<div *ngIf="lang === 'en'" class="tnc"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <p>
        <strong>PRIVACY NOTICE</strong>
    </p>
    <ol>
        <li>
            <strong>Introduction</strong>
            <p class="mt-2">
                This Privacy Notice is the policy of PT Indosat Tbk (“<strong>Indosat
                    Ooredoo Hutchison</strong>” or “<strong>IOH</strong>” or “<strong>We</strong>”
                or “<strong>Us</strong>” or “<strong>Our</strong>”) in handling information
                and data from users of IOH sites, applications, platform, product and
                services.
            </p>
            <p>
                We respect and protects the personal data (“<strong>Personal Data</strong>”)
                and information of users of sites, applications, platforms, products and
                other services from IOH (“<strong>User</strong>” or “<strong>You</strong>”
                or “<strong>Your</strong>”) in accordance with the applicable laws and
                regulation in Indonesia.
            </p>
            <p>
                This Privacy Notice sets out the basis and terms and conditions applicable
                to Personal Data processing activities, including but not limited to the
                acquisition, collection, processing, management, analysis, storage,
                rectification, updating, display, announcement, transmission, dissemination,
                disclosure, access provision, deletion and/or destruction of Personal Data
                that You provide to IOH or that is collected by IOH from You when You use
                Our products and services, visit, access, or use the online services of
                applications, platforms, websites, software tools, services and other
                functions provided by IOH, or visit, access or use other products and
                services offered or organized by IOH (hereinafter referred to as the
                “<strong>Services</strong>”).
            </p>
            <p>
                This Privacy Notice applies to all Users, prospective Users, as well as
                other parties who interact with IOH, insofar as relevant to the processing
                of Personal Data.
            </p>
            <p>
                If for a particular product/Service there is a separate or additional
                privacy policy, then such policy shall apply as a supplement to this Privacy
                Notice.
            </p>
        </li>
        <li>
            <strong>Definition</strong>
            <p class="mt-2">
                In this Privacy Notice, unless otherwise stated in a separate section, the
                following terms shall have the following meanings:
            </p>
            <ol type="a">
                <li>
                    “<strong>Personal Data</strong>”<strong></strong> means any data
                    concerning an identified or identifiable individual, either separately or in
                    combination with other information, whether directly or indirectly through
                    electronic and/or non-electronic systems.
                </li>
                <li>
                    “<strong>Specific Personal Data</strong>” means certain Personal
                    Data that requires greater protection, in accordance with the applicable
                    laws and regulations (including but not limited to health data, biometric
                    data, genetic data, criminal records, children’s data, certain financial
                    data, and/or other data as determined by regulation).
                </li>
                <li>
                    “<strong>Personal Data Processing</strong>” means one or a series
                    of actions performed upon Personal Data, including collection, recording,
                    storage, utilization, disclosure, and deletion.
                </li>
                <li>
                    “<strong>Personal Data Controller</strong>” means a party that
                    determines the purpose and control of the processing of Personal Data. IOH
                    acts as the Personal Data Controller for Personal Data processed under this
                    Privacy Notiice, unless expressly stated otherwise.
                </li>
                <li>
                    “<strong>Personal Data Processor</strong>” means a party that
                    processes Personal Data on behalf of and under the instructions of the
                    Personal Data Controller.
                </li>
                <li>
                    “<strong>User Data</strong>” means (i) Personal Data; and/or (ii)
                    other information which separately or when combined with other information
                    may directly or indirectly identify the User.
                </li>
            </ol>
        </li>
        <li class="mt-3">
            <strong>Legal Basis for Personal Data Processing</strong>
            <p class="mt-2">
                The data We collect about You and how We collect it may vary depending on
                the type of Our Services that You access or use, how You use Our products
                and Services, and how You interact with IOH even if You are not a User, or
                what We have obtained from third parties with permission to share it with
                Us.
            </p>
            <p>
                IOH processes Your Personal Data based on one or more of the following
                lawful bases for processing:
            </p>
            <ul type="circle">
                <li>
                    Fulfillment of a contract in the event that You are one of the parties
                    or to fulfill Your request prior to a contract being entered into, including
                    matters set out in the terms and conditions of subscription to IOH
                    products/Services;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Compliance with IOH’s legal obligations in accordance with the
                    applicable laws and regulations (including the need for investigation
                    processes, reporting to regulators, and fulfillment of other obligations
                    strictly regulated by statutory provisions);
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Fulfillment of IOH’s legitimate interests, taking into account the
                    purpose, necessity, and balance between IOH’s interests and Your rights
                    (including fraud prevention, network and Service security, compliance,
                    internal audit, and Service improvement);
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Valid and/or explicit consent from You, where required by the applicable
                    laws and regulations, for the processing of Personal Data carried out by
                    IOH;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Implementation of certain actions required or permitted by the
                    applicable laws and regulations, including in the context of public
                    interest, public services, or the exercise of IOH’s authority under the
                    applicable laws and regulations, for example certain obligations in the
                    context of network and telecommunications service security, to help detect
                    and prevent fraud, tax evasion and financial crimes.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Fulfillment of other legitimate interests by taking into account the
                    purpose, necessity, and balance between IOH’s interests and the rights of
                    the User.
                </li>
            </ul>
            <p class="mt-2">
                IOH is the Personal Data Controller for all Personal Data collected and
                processed, unless an additional privacy notice states otherwise.
            </p>
            <p>
                If You have questions about or require further information regarding the
                legal basis for Us to collect and use Your Personal Data for any specific
                processing activity, please contact Us using the contact details provided in
                the “<strong>Contact Us</strong>” section below.
            </p>
        </li>
        <li class="mt-3">
            <strong>How does IOH collect Your Personal Data?</strong>
            <p class="mt-2">
                The data We collect may vary depending on the type of Services, how You use
                the Services, and Your interaction with IOH.
            </p>
            <p>
                IOH generally collects and uses Your Personal Data when You:
            </p>
            <ul type="circle">
                <li>
                    purchase or use various products and Services
                </li>
            </ul>
            <ul type="circle">
                <li>
                    use Our network and/or Services
                </li>
            </ul>
            <ul type="circle">
                <li>
                    register for Services
                </li>
            </ul>
            <ul type="circle">
                <li>
                    submit User inquiries, register to obtain information or other services
                </li>
            </ul>
            <ul type="circle">
                <li>
                    respond to communications from Us (such as SMS, electronic mail (email),
                    questionnaires or surveys)
                </li>
            </ul>
            <ul type="circle">
                <li>
                    use IOH websites, such as submitting application forms, completing
                    survey forms, using online services. (If Your browser enables internet
                    cookies, this may facilitate IOH in tracking personal preferences, pages
                    visited, and others)
                </li>
            </ul>
            <ul type="circle">
                <li>
                    participate or interact on IOH application pages and IOH social media,
                    such as Facebook, Instagram, Twitter, LinkedIn, and others
                </li>
            </ul>
            <ul type="circle">
                <li>
                    participate in IOH promotional events, incentives, loyalty programs, or
                    prize draws
                </li>
            </ul>
            <ul type="circle">
                <li>
                    provide information through contact centers, retailers/dealers, sales
                    channels, or IOH affiliates
                </li>
            </ul>
            <ul type="circle">
                <li>
                    grant consent to another company to share information about You
                </li>
            </ul>
            <ul type="circle">
                <li>
                    where information about You is publicly available
                </li>
            </ul>
            <ul type="circle">
                <li>
                    where You are a customer of a company that We acquire or a company
                    involved in a corporate action of Ours
                </li>
            </ul>
            <ul type="circle">
                <li>
                    visit IOH locations equipped with CCTV or other security devices
                </li>
            </ul>
            <p class="mt-2">
                We may also obtain Personal Data from lawful third parties, for example:
            </p>
            <ul type="circle">
                <li>
                    business partners/service providers,
                </li>
            </ul>
            <ul type="circle">
                <li>
                    fraud prevention agencies,
                </li>
            </ul>
            <ul type="circle">
                <li>
                    credit references, collection agencies,
                </li>
            </ul>
            <ul type="circle">
                <li>
                    connected network providers,
                </li>
            </ul>
            <ul type="circle">
                <li>
                    other parties as long as there is a lawful basis for processing.
                </li>
            </ul>
            <p class="mt-2">
                IOH will only process Personal Data from third parties if such third parties
                represent that they have a lawful basis to share such data with IOH.
            </p>
            <p>
                IOH may use cookies, web beacons, or similar technologies to enhance user
                experience, analytics, security, as well as personalized marketing, in
                accordance with Your preferences and the applicable laws and regulations.
                Users may manage cookie preferences through browser/device settings.
            </p>
        </li>
        <li>
            <strong>What Personal Data of Yours is collected by IOH?</strong>
            <p class="mt-2">
                The types of Personal Data information that IOH collects include, but are
                not limited to:
            </p>
            <ul type="circle">
                <li>
                    Identity and contact information, including but not limited to: name,
                    address, electronic mail address (e-mail), telephone number that may be
                    required in connection with products, services and other purposes of data
                    processing based on this Privacy Notice.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Individual identification information (for example, but not limited to:
                    Identity Card (KTP/e-KTP), passport number, KITAS number, Taxpayer
                    Identification Number (NPWP), or Social Security Administering Body (BPJS)
                    data, Driver’s License (SIM), and date of birth).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Demographic information (for example, but not limited to: age range,
                    marital status, gender).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Photographs, such as photos that You submit for contests or competitions
                    to win prizes.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Product-specific information (for example, but not limited to:
                    preferences, closed user groups (CUGs), friends and family that You choose
                    to include in Your service package, credit limits).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Your traffic data as part of the provision of connectivity to You, for
                    example, but not limited to: numbers You call, time and duration of calls,
                    or how You use data.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Banking information (for example, but not limited to: direct debit and
                    related bill payment banking transactions).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Account and service information including but not limited to: call usage
                    data, account balance, transaction history, credit information, billing,
                    loyalty points.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Your contact with Us (for example, but not limited to: records or
                    recordings of calls You make to one of Our contact centers, live chat
                    features, emails or letters sent, or other records of any contact with Us).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Credential information – We will collect passwords, hints, and similar
                    security information used for authentication and access to accounts and
                    Services.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Information that We obtain from other sources (for example, but not
                    limited to: credit agencies, fraud prevention agencies, banking, and other
                    parties cooperating with Us. This includes demographic data, interest-based
                    data, and internet browsing behavior data, etc.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Specific Personal Data – In certain circumstances, IOH may process
                    Specific Personal Data if and to the extent permitted by the applicable laws
                    and regulations and subject to fulfilling specific requirements, including
                    the implementation of additional security measures. Special categories of
                    Personal Data include information revealing racial or ethnic origin,
                    political opinions, religious or philosophical beliefs, trade union
                    membership, data concerning health or data concerning a person’s sex life or
                    sexual orientation. For example, We may collect Your health data when
                    assessing Your situation to facilitate debt recovery activities, provide
                    additional support, or when providing Our communications in an accessible
                    format.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Type and version of operating system, hardware version, device settings,
                    type of software, battery and signal strength, screen resolution, device
                    identity (International Mobile Equipment Identity), manufacturer and model,
                    language, as well as type and version of internet browser. The name and
                    version of the Services (such as applications) that You use are also
                    collected by Us.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Geographical location information, such as location obtained from Your
                    IP address or GPS, Base Station, Bluetooth or Wi-Fi signals, satellites,
                    telecommunications towers and information about how You engage with and use
                    the Services, for example when You choose to enable location-enabled
                    services on the device You use to access such services.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Biometric data including but not limited to: fingerprints, voice, audio,
                    video, or certain physical characteristics for authentication/certain
                    features.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    We collect information from and about various kinds of technologies
                    where the Services are used. The type of information collected depends on
                    the technology, usage, and device as well as personal settings. Examples of
                    such technologies may include computers, telephones and tablets, as well as
                    devices that can be used interactively, technologies connected in homes or
                    other vehicles.
                </li>
            </ul>
        </li>
        <li>
            <strong>How does IOH use Your Personal Data? (Purpose of
                Personal Data Processing)</strong>
            <p class="mt-2">
                Your Personal Data may be collected, used, processed and/or managed by IOH
                for the following purposes:
            </p>
            <ol start="1" type="1">
                <li>
                    To provide information and Services along with benefits and changes that
                    occur in Our Services or those of parties cooperating with Us, to You:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        to provide Our products, services, and offers or those of third
                        parties cooperating with Us, which may be of interest to You;
                    </li>
                    <li>
                        to provide information and offers related to lifestyle products that
                        may be beneficial to Users; to inform You about benefits and changes to
                        features of Our Services;
                    </li>
                    <li>
                        to provide You with Our latest offers, campaigns, and promotions
                        (where You subscribe to such updates);
                    </li>
                    <li>
                        to provide information and offers of non-cellular products to Users,
                        such as Value-Added Services (VAS), new technology services such as
                        Artificial Intelligence (AI), financial technology, home broadband, Internet
                        of Things (IoT), and other digital/enterprise products;
                    </li>
                    <li>
                        to understand how You interact with the Services and provide You
                        with the best experience;
                    </li>
                    <li>
                        to provide You with the latest security, versions, features,
                        options, and controls related to Your system or device.
                    </li>
                </ul>
            </ol>
            <ol start="2" type="1">
                <li class="mt-2">
                    To communicate with You or the party whose data You provide through the
                    Services:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        to send You service messages regarding subscription registration or
                        Our account;
                    </li>
                    <li>
                        to use Your information to participate in User surveys or meetings;
                    </li>
                    <li>
                        to enable Us to send information to You via electronic mail (email),
                        telecommunications means (telephone calls or text messages) or social media
                        regarding products and services offered by selected third parties that We
                        believe may be of interest to You.
                    </li>
                </ul>
            </ol>
            <ol start="3" type="1">
                <li class="mt-2">
                    For Our business activities:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        to process payments, respond to User Service requests;
                    </li>
                    <li>
                        for research and studies in which You may voluntarily share Personal
                        Data to participate;
                    </li>
                    <li>
                        for business operations to conduct accounting, auditing, billing,
                        reconciliation and collection activities, including monitoring and
                        prevention of crime or fraud, protecting Our legal rights, and carrying out
                        obligations under an agreement/contract/arrangement.
                    </li>
                </ul>
            </ol>
            <ol start="4" type="1">
                <li class="mt-2">
                    For functionality, development and improvement of products and Services:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        to process data including but not limited to numbers that Users
                        call, how much data Users use, sites that Users visit, and when Users do so,
                        so that We can provide connectivity, measure Service usage levels, diagnose
                        server problems, and provide security features;
                    </li>
                    <li>
                        to utilize Users’ Personal Data related to Users’ habits in using
                        the Services to understand and categorize Users. The processing results will
                        enable segmentation into User profiles that may be used by IOH;
                    </li>
                    <li>
                        including for research, testing, modification, enhancement, and/or
                        development of Our Services, including but not limited through the use of
                        new technologies such as Artificial Intelligence (AI). This processing is
                        carried out to identify trends, patterns, and continuously improve the
                        quality of Services;
                    </li>
                    <li>
                        to utilize Users’ Personal Data regarding Users’ habits in using the
                        Services for further analysis and to carry out marketing processes that are
                        more aligned with User preferences;
                    </li>
                    <li>
                        to process Users’ Personal Data in the context of preventing fraud
                        and for security purposes.
                    </li>
                </ul>
            </ol>
            <ol start="5" type="1">
                <li class="mt-2">
                    For advertising and marketing of Services;
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        We may use the physical location of Your device, combined with
                        information about which advertisements You view and other information that
                        We collect, to enable Us to provide personalized content and to study the
                        effectiveness of advertising and marketing campaigns.
                    </li>
                    <li>
                        You may choose to allow or refuse the use or sharing of Your device
                        location by changing Your device settings, but if You choose to refuse such
                        use or sharing, We may not be able to provide You with certain personalized
                        IOH Services and content.
                    </li>
                </ul>
            </ol>
        </li>
        <li>
            <strong>How does IOH share and disclose Your Personal
                Data?</strong>
            <p class="mt-2">
                Where permitted and where there is a lawful basis for processing, We share
                information about You with, among others:
            </p>
            <ol start="1" type="a">
                <li>
                    Companies within the IOH business group including but not limited
                    to: affiliates and subsidiaries (“IOH Group”) to assist in providing
                    Services or conducting data processing and/or management for and on behalf
                    of IOH.
                </li>
                <li>
                    Partners, suppliers, agents involved for the purpose of Service
                    activation before the Services are accessed/used by Users.
                </li>
                <li>
                    Partners, suppliers, agents involved in the delivery and provision
                    of Services that You will or have accessed, ordered or used.
                </li>
                <li>
                    Companies engaged to perform Services for, or on behalf of IOH,
                    and/or the IOH Group.
                </li>
                <li>
                    Credit references, fraud prevention agencies or business assessment
                    agencies, or other credit assessment agencies, including banking
                    institutions.
                </li>
                <li>
                    Debt collection agents or other debt recovery organizations.
                </li>
                <li>
                    Law enforcement authorities, Government Ministries/Institutions,
                    regulatory organizations, courts, or other public authorities if We are
                    required to do so, or permitted by law.
                </li>
                <li>
                    Third parties or an entity where such disclosure is necessary and
                    regulated in accordance with the applicable laws and regulations.
                </li>
                <li>
                    Emergency services (if You make an emergency call), including an
                    estimate of Your location.
                </li>
                <li>
                    Third parties for joint promotion purposes. Such third parties
                    shall be responsible for their own compliance with applicable privacy laws.
                </li>
                <li>
                    Other third parties when You register for their services and used by
                    them for authentication and fraud prevention purposes through Us, including
                    financial institutions in the form of banks or non-bank institutions.
                </li>
                <li>
                    Third parties who advertise with Us to serve You (for example, but
                    not limited to: Facebook, Google, Twitter, Amazon), taking into account
                    privacy policies that may specifically apply to such services.
                </li>
            </ol>
        </li>
        <li class="mt-3">
            <strong>Law Enforcement, Fraud and Security</strong>
            <p class="mt-2">
                IOH may disclose Personal Data if necessary to:
            </p>
            <ul type="circle">
                <li>
                    protect IOH from fraud and misuse;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    defend IOH’s rights and assets;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    comply with obligations related to national security or requests from
                    competent authorities.
                </li>
            </ul>
            <p class="mt-2">
                Disclosure shall only be made based on a compliance evaluation and to the
                extent required/permitted by law.
            </p>
        </li>
        <li>
            <strong>Corporate Actions (Merger, Sale, or Bankruptcy)</strong>
            <p class="mt-2">
                In the event of a corporate action (including but not limited to: merger,
                acquisition, business transfer, restructuring or change of control), IOH has
                the right to transfer or assign Personal Data as part of such transaction or
                corporate action.
            </p>
            <p>
                IOH will ensure that such transfer is carried out in accordance with legal
                provisions and, where required, provide notification to Users.
            </p>
        </li>
        <li>
            <strong>Third parties cooperating with IOH</strong>
            <p class="mt-2">
                When You purchase IOH Services using a third party or IOH partner, We often
                need to exchange information with them as part of managing that relationship
                and Your account, for example, in order to identify Your order and to be
                able to pay them.
            </p>
            <p>
                If We have a contract with a service provider or contractor to provide
                services to Us or provide services on Our behalf, and they may have access
                to Your Personal Data, We do not permit them to use or disclose Your
                Personal Data except in connection with the provision of their services. <br />
                We collect and combine information to monitor the use of Your products and
                services, and those of Our other Users, and to help Us improve the quality
                of Our Services.
            </p>
        </li>
        <li>
            <strong>
                Third party products that You purchase through
                your myIM3, bima+, Indosat Digital Ecosystem (IDE) account or other IOH
                applications or platforms
            </strong>
            <p class="mt-2">
                When You purchase third party products or services through Your account on
                myIM3, bima+, IDE, or other IOH applications or platforms, You agree that
                IOH may provide certain Personal Data to parties cooperating with IOH to
                serve You or complete Your purchase through such applications or platforms.
            </p>
        </li>
        <li>
            <strong>Transfer of Personal Data Outside the
                Jurisdiction of the Republic of Indonesia</strong>
            <p class="mt-2">
                We may need to transfer Your information to other IOH Group companies or
                service providers in countries outside the jurisdiction of Indonesia. Such
                data transfers may occur if Our servers (i.e., where We store data) are
                based outside the jurisdiction of Indonesia, or if You use Our Services
                while visiting a country outside the jurisdiction of Indonesia.
            </p>
            <p>
                If IOH sends Your information outside the jurisdiction of Indonesia, We will
                ensure that Your information is properly protected. We will always ensure
                that the country where the third party is based has a level of Personal Data
                protection that is equivalent to or higher than that of Indonesia, or that
                the third party receiving Your Personal Data has adequate and binding
                Personal Data protection standards, or at least obtain Your consent to
                transfer Your Personal Data.
            </p>
        </li>
        <li>
            <strong>Personal Data Security</strong>
            <p class="mt-2">
                IOH implements reasonable technical and organizational security measures to
                protect Your Personal Data.
            </p>
            <p>
                IOH shall not be responsible for unauthorized access or loss of Personal
                Data that occurs due to circumstances beyond IOH’s reasonable control
                (including unlawful acts of third parties), provided that IOH has
                implemented appropriate security measures. <br />
            </p>
            <p>
                You are responsible for maintaining the security of Your Personal Data and
                account and not sharing them with others.
            </p>
        </li>
        <li>
            <strong>Automated Decision-Making and Profiling</strong>
            <p class="mt-2">
                Under certain conditions, IOH may carry out automated processing including
                profiling for fraud/crime prevention, service recommendations, and/or
                certain risk assessments.
            </p>
            <p>
                An automated decision is a decision concerning You that is made
                automatically based on the results of a computer decision (using software
                algorithms), without any human review where such decision has legal effect
                or other significant effect. We use automated analysis to make predictions
                such as the type of Services that You are interested in, or automated
                decision-making to prevent theft, fraud, or other crimes. Artificial
                intelligence solutions provided by IOH may result in automated data
                processing in various fields.
            </p>
            <p>
                If automated decision-making produces legal consequences or significantly
                affects You, IOH will implement necessary safeguards in accordance with
                regulations, including providing a review mechanism where required by the
                applicable laws and regulations.
            </p>
        </li>
        <li>
            <strong>Children</strong>
            <p class="mt-2">
                If You are under 18 years of age, You are required to obtain consent from
                Your parent or legal guardian in accordance with the applicable laws and
                regulations before using the Services.
            </p>
            <p>
                Personal Data that has been collected will be stored for the period
                necessary to fulfill the purposes mentioned above. We may retain Your
                Personal Data to provide the Services that You request, or for other
                important purposes, such as complying with Our legal obligations, resolving
                disputes, and enforcing Our policies. The retention period of Personal Data
                is based on applicable legal requirements. However, if there is no relevant
                law, Personal Data will be retained for the time necessary for business
                purposes.
            </p>
        </li>
        <li>
            <strong>Retention of Personal Data</strong>
            <p class="mt-2">
                Such Personal Data may be stored in hard copy form or electronic format.
            </p>
            <p>
                We may store Your data in data centers or warehouses managed either by Us or
                by service providers on Our behalf. All Our facilities, systems, and
                products have been equipped with the necessary security controls to ensure
                the protection of Personal Data.
            </p>
            <p>
                The retention period may vary significantly based on the type of information
                and how it is used and Our retention period is based on criteria including
                legally required retention periods, pending or potential litigation, Our
                intellectual property or ownership rights, requirements under
                agreements/contracts, operational directives or needs, and historical
                archiving. When Personal Data is deleted from Our systems, such data will be
                erased or destroyed using appropriate security protocols so that it cannot
                be reconstructed or read.
            </p>
            <p>
                Periode penyimpanan dapat sangat bervariasi berdasarkan jenis informasi dan
                cara penggunaannya dan periode penyimpanan Kami didasarkan pada kriteria
                yang mencakup periode penyimpanan yang dipersyaratkan secara hukum, proses
                pengadilan yang tertunda atau potensial, kekayaan intelektual atau hak
                kepemilikan Kami, persyaratan berdasarkan perjanjian/kontrak, arahan atau
                kebutuhan operasional, dan pengarsipan sejarah. Ketika Data Pribadi dihapus
                dari sistem Kami, data tersebut akan dihapus atau dihancurkan menggunakan
                protokol keamanan yang sesuai sehingga tidak dapat direkonstruksi atau
                dibaca.
            </p>
            <p>
                IOH will retain Personal Data in accordance with the principle of storage
                limitation, namely only for as long as necessary for the processing
                purposes, or as required by the applicable laws and regulations, after which
                it will be securely deleted or destroyed.
            </p>
        </li>
        <li>
            <strong>Your Rights as a Data Subject</strong>
            <p class="mt-2">
                <a name="_Hlk215660037">
                    Below We explain details on how You may exercise Your rights. If You have
                    questions or cannot find the answer, please contact Our customer service
                    team.
                </a>
            </p>
            <p>
                We reserve the right to refuse Your request to access, rectify and/or
                delete, in whole or in part, Your Personal Data under Our control, if
                permitted or required under the applicable Laws and Regulations,
                particularly if such request may affect matters including but not limited
                to:
            </p>
            <ol start="1" type="a">
                <li>
                    endangering Your safety, physical or mental health and/or that of
                    others; and/or
                </li>
                <li>
                    impacting the disclosure of another person’s Personal Data; and/or
                </li>
                <li>
                    conflicting with the interests of national defense and security;
                    and/or
                </li>
                <li>
                    the grounds for the request are not relevant to You and/or to the
                    Personal Data processing activities that We carry out.
                </li>
            </ol>
            <p class="mt-2">
                We may impose an administrative fee for each of Your requests in accordance
                with the applicable laws and regulations.
            </p>
            <p>
                <u>Right to Access Personal Data</u> <u></u>
            </p>
            <p>
                You have the right to request a copy of the Personal Data that IOH holds
                about You. To submit this request as an individual or an authorized third
                party, You may visit the “Contact Us” section which provides details on how
                to do so. Alternatively, You may contact Our customer service team.
            </p>
            <p>
                <u>Right to Data Portability</u> <u></u>
            </p>
            <p>
                You have the right to carry and transmit the Personal Data that You have
                provided to Us to another party or to another Personal Data controller,
                provided that the systems used can securely communicate in accordance with
                regulations, for example by enabling You to integrate Your data with
                third-party platforms cooperating with Us or allowing You to download Your
                monthly bill through Our official channels in a commonly used structure
                and/or format.
            </p>
            <p>
                <u>Right to Object to the Use of Personal Data</u> <u></u>
            </p>
            <p>
                You have the right, under certain circumstances, to object to IOH processing
                Your Personal Data. For further information or to exercise this right,
                please contact IOH customer service. If this relates to an automated
                decision made about You (meaning without human involvement), You may still
                notify Us and We will review Your request first.
            </p>
            <p>
                <u>Right to Withdraw Consent to the Use of Personal Data</u> <u></u>
            </p>
            <p>
                You have the right, under certain circumstances, to withdraw consent for the
                processing of Personal Data that You have previously provided by contacting
                IOH customer service.
            </p>
            <p>
                However, the unavailability of Your Personal Data may result in Us being
                unable to verify and process Your purchase, which may result in You being
                unable to use certain Services.
            </p>
            <p>
                If You still wish to use Our Services, then You may only withdraw part of
                the consent for the use of Personal Data that is not used to provide the
                Services to You.
            </p>
            <p>
                Withdrawal of consent does not affect the validity of the processing of Your
                Personal Data that has been carried out prior to such withdrawal.
            </p>
            <p>
                <u>Right to Restrict the Use of Your Data</u> <u></u>
            </p>
            <p>
                If You believe that the data We hold about You is inaccurate, or You believe
                that We should not process Your Personal Data, please contact Our customer
                service team to discuss Your rights. Under certain circumstances, You have
                the right to request that We restrict processing.
            </p>
            <p>
                <u>Right to Erase Your Data</u> <u></u>
            </p>
            <p>
                IOH strives to only process and retain Your data for as long as We need it.
                Under certain circumstances You have the right to request that We erase Your
                Personal Data that We hold. If You believe that We are retaining Your data
                longer than We need, it is advisable to first check whether Your
                subscription contract with IOH has ended, which You can do through the
                customer service team. If Your contract with IOH has ended, We may still
                have lawful grounds to process Your Personal Data. For further information
                regarding retention periods, please refer to the section of this privacy
                notice entitled Retention.
            </p>
        </li>
        <li>
            <strong>Marketing Opt-Out:</strong>
            <p class="mt-2">
                If You no longer wish to receive marketing information from IOH, You may opt
                out at any time. If You have previously chosen to receive personalized
                content based on how and where You use Our network, You may also opt out at
                any time.
            </p>
            <p>
                The method to opt out of marketing activities is by contacting Our customer
                service team and through other mechanisms that We provide from time to time.
            </p>
            <p>
                If You choose to opt out, You may still receive service-related messages.
            </p>
            <p>
                Please note that You may still receive promotional messages for up to 7 x 24
                hours after opting out. This may be due to the time required for Us to
                update Our database.
            </p>
            <p>
                You may also have received marketing information from IOH even though You
                are not a User or have never interacted with Us. This is the result of
                third-party lists that may be obtained by IOH from time to time, which state
                that You have given permission to be contacted by certain other parties.
            </p>
            <p>
                If You have registered with Us to opt out of IOH marketing information, You
                should not receive such communications. If You continue to receive them, We
                request that You immediately notify Us by contacting Our customer service
                team. This will only stop marketing information from Us and will not stop
                third parties from sharing Your data unless You contact them directly.
            </p>
        </li>
        <li>
            <strong>How to Submit a Complaint</strong>
            <p class="mt-2">
                If You wish to contact Us regarding the exercise of Your rights or to submit
                a complaint about how We use Your Personal Data, You may contact IOH
                customer service through official channels.
            </p>
            <p>
                IOH will follow up on Your request within a reasonable period in accordance
                with the applicable laws and regulations.
            </p>
        </li>
        <li>
            <strong>Personal Data Protection Incident</strong>
            <p class="mt-2">
                In the event of a Personal Data protection incident, IOH will handle the
                incident in accordance with internal procedures and the applicable laws and
                regulations, including providing notification to the required parties.
            </p>
        </li>
        <li>
            <strong>Governing Law</strong>
            <p class="mt-2">
                This Privacy Notice is governed by the laws of the Republic of Indonesia.
            </p>
            <p>
                This Privacy Notice is made in the Indonesian language and English. In the
                event of any difference or inconsistency between the Indonesian language
                version and the English version, the Indonesian language version shall
                prevail and the English version shall be deemed amended to conform with the
                Indonesian language version.
            </p>
        </li>
        <li>
            <strong>Changes to the Privacy Notice</strong>
            <p class="mt-2">
                IOH may amend or update this Privacy Notice at any time by publishing it on
                the relevant websites, applications and Services.
            </p>
            <p>
                Users are expected to carefully read and periodically review this Privacy
                Notice page to be aware of any changes made by IOH to this Privacy Notice.
                By accessing and using IOH websites, applications, or other services, Users
                agree to accept the changes to the Privacy Notice.
            </p>
        </li>
        <li>
            <strong>Acknowledgment and Consent</strong>
            <ol start="1" type="a">
                <li>
                    You warrant that all data provided in written form or in any other
                    form for the use of the Services is truly Yours and does not originate from
                    any third party without a lawful basis, therefore any matters arising in
                    connection with the provision and accuracy of such data shall be Your sole
                    responsibility.
                </li>
                <li>
                    By agreeing to this Privacy Notice, You acknowledge that You have
                    read, understood and agreed to this Privacy Notice. In particular, You agree
                    and grant Us permission to carry out the collection, processing, analysis,
                    storage, disclosure, correction, and deletion of Your Personal Data in
                    accordance with this Privacy Notice.
                </li>
                <li>
                    If You are below the minimum age requirement or fall within the
                    category of children in accordance with the applicable laws and regulations,
                    then consent for the processing of Your Personal Data must be provided by
                    Your parent (father or mother) or guardian in accordance with the applicable
                    regulations.
                </li>
            </ol>
        </li>
    </ol>


    <!-- <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        PRIVACY POLICY</h1>
    <ul>
        <li>This <strong>Privacy</strong> Policy is the policy of PT Indosat Tbk (&ldquo;<strong>Indosat Ooredoo
                Hutchison</strong>&rdquo; or &ldquo;<strong>IOH</strong>&rdquo; or &ldquo;<strong>We</strong>&rdquo; or
            &ldquo;<strong>Us</strong>&rdquo; or &ldquo;<strong>Our</strong>&rdquo;) in handling
            <strong>information</strong> and data from users of IOH sites, applications, platform, product and services.
            IOH
            respects and <strong>protects the personal data</strong> (&ldquo;<strong>Personal Data</strong>&rdquo;) and
            information of users of sites, applications, platforms, products and <strong>other services</strong> from
            IOH
            (&ldquo;<strong>User</strong>&rdquo; <strong>or</strong> &ldquo;<strong>You</strong>&rdquo; or
            &ldquo;<strong>Your</strong>&rdquo;).
        </li>
    </ul>
    <p>This Privacy Policy sets out the basis and terms and conditions that apply to the acquisition, collection,
        processing, analysis, storage, repair, updating, display, announcement, delivery, dissemination, disclosure,
        and/or
        opening of access, deletion and destruction associated with the Persona Data provided by Users to IOH or
        collected
        by IOH from Users either when Users use any of Our products and services, visit, access or use online services
        applications, platforms, websites, software tools, services and other functions provided by IOH, or visit,
        access or
        use other authorised products and services offered or organised by IOH (hereinafter collectively referred to as
        "Services"). User Data is the User's personal data and other information that when combined with other
        information
        can identify the User.</p>
    <p>This Privacy Policy applies to all Personal Data that We collect, obtain or use when You use any of Our products
        and
        Services, unless a separate or additional privacy policy is offered for those products and services. We advise
        You
        to read this Privacy Policy together with our product/Service Terms and Conditions as they may contain product
        or
        service specific information about how We process Your Personal Data.</p>
    <p>This Privacy Policy applies to all Services, and to Users, all Service User and prospective User of IOH.</p>
    <p><strong>How does IOH collect your personal data?</strong></p>
    <p>The data We collect about You and how We collect it may vary depending on the types of Our Services you access or
        use, how you use Our products and services, and how You interact with IOH even if You are not an IOH customer,
        or
        what we have obtained from third parties with permission to share them with Us.<br /> IOH will process Your
        Personal
        Data based on:</p>
    <ul>
        <li>Fulfilment of agreement obligations in the event that You are a party or fulfil your request when
            entering
            into an agreement.</li>
    </ul>
    <ul>
        <li>Fulfilment of other legitimate interests by taking into account the IOH&rsquo;s and Your goals, needs
            and
            balance of interests. For example, the interests of avoiding fraud, maintaining the security of our
            network
            and services, direct marketing, and improving Our Services. Whenever IOH uses these legal grounds to
            process
            your data, we assess our business interests to ensure those interests do not override Your rights.</li>
    </ul>
    <ul>
        <li>Fulfilment of legal obligations from IOH in accordance with the provisions of laws and regulations, for
            example the need for an investigation process, reporting to regulators, and fulfilment of other
            obligations
            which are strictly regulated by the provisions of laws and regulations.</li>
    </ul>
    <ul>
        <li>Implementation of tasks in the context of public interest, public service, or implementation of IOH
            authority based on the laws and regulations. For example, to help detect and prevent fraud, tax evasion
            and
            financial crime, etc.</li>
    </ul>
    <ul>
        <li>Explicit valid consent from You to IOH&rsquo;s processing of Personal Data. Your valid consent can be in
            the
            form of a mandatory consent and optional consent. The Mandatory consent is processing related to billing
            and
            routing so You can make calls, SMS, and data and internet services on your mobile, We process things
            like
            the number you call, how much data You use, sites You visit and when You do it so we can provide
            connectivity. This is necessary to &nbsp;allows Us to bill You, based on Your usage We also need to
            check
            the credit limit of postpaid or remaining prepaid credit when You apply for a product or service.</li>
    </ul>
    <ul>
        <li>Fulfilment of other legitimate interests by taking into account the goals, needs and balance of
            IOH&rsquo;s
            interests and User rights.&nbsp;</li>
    </ul>
    <p>IOH collects and uses Your personal information with Your knowledge and agreement and usually when You:</p>
    <ul>
        <li>Purchase or use IOH&rsquo;s Services.</li>
        <li>Use our network or Our Services.</li>
        <li>Sign up for Our Services.</li>
        <li>Ask customer questions, sign up for information or other services.</li>
        <li>Respond to communications from Us (such as SMS, email, questionnaires or surveys).</li>
        <li>Interact with the IOH website, such as submitting application forms, filling out survey forms, using
            online
            services. (If your browser has Internet cookies enabled, it may facilitate the IOH's tracking of
            personal
            preferences, pages visited, etc.).</li>
        <li>Participate on IOH app pages and IOH social media, such as Facebook, Instagram, Twitter, LinkedIn and
            others.</li>
        <li>Participate in IOH promotional events, incentives, loyalty programs or prize draws.</li>
        <li>You have given an agreement for other companies to share information about You.</li>
        <li>Where information about You is publicly available.</li>
        <li>Where You are a customer of a company We acquire or a company that is involved in a corporate action.
        </li>
        <li>Provide information through IOH&rsquo;s customer call centres, dealers and sales channels or through
            affiliates or other business dealings with IOH where You have agreed to provide Your Personal Data.</li>
    </ul>
    <p>We also collect information from certain organizations, where appropriate and to the extent we have a legal basis
        or
        interest to do so. These include fraud prevention agencies, business directories, credit check
        reference/checking
        agencies, bill counting agencies, and connected network providers.</p>
    <p>We may also collect information about you through CCTV devices installed when you visit Our premises or through
        other
        security cameras as part of Our security and crime prevention measures.</p>
    <p><strong>What is your Personal Data collected by IOH?</strong></p>
    <p>The types of Personal Data information that IOH collects include, but are not limited to:</p>
    <ul>
        <li>Contact information (for example, among other things: name, address, e-mail address and telephone
            number)
            which is basically needed to contact Users in connection with products, services and other purposes of
            data
            processing based on this Privacy Policy.</li>
        <li>Individual identification information (for example, among others: Identity Card (<em>KTP/e-KTP</em>),
            passport number, Taxpayer Identification Number (<em>NPWP</em>), or Social Security Administration
            Agency
            (<em>BPJS</em>) data, driving license (SIM), and date of birth).</li>
        <li>Demographic information (for example, among others: age range, marital status, gender).</li>
        <li>Photos, such as those you submit for a contest or competition win prizes.</li>
        <li>Product-specific information (e.g., among others: preferences, closed user groups (CUGs), friends and
            family
            You choose to include in Your service plan, credit limit).</li>
        <li>Your traffic data as part of providing connectivity to You, for example, among others: the number you
            call,
            the time and duration of the call, or how You use the data.</li>
        <li>Banking information (for example, among others: direct debit and related bill payment banking
            transactions).
        </li>
        <li>Service account information (for example, among others: call usage data, account balance, transaction
            history, credit information, billing, loyalty points).</li>
        <li>Your contact with uUs (for example, among others: records or records of calls You make to one of our
            contact
            centres, live chat features, emails or letters sent, or other records of any contact with Us).</li>
        <li>Credential information &ndash; We will collect passwords, hints and similar security information used
            for
            authentication and access to accounts and Services.</li>
        <li>Information We obtain from other sources, (for example, among others: credit agencies, fraud prevention
            agencies, banks, and others We work with. This includes demographic data, interest-based data, and
            internet
            browsing behaviour, etc.</li>
        <li>In some cases (if and to the extent permitted by applicable law), special categories of Personal Data or
            Personal Data relate to criminal convictions and offenses. A special category of Personal Data includes
            information that reveals racial or ethnic origin, political opinions, religious or philosophical
            beliefs,
            trade union membership, data related to health or data related to a person&rsquo;s sex life or sexual
            orientation. For example, We may collect Your health data when assessing Your situation to facilitate
            debt
            recovery activities, provide additional support, or when providing Our communications in an accessible
            format.</li>
        <li>Operating system type and version, hardware version, device settings, software type, battery and signal
            strength, screen resolution, device identity (International Mobile Equipment Identity), manufacturer and
            model, language, and internet browser type and version. We also collect the name and version of the
            Service
            (such as applications) You use.</li>
        <li>Geographic location information, such as the location derived from your IP or GPS address, Base Station,
            Bluetooth or Wi-Fi signals, satellites, telecommunication towers and information about how You engage
            with
            and use the Service, for example when You choose to activate the service location-enabled on the device
            You
            use to access the service.</li>
        <li>Some of Our Services may allow You to use biometric information to perform identification or
            authentication
            or to take advantage of certain features. Biometric data can include fingerprints, voice, audio, video
            or
            similar unique physical characteristics.</li>
        <li>We collect information from and about various technologies in which the Services are used. The type of
            information collected depends on the technology, usage, and device and personal settings. Examples of
            this
            technology may include computers, phones and tablets, as well as interactive wearable devices, connected
            technologies in homes or other vehicles.</li>
    </ul>
    <p><strong>How does IOH use your Personal Data?</strong></p>
    <p>Your Personal Data may be collected, used and/or processed by Us for, among others, the following purposes:</p>
    <ol>
        <li>To provide information Services, including benefits and changes that occur within Our Services or with
            parties
            collaborating with Us, to You:</li>
    </ol>
    <ul>
        <ul>
            <li>to provide products, services and offers from Us or third parties We work with that may be of
                interest
                to you</li>
            <li>providing information and offers related to lifestyle products that may be beneficial to User.</li>
            <li>to inform You about benefits and changes to the features of Services.</li>
            <li>to provide You with Our latest offers, campaigns and promotions (where You subscribe to such
                updates).
            </li>
            <li>providing information and offers of non-cellular products to Users, such as Value-Added Services
                (VAS),
                financial technology, home broadband, Internet of Things (IoT), and other digital/enterprise
                products.
            </li>
            <li>to understand how You interact with the Services and provide you with the best possible experience.
            </li>
            <li>to provide You with the latest security, versions, features, options and controls related to Your
                system
                or device.</li>
        </ul>
    </ul>
    <ol start="2">
        <li>To communicate with You or the party whose data You provide through the Service:
            <ul>
                <li>to send you service messages about Our subscription or account registration.</li>
                <li>to use Your information to participate in Our customer surveys or meetings.</li>
                <li>to enable Us to send information to You by electronic mail (e-mail), telecommunication means (phone
                    calls or text messages) or social media about products and services offered by selected third
                    parties
                    that We think may be of interest to You.</li>
            </ul>
        </li>
        <li>For Uur business activities:
            <ul>
                <li>to process payments, respond to User service requests.</li>
                <li>for research and studies that may voluntarily share Personal Data to participate.</li>
                <li>for business operations performing accounting, auditing, billing, reconciliation and collection
                    activities, including crime or fraud monitoring and prevention, protecting our legal rights, and
                    performing obligations based on an agreement/ contracts/agreement.</li>
            </ul>
        </li>
        <li>For functionality, development and improvement of products and Services
            <ul>
                <li>to provide network connectivity, measure Service usage levels, diagnose server problems, and provide
                    security features.</li>
                <li>utilizing Users' Personal Data related to Your usage habits within the Service to understand and
                    categorize Users. The processed results will enable segmentation within user profiles that can be
                    utilized by IOH.</li>
                <li>using Personal Data for research purposes, to test, modify, improve or develop Our products,
                    Services
                    and new technologies and to identify trends.</li>
                <li>Leveraging Users' Personal Data regarding Your usage habits within the Service for further analysis
                    and
                    to execute marketing processes that align more closely with User preferences.</li>
                <li>processing Users' Personal Data in the context of fraud prevention and for security purposes.</li>
            </ul>
        </li>
        <li>For advertising and marketing of Services
            <ul>
                <li>We may use the physical location of Your device, combined with information about what advertisements
                    You
                    saw and other information We collect, to enable Us to provide personalized content and to study the
                    effectiveness of advertising and marketing campaigns.</li>
                <li>You can choose to allow or deny the use or sharing of Your device location by changing Your device
                    settings, but if You choose to object to such use or sharing, We may not be able to provide You with
                    certain personalized IOH Services and content.</li>
            </ul>
        </li>
    </ol>
    <p><strong>How does IOH share your Personal Data?</strong></p>
    <p>Where it is possible and has a legal processing basis, We share information about you with, among others:</p>
    <ol>
        <li>Companies in the IOH group include affiliates and subsidiaries ("<strong>IOH Group</strong>") to help
            provide services or perform data processing for and on behalf of IOH.</li>
        <li>Partners, suppliers, agents involved in for the purposes of activating the Service before the Service is
            accessed/used by the User.</li>
        <li>Partners, suppliers, agents involved in the delivery of products and the provision of services that you
            will
            or have accessed, ordered or used.</li>
        <li>Companies engaged to perform services for, or on behalf of, IOH, and/or the IOH Group.</li>
        <li>Credit reference, fraud prevention or business assessment agencies, or other credit rating agencies,
            including banking.</li>
        <li>Debt collection agencies or other debt recovery organizations.</li>
        <li>Law enforcement officials, Government Ministries/Agencies, regulatory organizations, courts or other
            public
            authorities when We have to, or are permitted by law.</li>
        <li>A third party or an entity where such disclosure is required and regulated in accordance with applicable
            laws and regulations.</li>
        <li>Emergency services (if you made an emergency call), including your approximate location.</li>
        <li>Third parties for joint promotion purposes. The third part will be responsible for their own compliance
            with
            applicable privacy laws.</li>
        <li>Other third parties when You sign up for their services and used by them for authentication and fraud
            prevention purposes through Us, including financial institutions in the form of banks or non-banks.</li>
        <li>Third parties who advertise with Us to serve You (for example, among others: Facebook, Google, Twitter,
            Amazon), taking into account the privacy policies that may apply specifically to those services.</li>
    </ol>
    <p><strong>Fraud management and law enforcement</strong></p>
    <p>We will release information where reasonable for the purposes of protecting Us from fraud, defending Our rights
        or
        property, or to protect the interests of User.<br /> We may also need to disclose Your information to comply
        with
        obligations with respect to national defence and security interests, as well as our legal obligations to respond
        to
        the legal demands of authorities. Your Personal Data will only be provided if We in good faith believe that We
        are
        obligated to do so in accordance with the law and based on a thorough evaluation of all legal requirements.</p>
    <p><strong>In the Event of a Corporate Action (a Merger, Sale or Bankruptcy)Third parties that work with
            IOH</strong>
    </p>
    <p>When You purchase IOH Services using a third party or partner, We often need to exchange information with them as
        part of managing that relationship and Your account, for example, in order to identify Your order and be able to
        pay
        for them.</p>
    <p><br /> If We have contracts with service providers or contractors to provide Us with services or deliver services
        on
        Our behalf, and they may have access to your Personal Data, We do not allow them to use or disclose Your
        personal
        information except in connection with providing their services.</p>
    <p><br /> We collect and combine information to monitor Your use of Our products and services, and those of Our
        other
        User, and to help Us improve the quality of Our Services.</p>
    <p><strong>Third party products that you purchase through myIM3,bima+ Indosat Digital Ecosystem (IDE) or other IOH
            applications or platforms</strong></p>
    <p>When You purchase third party products or services through Your account in myIM3, bima+, IDE, or application or
        other
        IOH platform, You agree that IOH may provide certain Personal Data to that parties who work with the IOH to
        serve
        You to complete your purchase through the application or platform.</p>
    <p><strong>Transfer of Personal Data outside the Legal Territory of the Republic of Indonesia</strong></p>
    <p>We may need to transfer Your information to other IOH Group companies or service providers in countries outside
        the
        jurisdiction of Indonesia. This kind of data transfer may occur if Our servers (i.e. where We store data) are
        based
        outside the jurisdiction of Indonesia, or if You use our services and products while visiting a country outside
        the
        jurisdiction of Indonesia.<br /> If IOH transfers Your information outside the jurisdiction of Indonesia, We
        will
        ensure that your information is properly protected. We will always ensure that the country where the third party
        is
        based has a level of protection of Personal Data that is equivalent to or higher than Indonesia, or the third
        party
        who will receive your Personal Data has adequate and binding standards of protection for Personal Data, or at
        least
        obtains approval from You to transfer Your Personal Data.</p>
    <p><strong>Protection of Your Personal Data</strong></p>
    <p>We have a dedicated security team that constantly reviews and improves Our measures to protect Your Personal Data
        from unauthorized access, loss, disclosure or accidental destruction.<br /> </p>
    <p>We are not responsible for unauthorized access or loss of personal information that is beyond Our control. We
        will
        never ask for Your Personal Data or account credentials. You are responsible for keeping Your Personal Data and
        account information secure and not sharing it with others.</p>
    <p><strong>Automated Decision-Making</strong></p>
    <p>In some cases, our use of Your Personal Data may result in automated decision-making (including profiling) that
        legally affects you or that significantly affects You.</p>
    <p>An automated decision is a decision about You that is made automatically based on a computer decision (using
        software
        algorithms), without human review where the decision has legal or other significant influence. We use automated
        analysis to make predictions such as the types of Services You may be interested in, or automated
        decision-making to
        prevent theft, fraud or other crimes. The artificial intelligence solutions provided by IOH can lead to the
        automatic processing of data in various fields. If Our automated decision-making has a legal effect or
        significantly
        affects You, We will implement measures to protect Your rights, freedoms and interests, by conducting a privacy
        impact assessment to identify appropriate measures to protect those rights, &nbsp;or obtain Your explicit
        agreement
        as required by applicable law.</p>
    <p><strong>Legal Basis for Use of IOH</strong></p>
    <p>Our legal basis for collecting and using Personal Data will depend on the Personal Data concerned and the
        specific
        context in which the information is collected.</p>
    <p>We need personal information to fulfil a contract with You, where We have a legal obligation to do so or where it
        is
        in Our legitimate interests to carry out the processing (such as processing for administrative purposes, direct
        marketing, product development or development, fraud or criminal action prevention and support information
        security)
        and not to the exclusion of Your data protection interests or fundamental rights and freedoms.</p>
    <p>If We ask You to provide Personal Data to comply with legal requirements or to fulfil a contract with You, We
        will
        explain this at the time of collection of the information. We will also tell You whether the requirements for
        the
        information are mandatory and explain any consequences to You if you do not provide the information.<br />
        Similarly, if We collect and use Your personal information based on Our legitimate interests (or that of any
        third
        party), We will take reasonable steps to provide clear notice and describe Our legitimate interests.</p>
    <p>IOH is the data controller of all Personal Data collected, unless an additional privacy notice says otherwise.
    </p>
    <p>If You have questions about or need further information regarding the legal basis for Us to collect and use Your
        personal information for any particular processing activity, please contact Us using the contact details
        provided in
        the &ldquo;<strong>Contact Us</strong>&rdquo; section below.</p>
    <p><strong>Information about children </strong></p>
    <p>If You are under the age of 18, then You are obliged to obtain the valid consent of Your parent or legal guardian
        in
        accordance with applicable regulations before using Our network, and/or Services.</p>
    <p><strong>Storage (Retention) </strong></p>
    <p>Personal Data that has been collected and will be stored for the required period of time to fulfil the purposes
        stated above. We may retain Your Personal Data to provide the Services You have requested, or for other
        important
        purposes, such as complying with Our legal obligations, resolving disputes and implementing Our policies. The
        period
        of retention of personal data is based on applicable legal requirements. However, in the absence of relevant
        laws,
        Personal Data will be retained for as long as necessary for business purposes.</p>
    <p>This Personal Data may be stored in hard copy, or electronic format.</p>
    <p>We may store Your data in data centres or warehouses managed either by Us or by service providers on Our behalf.
        All
        of Our facilities, systems and products are equipped with the necessary security controls to ensure the
        protection
        of Personal Data.</p>
    <p>Retention periods can vary significantly based on the type of information and how it is used and Our retention
        periods are based on criteria that include legally required retention periods, pending or potential litigation,
        Our
        intellectual property or proprietary rights, requirements under agreements/contracts, operational directives or
        needs, and historical archiving. When Personal Datais deleted from Our system, it will be deleted or destroyed
        using
        appropriate security protocols so that it cannot be reconstructed or read.</p>
    <p><strong>Your rights</strong></p>
    <p>Below We explain the details of how You can exercise your rights. If You have any question or cannot find the
        answer,
        please contact our customer service team.<br /> We have the right to refuse Your request to access, correct
        and/or
        delete, part or all of Your Personal Data that We control, if permitted or required based on the applicable laws
        and
        regulations, especially if the request may have an impact on matters such as but not limited to :</p>
    <ol>
        <li>endanger Your safety, physical or mental health and/or others; and/or</li>
        <li>there is an impact of disclosing other people&rsquo;s Personal Data; and/or</li>
        <li>contrary to the interests of state defence and security and/or</li>
        <li>the reason for the request is irrelevant to You and/or the Personal Data processing activities We carry out.
        </li>
    </ol>
    <p>We may be able to charge administrative fees for each of Your requests in accordance with applicable laws and
        regulations.</p>
    <p><strong>Right to access Personal Data</strong></p>
    <p>You have the right to request a copy of the Personal Data IOH holds about You. To make this request as an
        individual
        or an authorized third party, you may visit the &ldquo;<strong>Contact Us</strong>&rdquo; section which provides
        details on how to do so. Or, you can contact Our customer service team.</p>
    <p><strong>Right to correct Personal Data</strong></p>
    <p>You have the right to correct the information held about You if it is inaccurate. If the information We hold
        about
        You is inaccurate or needs updating, You can contact our customer service team. You are encouraged to be active
        in
        ensuring the accuracy and updating of Your data from time to time.</p>
    <p>&nbsp;</p>
    <p><strong>Right to data portability</strong></p>
    <p>You have the right to carry and send your Personal Data which You provide Us to other parties or to other
        Personal
        Data controllers, as long as the systems used can communicate with each other safely according to regulations,
        for
        example by allowing you to integrate Your data with third party platforms that We work with or enable You to
        download your monthly bill through our official channels with the structure and/or format that is commonly used.
    </p>
    <p><strong>Right to object to the use of Personal Data</strong></p>
    <p>You have the right, in certain circumstances, to object to IOH processing Your Personal Data. For more
        information or
        to exercise this right, please contact IOH customer service. If this relates to an automated decision being made
        on
        Your behalf (meaning without human involvement), You can still inform Us and We will first review Your request.
    </p>
    <p><strong>Right to withdraw agreement to the use of Personal Data</strong></p>
    <p>You have the right, in certain circumstances, to withdraw the consent to the processing of Personal Data that You
        previously provided by contacting IOH customer service.<br /> However, the unavailability of Your Personal Data
        causes us to be unable to verify and process Your purchases, so You may be unable to use certain Services.</p>
    <p>If You still want to use Our Services, you can only withdraw partial consent to the use of Personal Data that is
        not
        used to provide services to You.</p>
    <p><strong>To Opt-Out of Marketing Information:</strong></p>
    <ol>
        <li>If You no longer wish to receive marketing information from IOH, You may opt-out at any time. If You
            previously
            opted to receive personalized content based on how and where You use Our network, You may also opt out at
            any
            time.</li>
        <li>The way to opt-out of marketing activities is by contacting Our customer service team and other mechanisms
            that
            We provide from time to time.</li>
        <li>If You choose to opt-out, You may still receive service-related messages.</li>
    </ol>
    <p>Please note that You may still receive offer messages for up to 7x 24 hours after opting out. This can be caused
        by
        the time it takes for Us to update our database.</p>
    <ol>
        <li>You may also have received marketing information from IOH even if You are not User or have never been in
            contact
            with Us. This is the result of a list of third parties that IOH may obtain from time to time, stating that
            You
            have given your consent to be contacted by certain other parties.</li>
        <li>If You have registered with us to opt-out of IOH marketing information, You may not receive such
            communications.
            If You are still receiving it, We ask that You inform Us immediately by contacting Our customer service
            team.
            This will only stop marketing information from Us and will not stop third parties from sharing Your data
            unless
            You contact them directly.</li>
    </ol>
    <p><strong>How to make a complaint</strong></p>
    <p>If You want to contact Us about any of Your rights or have a complaint about how We use your information, please
        contact Our customer service team &ndash; We will do our best to help You.</p>
    <p><strong>Right to limit the use of your data</strong></p>
    <p>If You feel the data We hold about You is inaccurate, or You believe We should not be processing Your Personal
        Data,
        please contact Our customer service team to discuss Your rights. In certain circumstances, You have the right to
        ask
        Us to restrict processing.</p>
    <p><strong>Right to delete your data</strong></p>
    <p>IOH endeavours to only process and store Your data for as long as We need it. In certain circumstances You have
        the
        right to ask Us to delete your Personal Data that We hold. If You feel that We are holding Your data for longer
        than
        We need, it is worth first checking whether Your subscription contract with IOH has ended, which You can do
        through
        the customer service team. If Your contract with IOH has ended, We may still have a legitimate reason to process
        Your personal data. For more information on retention periods, see the section in this privacy policy entitled
        Retention.</p>
    <p><strong>Applicable law</strong></p>
    <p>This Privacy Policy is subject to the laws of the Republic of Indonesia.<br /> This Privacy Policy is prepared in
        both Indonesian language and English. In the event of any discrepancy or conflict between the Indonesian
        language
        and English versions, the Indonesian language version shall prevail and the English version shall be deemed to
        have
        been amended to conform to the Indonesia language version.</p>
    <p>&nbsp;</p>
    <p><strong>Privacy Policy Changes</strong></p>
    <p>IOH may change or update this Privacy Policy at any time by publishing it on related sites, applications and
        Services. Users are expected to read carefully and check this Privacy Policy page from time to time to find out
        any
        changes made by IOH to this Privacy Policy. By accessing and using IOH sites, applications or other services,
        Users
        agree to agree to changes to the Privacy Policy.</p>
    <p><strong>Acknowledgment and Agreement &nbsp;</strong></p>
    <ol>
        <li>You guarantee that all data provided in written form or other forms to use this Service is truly Yours and
            not
            obtained from Personal Data belonging to third parties without legal permission, so that all matters arising
            in
            connection with the provision and correctness of such data are Your full responsibility.</li>
        <li>By agreeing to this Privacy Policy, You acknowledge that You have read and understood this Privacy Policy
            and
            agree to all its terms. In particular, You agree and give Us permission to collect, process, analyse, store,
            disclose, correct and delete your Personal Data in accordance with this Privacy Policy.</li>
        <li>If You are under the minimum age requirement or fall under the category of children in accordance with the
            provisions of the applicable laws and regulations, then consent to the processing of Your Personal Data must
            be
            given by Your parents (father or mother) or guardian in accordance with the applicable regulations.</li>
    </ol>
    <p>Last update: &nbsp;xx February 2024</p>
    <p>&nbsp;</p>
    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Terms and Conditions Indosat Ooredoo Hutchison Prepaid IM3
    </h1>
    <p>The following are terms and conditions to subscribe for Indosat Ooredoo Hutchison prepaid telecommunication
        service,
        which must be obeyed by customer</p>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq0"><strong>Preamble</strong></a></p>
    <ol>
        <li>"Indosat Ooredoo Hutchison" is PT Indosat Tbk.</li>
        <li>"Customer" is an individual using the Prepaid Service</li>
        <li>"Prepaid SIM Card" is the Prepaid Subscriber Identity Module (SIM) card issued by Indosat Ooredoo Hutchison
            for
            the Customer to be used in a cellular phone or other compatible gadgets to enable the Customer to access
            Prepaid
            Services</li>
        <li>"Prepaid Service" is the prepaid telecommunication service provided by Indosat Ooredoo Hutchison under the
            brand
            of&nbsp;<a href="https://indosatooredoo.com/id/personal/">IM3 Ooredoo</a>&nbsp;and/or Mentari Ooredoo,
            including
            but not limited to, voice calls, short messages, data access/internet and other added value services.</li>
        <li>"Emergency" is a condition beyond the control of Indosat Ooredoo Hutchison, including but not limited to,
            acts
            of God, plague, fire, earthquakes, storms, floods, or other disasters, threat of war, riots, or other
            threats of
            unrest, industrial disputes, blackouts, phone line damage, cyber attack, acts of other parties that may
            cause a
            condition wherein Indosat Ooredoo Hutchison cannot provide service as usual to its Customers, or a ban
            placed by
            the government. In the event of such emergency, Indosat Ooredoo Hutchison is released from its obligations.
        </li>
        <li>"Active Period" is the period when the Prepaid SIM Card is active, as determined by Indosat Ooredoo
            Hutchison.
        </li>
        <li>"Grace Period" is the 30 calendar day period after the Active Period expires.</li>
        <li>General Terms and Conditions are general terms and conditions listed on this page, which can be contained
            with
            Special Terms and Conditions (if any) for each Indosat Ooredoo Hutchison product and service.</li>
        <li>Special Terms and Conditions are special terms and conditions listed on this page or other pages that apply
            specifically to each product, service or certain programs that Indosat Ooredoo Hutchison organizes itself or
            in
            collaboration with other parties.</li>
        <li>"Invalid Card" is a Prepaid SIM Card that has exceeded its Grace Period so that the Prepaid SIM Card cannot
            be
            used anymore and its remaining phone credit is made void.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq1"><strong>General Terms</strong></a></p>
    <ol>
        <li>The Terms and Conditions apply after all the prerequisites to subscribe for Indosat Ooredoo Hutchison's
            Prepaid
            mobile cellular telecommunication service has been fulfilled by the Customer and has been approved by
            Indosat
            Ooredoo Hutchison, which can be done by activating the Prepaid SIM Card that the Customer obtained.</li>
        <li>Terms and Conditions apply to Customers who activate the Prepaid Service.</li>
        <li>There is no guarantee that the Prepaid Service is free of errors and disruptions, wherein in certain
            situations
            or places the Prepaid Service may not be available constantly or as it should be</li>
        <li>Customer may not use, or allow another party to use, the Prepaid Service for any act that is illegal or
            against
            the law.</li>
        <li>Customer is forbidden to misuse the Prepaid Service (including the subscription packs as determined by
            Indosat
            Ooredoo Hutchison), including excessive usage, and to use the Prepaid Service for any act against the law.
        </li>
        <li>Customer agrees from time to time to receive offers, product information, or marketing programs that are
            disseminated by Indosat Ooredoo Hutchison and/or in cooperation with a third party.</li>
        <li>Indosat Ooredoo Hutchison has the right to terminate this Terms and Conditions.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq2"><strong>Prepaid SIM Card</strong></a></p>
    <ol>
        <li>To subscribe for the Prepaid Service, Customer must activate the Prepaid SIM Card, followed by filling out
            the
            personal data properly and completely according to identifications (ID Card, Driver's License, Passport).
            The
            Prepaid SIM Card can only be activated within areas according to the activation area listed on the front of
            the
            Prepaid SIM Card's packaging. The Prepaid Service cannot be used if its activation/registration was done
            outside
            the mentioned areas</li>
        <li>To keep using the Prepaid Service, Customer must ensure that the Prepaid SIM Card is always in the Active
            Period.</li>
        <li>A Prepaid SIM Card in the Grace Period cannot use Prepaid Services</li>
        <li>Indosat Ooredoo Hutchison is not responsible for any loss of Customer's phone credit on the when the card
            becomes an "Invalid Card", and the Customer will not claim Indosat Ooredoo Hutchison for damages in any
            form.
        </li>
        <li>The Prepaid SIM Card is still a property of Indosat Ooredoo Hutchison, however Customer is responsible for
            all
            usage of the Prepaid SIM Card, including but not limited to, the event that the Prepaid SIM Card is used by
            another party.</li>
        <li>Customer has the right for a replacement of any lost or damaged Prepaid SIM Card, and Indosat Ooredoo
            Hutchison
            has the right to charge administrative fees according to the terms set by Indosat Ooredoo Hutchison.</li>
        <li>A damaged or lost Prepaid SIM Card can only be replaced according to the terms and conditions set by Indosat
            Ooredoo Hutchison. Indosat Ooredoo Hutchison is not responsible for any loss of phone credit from a
            Customer's
            Prepaid SIM Card that was damaged or lost.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq3"><strong>Limitation and Blocking</strong></a></p>
    <ol>
        <li>Indosat Ooredoo Hutchison has the right to do a blocking if the Prepaid SIM Card is suspected with good
            reason
            to have been used in any act against the law.</li>
        <li>Indosat Ooredoo Hutchison has the right to do a limitation and blocking on Prepaid Services for a Customer
            who
            has been discovered to have sent text messages beyond the normal fair usage for text message transmission,
            whether with or without the aid of any tool in the transmission.</li>
        <li>Indosat Ooredoo Hutchison has the right to do a blocking if the following were to happen: upon request of an
            authorized institution; if there is indication of misuse of the Prepaid SIM Card in any way that may cause
            damages, whether to Indosat Ooredoo Hutchison or to other customers.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq4"><strong>Others</strong></a></p>
    <ol>
        <li>Any information posted on the website or other media by Indosat Ooredoo Hutchison is part of these Terms and
            Conditions.</li>
        <li>Losses that arise as a result of the use or misuse of Prepaid SIM Cards by other parties who are not fully
            responsible are at the customer's risk.</li>
        <li>Indosat Ooredoo Hutchison is only responsible for losses that are a direct result of Indosat Ooredoo
            Hutchison's
            error in providing Prepaid Services, excluding indirect losses such as loss of profit, loss of reputation,
            calculation of bank interest.</li>
        <li>Indosat Ooredoo Hutchison reserves the right to change/terminate/add any part of the Prepaid Service or
            pricing
            structure at any time based on policies determined by Indosat Ooredoo Hutchison.</li>
        <li>Customer hereby authorizes and authorizes Indosat Ooredoo Hutchison to use these Terms and Conditions and
            any
            amendments, additions or updates thereof, including records, information or data relating to Customers in
            any
            form obtained from Customers for both Indosat's purposes and interests Ooredoo Hutchison itself or for
            cooperation with Indosat Ooredoo Hutchison partners.</li>
        <li>Rates may change at any time according to Indosat Ooredoo Hutchison's tariff policy which will be informed
            through the website&nbsp;<a href="http://www.indosatooredoo.com/">www.indosatooredoo.com</a>.</li>
        <li>Indosat Ooredoo Hutchison may apply different tariff variations according to the tariff policy set by
            Indosat
            Ooredoo Hutchison.</li>
        <li>For a smooth transaction to purchase your quota package, make sure your balance is at least 3000 left after
            you
            buy the quota package you choose.</li>
        <li>For the convenience of using your data package service, the system will start processing the deactivation 5
            minutes before your package expires.</li>
        <li>Any changes to these Terms and Conditions will be notified through the website&nbsp;<a
                href="http://www.indosatooredoo.com/">www.indosatooredoo.com</a>.</li>
        <li>Any changes to the Prepaid Service or the pricing structure will be effective when the Customer<br /> (i)
            extends the term of the subscription package; or<br /> (ii) purchase a new package, either the same or a
            different package, to replace the previous package, whichever occurs first.</li>
        <li>These Terms and Conditions are made, regulated and implemented according to and based on the legal
            provisions of
            the Republic of Indonesia.</li>
        <li>If there is a difference or dispute, it will be resolved through deliberation. All disputes or differences
            that
            cannot be resolved amicably by Indosat Ooredoo Hutchison and Customers in connection with the interpretation
            and/or implementation of these Terms and Conditions, both parties agree to resolve them through the Central
            Jakarta District Court.</li>
        <li>Any information and Special Terms and Conditions listed on the site by Indosat Ooredoo Hutchison are part of
            the
            General Terms and Conditions. If there is a difference.</li>
        <li>These Terms and Conditions are made in Indonesian and English. If there is a difference of word
            interpretation,
            phrase, or sentence in Indonesian and English in these Terms and Conditions, the Indonesian version shall
            prevail and be used in interpreting the said word, phrase or sentence.</li>
    </ol>
    <p>&nbsp;</p>
    <h1>Terms and Conditions Indosat Ooredoo Hutchison Postpaid IM3</h1>
    <p>The following are terms and conditions to subscribe for Indosat Ooredoo Hutchison postpaid telecommunication
        service,
        which must be obeyed by customer</p>
    <p>&nbsp;</p>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq10"><strong>Definition</strong></a></p>
    <ol>
        <li>&ldquo;Indosat Ooredoo Hutchison&rdquo; is PT Indosat Tbk, a telecommunication service provider.</li>
        <li>&ldquo;Customer&rdquo; is an individual, legal entity or institution that subscribes to the
            Telecommunication
            Service Provider, as stated in the Subscription Form, under these Subscription Terms and Conditions.</li>
        <li>&ldquo;Telecommunication Service&rdquo; is the postpaid mobile phone service provided by Indosat Ooredoo
            Hutchison for the Customer in the form of a mobile phone number that the Customer can use to make or receive
            calls and/or use for other packages/ features/ value added services/ push mail/ data and others as
            determined by
            Indosat Ooredoo Hutchison at any time.</li>
        <li>Push Mail service in an e-mail service that can be accessed by the Customer through Indosat Ooredoo
            Hutchison&rsquo;s telecommunication network.</li>
        <li>&ldquo;Subscription Form&rdquo; is a form that must be filled out and signed by the potential Customer when
            submitting a request to be a Customer.</li>
        <li>&ldquo;SIM Card&rdquo; is a micro-processor chip that includes a phone number that can be used on the
            Customer&rsquo;s telecommunication device so the Customer would be able to enjoy the Telecommunication
            Service..
        </li>
        <li>&ldquo;Activation&rdquo; is the act of activating the SIM Card in order to use the Telecommunication
            Service.
        </li>
        <li>&rdquo;Single Account Multi User&rdquo; (SAMU) is a service provided by Indosat Ooredoo Hutchison, which is
            a
            united payment service that unites all of the bills of an account that has several numbers.</li>
        <li>&ldquo;Blocking&rdquo; is the disconnection or non-activation of the Telecommnication Service, which could
            be
            temporary (some parts or the whole service) or permanent.</li>
        <li>&ldquo;Force Majeure&rdquo; is an incident outside of Indosatt&rsquo;s control that could prevent or delay
            Indosat Ooredoo Hutchison from performing its duties under these Subscription Terms and Conditions, such as:
            thunderstorm, earthquake, typhoon, fire, war, explosion, flood, tsunami, sabotage, cyber crime, riot, or
            government/ regulator policies or actions by a third party.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq11"><strong>SIM Card</strong></a></p>
    <ol>
        <li>The Customer is permitted to use the SIM card for the Customer&rsquo;s personal use only, according to these
            Subscription Terms and Conditions.</li>
        <li>If the Customer intends to transfer or handover the use of the SIM Card to a third party, then the Customer
            must
            get a written approval from Indosat Ooredoo Hutchison first. If the SIM Card is transferred or handed over
            to a
            third party without written consent from Indosat Ooredoo Hutchison beforehand, the Customer will still be
            held
            accountable for all incidents occurring related to the SIM Card.</li>
        <li>Customers are prohibited from misusing the SIM Card that is not line in line with its usage, according to
            these
            Subscription Terms and Conditions.</li>
        <li>If the Customer loses the SIM Card, the customer must report to the Customer Service division, which
            includes
            Galeri, Contact Center or Griya Indosat Ooredoo Hutchison, and sign an official statement on the loss of the
            SIM
            Card (&nbsp;<em>surat pernyataan kehilangan</em>) and provide a photocopy of the Customer&rsquo;s identity.
            Based on this report, Indosat Ooredoo Hutchison will unactivate the SIM Card. The Customer would still be
            held
            accountable for all subscription fees or expenses according to the Customer&rsquo;s subscription package and
            usage of the Telecommunication Service before the SIM Card was unactivated by Indosat Ooredoo Hutchison.
        </li>
        <li>Indosat Ooredoo Hutchison reserves the right to use the Customer&rsquo;s SIM Card number for another
            customer
            after the Telecommunication Service number has been permanently blocked either by Indosat Ooredoo Hutchison
            or
            the Customer.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq12"><strong>Subscriber Data</strong></a></p>
    <ol>
        <li>The Customer must guarantee that all data and information provided by the Customer to Indosat Ooredoo
            Hutchison
            in the Subscription Form is true.</li>
        <li>If the Customer has not completed all requirements included in the Subscription Form or the Subscription
            Form
            failed to pass Indosat Ooredoo Hutchison&rsquo;s verification test, Indosat Ooredoo Hutchison would suspend
            the
            SIM Card number&rsquo;s activation (if the SIM Card has not been activated yet) or Block the SIM Card number
            (if
            the SIM Card has been activated).</li>
        <li>Customer&rsquo;s must submit a written statement informing Indosat Ooredoo Hutchison if the Customer&rsquo;s
            address or bank account number/ credit card changed including the card&rsquo;s expiration date.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq13"><strong>Service</strong></a></p>
    <ol>
        <li>Indosat Ooredoo Hutchison will provide the Customer with the Telecommunication Service in accordance with
            its
            operating telecommunication service facilities and based on the conditions that apply for Indosat Ooredoo
            Hutchison.</li>
        <li>Indosat Ooredoo Hutchisoncan at any time review its Telecommunication Service and its applied tariffs.</li>
        <li>If the Customer opts to subscribe to a value-added Telecommunication Service provided by a third party,
            then:
        </li>
        <ol>
            <li>The repair of the telecommunication device would refer to the guarantee conditions of the
                telecommunication
                device provided by the third party.</li>
            <li>Loss of the telecommunication device is the responsibility of the Customer.</li>
            <li>Customer cannot use a damaged telecommunication device or a telecommunication device as an excuse not to
                pay
                the Telecommunication Service fee.</li>
        </ol>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq14"><strong>Billing</strong></a></p>
    <ol>
        <li>Indosat Ooredoo Hutchison will bill the Customer for using the Telecommunication Service each month. The
            Customer is obligated to pay for that service by the due date written on the billing statement.</li>
        <li>If a Customer does not receive the billing statement he/ she was supposed to receive, the Customer must
            immediately ask or inform Indosat Ooredoo&rsquo; Hutchisons Customer Service. The Customer is still
            obligated to
            pay the monthly bill despite not having had received a billing statement.</li>
        <li>All objections concerning the billing statement does not excuse the Customer from the responsibility of
            settling
            the billing statement by the written due date. Indosat Ooredoo Hutchison will only respond to any objections
            concerning the billing statement by the latest up to 2 (two) months after the billing statement was
            processed.
        </li>
        <li>The Customer agrees the billing statement delivered is valid based on data electronically captured by
            Indosat
            Ooredoo Hutchison.</li>
        <li>Indosat Ooredoo Hutchison is fully authorized to demand the settlement of the billing statement before the
            due
            date according to the amount due recorded by Indosat Ooredoo Hutchison if the total of the current billing
            statement exceeds the Customer&rsquo;s average monthly usage. The Customer is then obliged to settle the
            bill
            according to the amount stated in the billing statement by the date determined by Indosat Ooredoo Hutchison.
        </li>
        <li>Indosat Ooredoo Hutchison has the right to collect the cost of printing and sending hardcopy bills to
            Customers.
            If the Customer does not want to be charged for printing and sending the hard copy of the bill, the Customer
            can
            contact the call center 021-30008686 or access the MyIM3 application to register for e-billing for sending
            billing information for the use of Telecommunications Services. The amount of printing and sending hardcopy
            bills can be checked at&nbsp;<a
                href="https://indosatooredoo.com/portal/en/bspostpaidbillviacourier">https://indosatooredoo.com/portal/en/bspostpaidbillviacourier</a>
        </li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq15"><strong>Billing Limit, Expenses and
                Payment</strong></a></p>
    <ol>
        <li>Indosat Ooredoo Hutchison reserves the right to determine the limit for the billing statement including but
            not
            limited to the time and limit amount, effectively valid since the date of Activation according to the
            conditions
            the Customer agreed to during initial registration. Indosat Ooredoo Hutchison will send a complete
            notification
            to the Customer on the time period and limit amount.</li>
        <li>As for the billing limit, if the Customer wishes to use the Telecommunication Service and additional
            facilities
            (if any) outside of the limited bill determined by Indosat Ooredoo Hutchison, then the Customer agrees to
            settle
            the bill using a credit card.</li>
        <li>The customer must pay subscription fees and all expenses linked to the use of the Telecommunication Service
            additional facilities (if any) to Indosat Ooredoo Hutchison according to the package selected by the
            Customer
            and tariff determined by Indosat Ooredoo Hutchison, which is subject to change at any time according to the
            existing conditions. All taxes or fees related to said payment would be the responsibility of the Customer.
        </li>
        <li>All Telecommunication Service usage fees and charges overseas will be included in the Customer&rsquo;s
            billing
            statement after Indosat Ooredoo receives the data on the Customer&rsquo;s usage from Indosat Ooredoo
            Hutchison&rsquo;s International roaming partner.</li>
        <li>If the Customer&rsquo;s number is blocked for any reason, the Customer is still obligated to settle its bill
            to
            Indosat Ooredoo Hutchison simultaneously.</li>
        <li>Customer can make payments through the following:</li>
        <ol>
            <li>Cash or transfer according to the payment locket or account written on the billing statement;</li>
            <li>Direct debit from the Customer&rsquo;s bank account or Credit Card</li>
            <li>Any other payment method determined by Indosat Ooredoo Hutchison in the future.</li>
        </ol>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq16"><strong>Responsibility</strong></a></p>
    <ol>
        <li>Indosat Ooredoo Hutchison cannot be held accountable for indirect losses suffered by the Customer and/ or
            third
            party. Indosat Ooredoo Hutchison&rsquo;s only obligation is to take responsibility over losses suffered by
            the
            Customer as long as there is solid proof of Indosat Ooredoo Hutchison&rsquo;s infringement with compensation
            worth maximum 3 (three) months subscription fee.</li>
        <li>In the case of Force Majeure, Indosat Ooredoo Hutchison is liberated from any responsibilities, based on
            these
            Subscription Terms and Conditions.</li>
        <li>Indosat Ooredoo Hutchison cannot be held accountable for lost news and/ or information owned by the Customer
            or
            received and/ or delivered by the Customer to/ or from another party through Indosat Ooredoo
            Hutchison&rsquo;s
            telecommunication network. Thus, the Customer liberates Indosat Ooredoo Hutchison from any claims/ demands
            made
            by any party.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq17"><strong>Blocking and Cancellation of
                Subscription
                Service</strong></a></p>
    <ol>
        <li>Indosat Ooredoo Hutchison reserves the right to block the Telecommunication Service without prior notice to
            the
            Customer if one or more of the following occurs:</li>
        <ol>
            <li>The Customer did not settle its bill by the due date determined by Indosat Ooredoo Hutchison.</li>
            <li>The Customer did not fulfill its obligation to settle its bill, as stated in these Subscription Terms
                and
                Conditions V (5) above.</li>
            <li>The Customer has reached a certain usage limit determined by Indosat Ooredoo Hutchison while Indosat
                Ooredoo
                Hutchison is currently in the middle of its verification process for the Customer or if the Customer did
                not
                pass Indosat Ooredoo Hutchison&rsquo;s verification process.</li>
            <li>The Customer&rsquo;s usage has reached its credit limit (If the Telecommunication Service includes a
                credit
                limit).</li>
            <li>The Customer is suspected to be using the Telecommunication Service to perform illegal activities based
                on
                sufficient initial proof.</li>
            <li>The data or information provided by the Customer, as mentioned in article II (1) is inaccurate, false or
                misleading.</li>
            <li>The Customer is in violation of these Subscription Terms and Conditions.</li>
            <li>The Customer has legally declared bankruptcy or was legally placed under the guardianship of another
                (&nbsp;<em>curatele</em>).</li>
            <li>The Customer is declared legally deceased.</li>
            <li>The Customer is in violation of the law resulting in moral or material disadvantages against Indosat
                Ooredoo
                Hutchison.</li>
            <li>In the case of Force Majeure occurring for 6 (six) months in a row.</li>
        </ol>
        <li>Specifically for SAMU, if the Customer conducts acts as stated in article 1 above, Indosat Ooredoo Hutchison
            reserves the right to block one of or all of the Telecommunication Services registered under the SAMU
            Customer&rsquo;s name.</li>
        <li>After Indosat Ooredoo Hutchison has permanently blocked a number, Indosat Ooredoo Hutchison reserves the
            right
            to use said number and give it to another customer, in accordance with the conditions applied for Indosat
            Ooredoo Hutchison.</li>
        <li>The Customer may stop subscribing to the Telecommunication Service at any time by submitting a written
            request
            first to Indosat Ooredoo Hutchison. A cancellation of the subscription based on the Customer&rsquo;s request
            does not eliminate the Customer&rsquo;s obligation to settle its debt to Indosat Ooredoo Hutchison.</li>
        <li>Indosat Ooredoo Hutchison and the Customer agree to override Article 1266 of the Civil Law concerning the
            cancellation/ end of this subscription.</li>
    </ol>
    <p><a href="https://indosatooredoo.com/portal/en/pssupporttnc#faq18"><strong>Miscellaneous</strong></a></p>
    <ol>
        <li>These Subscription Terms and Conditions abide and are regulated by the law of the Republic of Indonesia. If
            conflicts or differences arise and Indosat Ooredoo Hutchison and the Customer are unable to settle said
            differences or conflicts due to differences in perception or implementation of the Subscription Terms and
            Conditions, both parties agree to settle the matter at the Central Jakarta Court.</li>
        <li>The Customer permits and provides Indosat Ooredoo Hutchison with the authority to use these Subscription
            Terms
            and Conditions including any following changes, additions or renewals, including notes, information or data
            concerning the Customer in any form received by Indosat Ooredoo Hutchison from the Customer for Indosat
            Ooredoo
            Hutchison&rsquo;s personal use and interests in any form.</li>
        <li>The Customer agrees to receive offers/ information concerning marketing programs/ products released by
            Indosat
            Ooredoo Hutchison and/ or a third party partnering with Indosat Ooredoo.<br /> The Customer can deactivate
            or
            reactivate to receive the offers/information related to the marketing programs/products by accessing *185#,
            select &ldquo;Layanan DnD&rdquo; (DnD service)</li>
        <li>The Customer agrees to abide by the terms and conditions as written on&nbsp;<a
                href="http://www.indosatooredoo.com/">www.IndosatOoredoo.com</a>&nbsp;as long as it does not conflict
            with
            these Subscription Terms and Conditions.</li>
        <li>These Subscription Terms and Conditions replace any deal or agreements made before regarding Indosat Ooredoo
            Hutchison's Telecommunication Services (if any).</li>
    </ol>
    <p>&nbsp;</p>
    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Terms and Conditions Indosat Ooredoo Hutchison Prepaid Tri
    </h1>
    <p>This Privacy Policy is the policy of PT Indosat Tbk (&ldquo;Indosat Ooredoo Hutchison&rdquo; or
        &ldquo;IOH&rdquo;) in
        managing the information and data of IOH&rsquo;s website and services (&ldquo;Data&rdquo;). IOH respects and
        protects the personal information and data of the users of IOH&rsquo;s official website and services
        (&ldquo;Users&rdquo;). This Privacy Policy applies to Tri products and services, as well as the ancillary
        websites
        and applications in connection with the provision of Tri product and services by IOH (the
        &ldquo;Services&rdquo;).
    </p>
    <p>This Privacy Policy regulates the applicable ground and conditions for the acquisition, collection, processing,
        analysis, storage, display, announcement, delivery, dissemination and/or access opening, deletion and
        extermination
        of Data provided by the Users to IOH or collected by IOH from the Users when the Users registered, accessed the
        website and/or applications of IOH. User Data may include Users&rsquo; personal data and other information
        related
        with the Users.&nbsp;</p>
    <p>By accessing and/or using the Services of IOH, the Users declare that all User Data are the correct and
        legitimate
        data, and the Users authorize IOH to acquire, collect, process, analyse, store, deliver, provide access, use,
        delete
        and exterminate the Data in compliance with this Privacy Policy.</p>
    <p>This Privacy Policy does not apply to the practices of companies that IOH does not own or control, or to
        individuals
        whom IOH does not employ or manage, including any of the third parties to which IOH may disclose user
        information as
        set forth in this Privacy Policy.</p>
    <p>Users are expected to read this Privacy Policy carefully. By accessing and/or using the website, the Users have
        read,
        understood and agreed to be bound with all provisions written in this Privacy Policy. If the Users do not agree
        to
        be bound with this Privacy Policy, the Users are welcomed to stop accessing and not using the Services.</p>
    <p>&nbsp;</p>
    <p><strong>DATA ACQUISITION AND COLLECTION</strong></p>
    <p>IOH acquires and collects Data for IOH&rsquo;s services provision purpose to the Users, conducts transactional
        processes, manages data to maintain and improve quality and Users&rsquo; experience towards Services as well as
        other purposes authorized or required by the applicable law. The collected Data are as in the following:</p>
    <ol type="a">
        <li>Data given by the Users, such as:</li>
        <ol type="i">
            <li>when registering or updating the account in IOH, including username, email address, phone number,
                password,
                address, photo, mobile device information, and etc;</li>
            <li>when contacting IOH, including through Customer Care;</li>
            <li>when filling survey sent by IOH or on behalf of IOH;</li>
            <li>when having interaction with another User through features such as message, product discussion, review,
                rating,
                and so on;</li>
            <li>when using Services on the website and filling payment data when the Users conduct payment transactional
                activity through the website or applications, including detailed transaction data, such as bank account
                data,
                credit card, type, amount and/or information about the purchased product or service, delivery address,
                payment
                channel used, transaction amount, date and time of the transaction, and other transaction details;
                and/or
            </li>
            <li>when using features that require access permission to the User&rsquo;s device;</li>
        </ol>
        <li>Data recorded by the Users when using website or applications, including but not limited to:</li>
        <ol type="i">
            <li>location data or the approximates, such as IP address, Wi-Fi location, geo-location, and other location
                information;</li>
            <li>data of the time of every activity of the Users, including registration, login, transaction, and other
                activities;</li>
            <li>usage data or User&rsquo;s preference, including User&rsquo;s interaction in using the website or
                applications,
                saved options and selected settings. The data are acquired using cookies, pixel tags, and similar
                technologies
                that generate and maintain unique ID;</li>
            <li>device data, such as the type of device used to access the Website, including the hardware model,
                operation
                system and the version, software, file name and the version, language selection, unique device ID,
                advertising
                ID, serial number, device movement information, and/or cellular network information;</li>
            <li>record data or log, including records on the server that receives the data, such as device IP address,
                access
                date and time, seen application&rsquo;s feature or page, application process and other system
                activities,
                type
                of browser, and/or third party website or application used before interacting with the website or
                applications
                of IOH;</li>
        </ol>
        <li>data acquired from other sources, such as:</li>
        <ol type="i">
            <li>IOH&rsquo;s partners that cooperate with IOH in providing IOH&rsquo;s services and improving quality as
                well
                as
                Website Users&rsquo; experience, such as partners in content providing, payment service, infrastructure
                and
                telecommunication support service, and other IOH&rsquo;s partners;</li>
            <li>marketing and sales service provider;</li>
            <li>governmental institutions or agencies; and</li>
            <li>other generally accessible sources.</li>
        </ol>
    </ol>
    <p>&nbsp;</p>
    <p><strong>DATA USAGE</strong></p>
    <p>IOH may entirely or partly use, process and combine the data acquired and collected from the Users for these
        purposes:</p>
    <ol type="a">
        <li>processing all types of demands, activities or transactions performed by the Users through Website;</li>
        <li>providing IOH&rsquo;s services for the Users, such as by offering, acquiring, or providing IOH&rsquo;s
            service
            facilities or other services through Website;</li>
        <li>repairing and improving the quality of service of IOH;</li>
        <li>maintaining the quality of service of IOH;</li>
        <li>assisting the Users during communication with IOH&rsquo;s Customer Care service, for:</li>
        <li>examining and resolving Users&rsquo; problems;</li>
        <li>directing Users&rsquo; questions to the Customer Care to resolve the problems;</li>
        <li>improving the quality of service of IOH&rsquo;s Customer Care.</li>
        <li>contacting Users through email, letter, phone, fax, and etc, regarding provision of Services;</li>
        <li>study, analysis, development and product and service experiment purposes in order to improve the quality
            and
            security of services on website and applications, as well as to develop new products, features, and
            features;
        </li>
        <li>informing the Users regarding the product, service, promotion, study, survey, news, latest update,
            event,
            and
            etc, through the website or other media;</li>
        <li>conducting promotion and processing contest and lottery, giving gifts, as well as presenting relevant
            advertisements and content of the Services and its business partners;</li>
        <li>performing monitoring or investigation on suspicious activities and transactions or transactions that
            are
            indicated to contain the element of fraud or violation to the terms and conditions of Services or the
            applicable
            law, as well as taking the necessary actions as the follow-up to the result of the monitoring or
            investigation
            of the activity or transaction;</li>
        <li>cooperating with the third party regarding IOH&rsquo;s business activities which aims to benefit IOH;
        </li>
        <li>for fulfilment of obligation of IOH and/or User under the applicable law and/or terms of Services; and
        </li>
        <li>if instructed by the law enforcer, using, or disclosing the Users data for law enforcement or compliance
            to
            the
            applicable law purposes, including in case of dispute or legal process between Users and IOH.</li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>PERSONAL DATA DISCLOSURE</strong></p>
    <p>IOH protects Users&rsquo; Data and it will only be disclosed to the third party to the extent that it is
        reasonably
        necessary in the following cases:</p>
    <ol type="a">
        <li>if the disclosure of Data is required to assist IOH in providing the Services including but not limited
            to
            understand more about user behaviour on IOH&rsquo;s Service;</li>
        <li>IOH may provide relevant information and data to the business partners of IOH under the User&rsquo;s
            consent
            to
            use the business partners&rsquo; services, such as applications or websites of which API and services
            have
            been
            integrated, or business partners that have worked together with IOH;</li>
        <li>there requires a communication between IOH&rsquo;s business partners and the Users to resolve problems
            regarding
            the usage of Services, or other matters;&nbsp;&nbsp;</li>
        <li>Users contact IOH through public media, such as social media and certain features on the website,
            communication
            between the Users and IOH can be seen by the public;</li>
        <li>IOH may share Users&rsquo; information to the subsidiaries and affiliations to help providing services
            or to
            process data for and on behalf of IOH;</li>
        <li>it is appropriate or necessary to enforce the terms of Service, take precautions against liability, to
            investigate and defend itself against any third-party claims or allegations, to assist government
            enforcement
            agencies, to protect the security or integrity of the Services, and to protect the rights, property, or
            personal
            safety of IOH, Users or others;</li>
        <li>IOH may provide relevant information to the vendor, consultant, marketing partner, research firm, or
            similar
            service providers; and</li>
        <li>if required to do so by law, or in the good-faith belief that such action is necessary to comply with
            applicable
            laws, international law or respond to a court order, subpoena, or search warrant or equivalent, or where
            in
            IOH
            reasonable belief, an individual&rsquo;s physical safety may be at risk or threatened.</li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>COMMITMENT TO DATA SECURITY </strong></p>
    <p>IOH uses commercially reasonable physical, managerial, and technical safeguards to preserve the integrity and
        security of user personal information. IOH cannot, however, ensure or warrant the security of any
        information
        user
        transmits using Company&rsquo;s Service and user do so at user own risk. Using unsecured wifi or other
        unprotected
        networks is never recommended. Once IOH receives user transmission of information, IOH makes commercially
        reasonable
        efforts to ensure the security of Company&rsquo;s systems. However, please note that this is not a guarantee
        that
        such information may not be accessed, disclosed, altered, or destroyed by breach of any of IOH physical,
        technical,
        or managerial safeguards. If IOH learns of a security systems breach, then IOH may attempt to notify user
        electronically so that user can take appropriate protective steps. IOH may post a notice if a security
        breach
        occurs.</p>
    <p>&nbsp;</p>
    <p><strong>INFORMATION STORAGE AND DELETION </strong></p>
    <p>IOH will store the Data for so long the User&rsquo;s account is active and may perform deletion to the extent
        permissible by the applicable law.</p>
    <p>Users can request for deletion of their personal information by</p>
    <ol type="i">
        <li>contacting us at 3care@three.co.id / 3care@ioh.co.id, or</li>
        <li>by submitting a request through Bima+ application.</li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>APPLICATION LINK OF ANOTHER PARTY</strong></p>
    <p>IOH&rsquo;s website, applications, or Services may provide link to another party&rsquo;s website or
        application.
        The
        referred link does not suggest that IOH agrees and be liable of the content of the other party&rsquo;s
        website
        or
        application. You know and agree that IOH does not hold liable upon the content or other materials included
        on
        that
        party&rsquo;s website or application.</p>
    <p>&nbsp;</p>
    <p><strong>USER&rsquo;S CHOICE</strong></p>
    <ol type="a">
        <li>Users may access and change User&rsquo;s information and data through profile/setting feature on the
            website.
        </li>
        <li>As long as permitted by the applicable law, Users may contact IOH to revoke the agreement upon the
            acquisition,
            collection, processing, and usage of User&rsquo;s Data. Under that circumstance, the User understands
            the
            consequences that the User will not be able to use Website services or other IOH&rsquo;s Services.</li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>INTELLECTUAL PROPERTY RIGHTS </strong></p>
    <p>Every logo and/or logo application, character, and/or brand on the services, contents, products, and features
        of
        H3I
        as included or used on the Services are reserved under the protection of the applicable law in Indonesia.
        You
        are
        not allowed to use, implement, and apply logo and/or logo application in any way without having written
        consent
        from
        IOH.&nbsp;</p>
    <p>All materials included on the website and applications are protected by the copyrights granted and endorsed
        by
        the
        applicable law of Indonesia, including but not limited to Law No. 28 of 2014 on Copyrights and its changes
        and
        its
        regulation of implementation. If there is any individual or legal firm finds that the materials included on
        the
        website belong to them, please immediately inform IOH to be acted upon.&nbsp;</p>
    <p><strong>IN THE EVENT OF MERGER, SALE, OR BANKRUPTCY</strong></p>
    <p>In the event that IOH is acquired by or merged with a third party entity, IOH reserve the right to transfer
        or
        assign
        the Data as part of such merger, acquisition, sale, or other change of control. In the unlikely event of
        Company
        bankruptcy, insolvency, reorganization, receivership, or assignment for the benefit of creditors, or the
        application
        of laws or equitable principles affecting creditors' rights generally, IOH may not be able to control how
        user
        personal information is treated, transferred, or used.</p>
    <p><strong>APPLICABLE LAW</strong></p>
    <p>This Privacy Policy is subject to the laws of the Republic of Indonesia.</p>
    <p>This Privacy Policy is made in Indonesian and English. If there is any difference or contradiction between
        the
        Indonesian and English version, the Indonesian version will be applied.</p>
    <p><strong>&nbsp;</strong></p>
    <p><strong>PRIVACY POLICY CHANGES </strong></p>
    <p>IOH may change or update this Privacy Policy at any time. The Users are expected to read this carefully and
        to
        check
        this Privacy Policy page from time to time to know any changes that IOH does towards this Privacy Policy. By
        keep
        accessing and using the website or other services of IOH, the Users agree to accept the changes of the
        Privacy
        Policy.</p>
    <h1 [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri' }">
        Personalize Marketing of Products and Services by IOH</h1>
    <ul>
        <li>To utilize customers' personal data from IOH, including the physical location of IOH customer devices
            combined
            with information about the advertisements viewed and usage habits of IOH services and/or products. This
            data
            will be shared with third parties for the provision of personalized content and to assess the
            effectiveness
            of
            third-party advertising campaigns aligned with the targeted customer profiles</li>
        <li>To use IOH customers' personal data related to usage and purchase habits of IOH products and/or
            services,
            tendencies to change numbers, as well as location. This data will be shared with third parties for
            further
            analysis processes. The analysis encompasses credit risk assessment and the provision of additional
            telecommunications services. This may involve collaboration with third parties in the financial services
            sector
            and others</li>
        <li>To use IOH customers' personal data related to usage habits of IOH products and/or services to
            understand
            and
            categorize customers. The results of this processing will create segmentation in customer profiles that
            will
            be
            shared with third parties</li>
        <li>To leverage IOH customers' personal data related to their habits in using IOH products and/or services
            for
            further analysis for third-party purposes. Additionally, to carry out marketing processes more aligned
            with
            the
            preferences of IOH customers. This includes collaborating with third parties to provide offers for
            products
            and
            services held by third parties that better align with your preferences, as recognized by IOH.</li>
    </ul> -->
</div>

<div *ngIf="lang === 'id'" class="tnc"
    [ngClass]="{ 'im3' : platform === 'im3', 'indosat' : platform === 'indosat' || platform === 'tri' }">
    <p>
        <strong>PEMBERITAHUAN PRIVASI</strong>
    </p>

    <ol>
        <li>
            <strong>Pendahuluan</strong>
            <p class="mt-2">
                Pemberitahuan Privasi ini merupakan kebijakan PT Indosat Tbk (“<strong>Indosat
                    Ooredoo Hutchison</strong>” atau “<strong>IOH</strong>” atau “<strong>Kami</strong>”)
                dalam penanganan informasi dan data pengguna situs, aplikasi, platform,
                produk dan layanan IOH.
            </p>
            <p>
                Kami menghargai dan melindungi data dan informasi pribadi (“<strong>Data
                    Pribadi</strong>”) pengguna situs, aplikasi, platform, produk dan
                layanan<strong></strong>dari IOH (“<strong>Pengguna</strong>”
                <strong>
                    atau
                </strong>
                “<strong>Anda</strong>”) sesuai dengan ketentuan perundang-undangan yang
                berlaku di Indonesia.
            </p>
            <p>
                <a name="_Hlk222395415">
                    Pemberitahuan Privasi ini menetapkan dasar dan syarat ketentuan yang
                    berlaku terhadap kegiatan pemrosesan Data Pribadi, termasuk namun tidak
                    terbatas pada pemerolehan, pengumpulan, pemrosesan, pengolahan,
                    penganalisisan, penyimpanan, perbaikan, pembaruan, penampilan,
                    pengumuman, pengiriman, penyebarluasan, pengungkapan, pembukaan akses,
                    penghapusan dan/atau pemusnahan Data Pribadi yang Anda berikan kepada
                    IOH atau yang dikumpulkan oleh IOH dari Anda pada saat Anda menggunakan
                    produk dan layanan Kami, mengunjungi, mengakses, maupun menggunakan
                    layanan daring aplikasi, platform, situs web, peralatan perangkat lunak,
                    layanan dan fungsi lain yang disediakan IOH, atau mengunjungi, mengakses
                    ataupun menggunakan produk dan layanan lainnya yang ditawarkan atau
                    diselenggarakan oleh IOH (selanjutnya disebut sebagai “<strong>Layanan</strong>”).
                </a>
            </p>
            <p>
                Pemberitahuan Privasi ini berlaku untuk seluruh Pengguna, calon Pengguna,
                maupun pihak lain yang berinteraksi dengan IOH, sepanjang relevan dengan
                pemrosesan Data Pribadi.
            </p>
            <p>
                Apabila untuk suatu produk/Layanan terdapat kebijakan privasi terpisah atau
                tambahan, maka kebijakan tersebut akan berlaku sebagai pelengkap
                Pemberitahuan Privasi ini.
            </p>
        </li>
        <li>
            <strong>Definisi</strong>
            <p class="mt-2">
                <a name="_Hlk222400873">
                    Dalam Pemberitahuan Privasi ini, kecuali dinyatakan lain dalam bagian
                    yang terpisah, istilah berikut mempunyai arti sebagai berikut:
                </a>
            </p>
            <ol type="a">
                <li>
                    “<strong>Data Pribadi</strong>” adalah setiap data tentang orang
                    perseorangan yang teridentifikasi atau dapat diidentifikasi secara
                    tersendiri atau dikombinasikan dengan informasi lainnya, baik secara
                    langsung maupun tidak langsung melalui sistem elektronik dan/atau
                    non-elektronik.
                </li>
                <li>
                    “<strong>Data Pribadi Spesifik</strong>” adalah Data Pribadi
                    tertentu yang memerlukan pelindungan lebih, sesuai peraturan
                    perundang-undangan yang berlaku (termasuk namun tidak terbatas pada data
                    kesehatan, biometrik, genetika, catatan kejahatan, data anak, data keuangan
                    tertentu, dan/atau data lain yang ditetapkan peraturan).
                </li>
                <li>
                    “<strong>Pemrosesan Data Pribadi</strong>” berarti satu atau
                    serangkaian tindakan atas Data Pribadi, termasuk pengumpulan, pencatatan,
                    penyimpanan, pemanfaatan, pengungkapan, dan penghapusan.
                </li>
                <li>
                    “<strong>Pengendali Data Pribadi</strong>” adalah pihak yang
                    menentukan tujuan dan kendali pemrosesan Data Pribadi. IOH bertindak sebagai
                    Pengendali Data Pribadi atas Data Pribadi yang diproses berdasarkan
                    Pemberitahuan Privasi ini, kecuali dinyatakan lain secara tegas.
                </li>
                <li>
                    “<strong>Prosesor Data Pribadi</strong>” adalah pihak yang memroses
                    Data Pribadi atas nama dan instruksi Pengendali Data Pribadi.
                </li>
                <li>
                    “<strong>Data Pengguna</strong>” berarti (i) Data Pribadi;
                    dan/atau (ii) informasi lain yang secara sendiri-sendiri atau apabila
                    digabungkan dengan informasi lain dapat mengidentifikasi Pengguna secara
                    langsung maupun tidak langsung.
                </li>
            </ol>
        </li>
        <li class="mt-3">
            <strong><u>Dasar Hukum Pemrosesan Data Pribadi</u></strong>
            <p class="mt-2">
                Data yang Kami kumpulkan tentang Anda dan bagaimana Kami mengumpulkannya
                dapat bervariasi tergantung pada jenis Layanan Kami yang Anda akses atau
                gunakan, bagaimana Anda menggunakan produk dan Layanan Kami, dan bagaimana
                Anda berinteraksi dengan IOH meskipun Anda bukan Pengguna, atau apa yang
                telah Kami peroleh dari pihak ketiga dengan izin untuk membaginya dengan
                Kami. <br />
                <br />
            </p>
            <p>
                IOH memroses Data Pribadi Anda berdasarkan satu atau lebih dasar pemrosesan
                yang sah sebagai berikut:
            </p>
            <ul type="circle">
                <li>
                    <strong>Pemenuhan perjanjian</strong> dalam hal Anda merupakan
                    salah satu pihak atau untuk memenuhi permintaan Anda sebelum
                    perjanjian dibuat, termasuk hal-hal yang tercantum dalam syarat dan
                    ketentuan berlangganan produk/Layanan IOH;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    <strong>Pemenuhan kewajiban hukum IOH</strong> sesuai
                    peraturan perundang-undangan yang berlaku (termasuk kebutuhan
                    untuk proses penyidikan, pelaporan kepada regulator, dan pemenuhan
                    kewajiban lainnya yang diatur secara ketat oleh ketentuan
                    perundang-undangan);
                </li>
            </ul>
            <ul type="circle">
                <li>
                    <strong>
                        Pemenuhan kepentingan yang sah (legitimate interest) IOH
                    </strong>
                    , dengan memperhatikan tujuan, kebutuhan, dan keseimbangan
                    kepentingan IOH dan hak Anda (termasuk pencegahan fraud,
                    keamanan jaringan dan Layanan, kepatuhan, audit internal, dan
                    peningkatan Layanan);
                </li>
            </ul>
            <ul type="circle">
                <li>
                    <strong>
                        Persetujuan (consent) yang sah dan/atau eksplisit dari
                        Anda
                    </strong>
                    , apabila dipersyaratkan oleh peraturan perundang-undangan
                    yang berlaku, terhadap pemrosesan Data Pribadi yang dilakukan
                    IOH.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    <strong>
                        Pelaksanaan tindakan tertentu yang diwajibkan atau
                        diizinkan oleh peraturan perundang-undangan,
                    </strong>
                    termasuk dalam rangka kepentingan umum, pelayanan publik, atau
                    pelaksanaan kewenangan IOH berdasarkan peraturan
                    perundang-undangan yang berlaku, misalnya kewajiban tertentu dalam
                    rangka keamanan jaringan dan layanan telekomunkasi, untuk
                    membantu mendeteksi dan mencegah penipuan, penggelapan pajak
                    dan kejahatan keuangan.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    <strong>Pemenuhan kepentingan yang sah lainnya</strong> dengan
                    memperhatikan tujuan, kebutuhan, dan keseimbangan kepentingan
                    IOH dan hak Pengguna.
                </li>
            </ul>
            <p class="mt-2">
                IOH adalah Pengendali Data Pribadi atas seluruh Data Pribadi yang
                dikumpulkan dan diproses, kecuali jika pemberitahuan privasi tambahan
                mengatakan sebaliknya.
            </p>
            <p>
                Jika Anda memiliki pertanyaan tentang atau memerlukan informasi lebih lanjut
                mengenai dasar hukum bagi Kami untuk mengumpulkan dan menggunakan Data
                Pribadi Anda untuk setiap kegiatan pemrosesan tertentu, silakan hubungi Kami
                menggunakan rincian kontak yang disediakan di bagian "<a><strong>Hubungi
                        Kami</strong></a>
                " di bawah.
            </p>
        </li>
        <li>
            <strong>
                <u>Bagaimana IOH mengumpulkan Data Pribadi Anda?</u>
            </strong>
            <p class="mt-2">
                Data yang kami kumpulkan dapat bervariasi bergantung pada jenis Layanan,
                cara Anda menggunakan Layanan, dan interaksi Anda dengan IOH.
            </p>
            <p>
                IOH umumnya mengumpulkan dan menggunakan Data Pribadi Anda ketika Anda:
            </p>
            <ul type="circle">
                <li>
                    membeli atau menggunakan berbagai produk dan Layanan
                </li>
                <li>
                    menggunakan jaringan Kami dan/atau Layanan
                </li>
                <li>
                    mendaftar untuk Layanan
                </li>
                <li>
                    mengajukan pertanyaan Pengguna, daftar untuk mendapatkan
                    informasi atau layanan lainnya
                </li>
                <li>
                    menanggapi komunikasi dari Kami (seperti SMS, surat elektronik
                    (email), kuesioner atau survei)
                </li>
                <li>
                    menggunakan situs IOH, seperti mengirimkan formulir aplikasi,
                    mengisi formulir survei, menggunakan layanan online. (Apabila
                    browser Anda mengaktifkan cookie internet, hal tersebut dapat
                    memfasilitasi IOH untuk melakukan pelacakan preferensi
                    pribadi, halaman yang dikunjungi, dan lainnya)
                </li>
                <li>
                    berpartisipasi ataupun berinteraksi di halaman aplikasi IOH
                    dan media sosial IOH, seperti Facebook, Instagram, Twitter,
                    LinkedIn, dan lainnya
                </li>
                <li>
                    berpartisipasi dalam acara promosi, insentif, program
                    loyalitas IOH, atau undian
                </li>
                <li>
                    memberikan informasi melalui contact center, retailer/dealer,
                    channel penjualan, atau afiliasi IOH
                </li>
                <li>
                    Anda memberikan persetujuan kepada perusahaan lain untuk
                    membagi informasi tentang Anda
                </li>
                <li>
                    dimana informasi tentang Anda tersedia untuk umum
                </li>
                <li>
                    dimana Anda adalah pelanggan dari perusahaan yang Kami
                    akuisisi atau perusahaan yang terlibat dalam suatu aksi
                    korporasi Kami
                </li>
                <li>
                    berkunjung ke lokasi IOH yang dilengkapi CCTV atau perangkat
                    keamanan lainnya
                </li>
            </ul>
            <p class="mt-2">
                Kami juga dapat memperoleh Data Pribadi dari pihak ketiga yang sah,
                misalnya:
            </p>
            <ul type="circle">
                <li>
                    mitra bisnis/penyedia layanan,
                </li>
                <li>
                    lembaga pencegahan fraud,
                </li>
                <li>
                    referensi kredit, lembaga penagihan,
                </li>
                <li>
                    penyedia jaringan terhubung,
                </li>
                <li>
                    pihak lain sepanjang terdapat dasar pemrosesan yang sah.
                </li>
                <li>
                    mitra bisnis/penyedia layanan,
                </li>
            </ul>
            <p class="mt-2">
                IOH hanya akan memproses Data Pribadi dari pihak ketiga apabila pihak ketiga
                tersebut menyatakan memiliki dasar yang sah untuk membagikan data tersebut
                kepada IOH.
            </p>
            <p>
                IOH dapat menggunakan cookies, web beacon, atau teknologi sejenis untuk
                meningkatkan pengalaman pengguna, analitik, keamanan, serta pemasaran yang
                dipersonalisasi, sesuai preferensi Anda dan peraturan perundang-undangan
                yang berlaku. Pengguna dapat mengatur preferensi cookies melalui pengaturan
                browser/perangkat.
            </p>
        </li>
        <li>
            <strong><u>Apa saja Data Pribadi Anda yang dikumpulkan
                    oleh IOH??</u></strong>
            <p class="mt-2">
                Jenis-jenis informasi Data Pribadi yang IOH kumpulkan termasuk, namun tidak
                terbatas pada:
            </p>
            <ul type="circle">
                <li>
                    Informasi identitas dan kontak, antara lain: nama, alamat,
                    alamat surat elektronik (e-mail), nomor telepon yang mungkin
                    dibutuhkan sehubungan dengan produk, layanan dan tujuan-tujuan
                    lain dari pemrosesan data berdasarkan Pemberitahuan Privasi
                    ini.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi identifikasi individual (misalnya, antara lain:
                    Kartu Tanda Penduduk (KTP/e-KTP), nomor paspor, nomor KITAS,
                    Nomor Pokok Wajib Pajak (NPWP), atau data Badan Penyelenggara
                    Jaminan Sosial (BPJS), Surat Izin Mengemudi (SIM), dan tanggal
                    lahir).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi demografis (misalnya, antara lain: rentang usia,
                    status perkawinan, jenis kelamin).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Foto, seperti foto-foto yang Anda kirimkan untuk kontes atau
                    kompetisi memenangkan hadiah.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi spesifik produk (misalnya, antara lain: preferensi,
                    closed user groups (CUGs), teman dan keluarga yang Anda pilih
                    untuk disertakan dalam paket layanan Anda, batas kredit).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Data trafik Anda sebagai bagian dari penyediaan konektivitas
                    untuk Anda, misalnya, antara lain: nomor yang Anda hubungi,
                    waktu dan durasi panggilan, atau cara Anda menggunakan data.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi perbankan (misalnya, antara lain: debit langsung dan
                    transaksi perbankan pembayaran tagihan yang terkait).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi akun dan layanan antara lain: data penggunaan
                    panggilan, saldo akun, riwayat transaksi, informasi kredit,
                    penagihan, poin loyalitas.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Kontak Anda dengan Kami (misalnya, antara lain: catatan atau
                    rekaman panggilan yang Anda lakukan ke salah satu pusat kontak
                    Kami, <em>fitur live chat</em>, email atau surat yang dikirim,
                    atau catatan lain dari kontak apa pun dengan Kami).
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi kredensial – Kami akan mengumpulkan kata sandi,
                    petunjuk, dan informasi keamanan serupa yang digunakan untuk
                    autentikasi dan akses ke akun dan Layanan.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi yang Kami peroleh dari sumber lain (misalnya, antara
                    lain: agen kredit, agen pencegahan penipuan, perbankan, dan
                    pihak lainnya yang bekerjasama dengan Kami. Ini termasuk data
                    demografis, data berbasis minat, dan perilaku penelusuran
                    internet, dll.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Data Pribadi Spesifik - Dalam beberapa keadaan tertentu, IOH
                    dapat memproses Data Pribadi Spesifik jika dan sepanjang
                    diizinkan oleh peraturan perundang-undangan yang berlaku dan
                    memenuhi persyaratan khusus, termasuk penerapan langkah
                    keamanan tambahan. Kategori khusus dari Data Pribadi mencakup
                    informasi yang mengungkap asal ras atau etnis, opini politik,
                    keyakinan agama atau filosofis, keanggotaan serikat pekerja, data
                    terkait kesehatan atau data terkait kehidupan seks atau
                    orientasi seksual seseorang. Misalnya, Kami dapat mengumpulkan
                    data kesehatan Anda saat menilai situasi Anda untuk
                    memfasilitasi aktivitas pemulihan utang, memberikan dukungan
                    tambahan, atau saat menyediakan komunikasi Kami dalam format
                    yang dapat diakses.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Jenis dan versi sistem operasi, versi perangkat keras,
                    pengaturan perangkat, jenis perangkat lunak, kekuatan baterai
                    dan sinyal, resolusi layer, identitas perangkat (International
                    Mobile Equipment Identity), produsen dan model, bahasa, serta
                    jenis dan versi browser internet. Nama dan versi Layanan
                    (seperti aplikasi) yang Anda gunakan juga Kami kumpulkan.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Informasi lokasi geografis, seperti lokasi yang didapatkan
                    dari alamat IP atau GPS Anda, Base Station, sinyal Bluetooh
                    atau Wi-Fi, satelit, menara telekomunikasi dan informasi
                    tentang bagaimana Anda terlibat dengan dan menggunakan
                    Layanan, sebagai contoh pada saat Anda memilih untuk mengaktifkan
                    layanan mengaktifkan-lokasi pada perangkat yang Anda gunakan
                    untuk mengakses layanan tersebut.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Data biometrik antara lain: sidik jari, suara, audio, video,
                    atau karakteristik fisik tertentu untuk autentikasi/fitur
                    tertentu.
                </li>
            </ul>
            <ul type="circle">
                <li>
                    Kami mengumpulkan informasi dari dan tentang berbagai macam
                    teknologi dimana Layanan digunakan. Jenis informasi yang
                    dikumpulkan tergantung pada teknologi, penggunaan, dan
                    perangkat serta pengaturan pribadi. Contoh dari teknologi ini
                    bisa berupa komputer, telepon dan tablet, juga perangkat yang dapat
                    digunakan secara interaktif, teknologi yang terhubung di rumah atau
                    kendaraan lain.
                </li>
            </ul>
        </li>
        <li>
            <strong><u>Bagaimana IOH menggunakan Data Pribadi
                    Anda? (Tujuan Pemrosesan Data Pribadi)</u></strong>
            <p class="mt-2">
                Data Pribadi Anda dapat dikumpulkan, digunakan, diproses dan/atau diolah
                oleh IOH untuk tujuan berikut:
            </p>
            <ol start="1" type="1">
                <li>
                    Untuk menyediakan informasi dan Layanan beserta manfaat dan
                    perubahan yang terjadi dari Layanan Kami ataupun pihak-pihak
                    yang bekerja sama dengan Kami, kepada Anda:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        untuk menyediakan produk, layanan, dan penawaran Kami
                        atau pihak ketiga yang bekerjasama dengan Kami, yang
                        mungkin menarik bagi Anda;
                    </li>
                    <li>
                        menyediakan informasi dan penawaran terkait produk gaya
                        hidup yang mungkin bermanfaat bagi Pengguna;untuk memberi
                        tahu Anda tentang manfaat dan perubahan pada fitur Layanan Kami;
                    </li>
                    <li>
                        untuk memberikan penawaran, kampanye, dan promosi terbaru
                        Kami kepada Anda (di mana Anda berlangganan pembaruan
                        tersebut);
                    </li>
                    <li>
                        menyediakan informasi dan penawaran produk non-seluler kepada
                        Pengguna, seperti Layanan Tambah Nilai (<em>Value-Added Service</em>/VAS),
                        layanan teknologi baru seperti <em>Artifisial Intellegence</em> (AI),
                        teknologi keuangan, broadband rumah, <em>Internet of Things</em>(IoT), dan
                        produk digital/ <em>enterprise</em> lainnya;
                    </li>
                    <li>
                        untuk memahami bagaimana Anda berinteraksi dengan Layanan
                        dan memberi Anda pengalaman terbaik;
                    </li>
                    <li>
                        untuk memberi Anda keamanan, versi, fitur, opsi, dan
                        kontrol terbaru yang terkait dengan sistem atau perangkat
                        Anda.
                    </li>
                </ul>
            </ol>
            <ol start="2" type="1">
                <li class="mt-2">
                    Untuk berkomunikasi dengan Anda atau pihak yang datanya Anda
                    berikan melalui Layanan:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        untuk mengirimkan pesan layanan kepada Anda tentang
                        pendaftaran langganan atau akun Kami;
                    </li>
                    <li>
                        untuk menggunakan informasi Anda untuk berpartisipasi
                        dalam survei atau pertemuan Pengguna;
                    </li>
                    <li>
                        untuk memungkinkan Kami mengirimkan informasi kepada Anda
                        melalui surat elektronik (email), sarana telekomunikasi
                        (panggilan telepon atau pesan teks) atau media sosial
                        tentang produk dan layanan yang ditawarkan oleh pihak ketiga
                        terpilih yang menurut Kami mungkin menarik bagi Anda.
                    </li>
                </ul>
            </ol>
            <ol start="3" type="1">
                <li class="mt-2">
                    Untuk kegiatan usaha (bisnis) Kami:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        untuk memproses pembayaran, menanggapi permintaan Layanan
                        Pengguna;
                    </li>
                    <li>
                        untuk penelitian dan studi yang mungkin secara sukarela
                        membagikan Data Pribadi untuk berpartisipasi;
                    </li>
                    <li>
                        untuk operasi bisnis melakukan kegiatan akuntansi, audit,
                        penagihan, rekonsiliasi dan pengumpulan, termasuk
                        pemantauan dan pencegahan kejahatan atau penipuan, melindungi
                        hak-hak hukum Kami, dan melakukan kewajiban berdasarkan
                        suatu kesepakatan/kontrak/perjanjian.
                    </li>
                </ul>
            </ol>
            <ol start="4" type="1">
                <li class="mt-2">
                    Untuk fungsionalitas, pengembangan dan peningkatan produk dan
                    Layanan:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        memproses data termasuk namun tidak terbatas pada nomor
                        yang Pengguna hubungi, berapa banyak data yang Pengguna gunakan,
                        situs yang Pengguna kunjungi, dan kapan Pengguna
                        melakukannya sehingga Kami dapat menyediakan konektivitas,
                        mengukur tingkat penggunaan Layanan, mendiagnosis masalah
                        server, dan menyediakan fitur keamanan;
                    </li>
                    <li>
                        memanfaatkan Data Pribadi Pengguna terkait kebiasaan Pengguna dalam
                        menggunakan Layanan untuk memahami dan mengkategorikan Pengguna. Hasil
                        pemrosesan akan memungkinkan segmentasi dalam profil Pengguna yang dapat
                        digunakan oleh IOH;
                    </li>
                    <li>
                        termasuk untuk keperluan penelitian, pengujian,
                        modifikasi, peningkatan, dan/atau pengembangan Layanan Kami,
                        termasuk namun tidak terbatas melalui penggunaan teknologi baru
                        seperti <em>Artificial Intelligence</em> (AI). Pemrosesan
                        ini dilakukan untuk mengidentifikasi tren, pola, serta
                        meningkatkan kualitas Layanan secara berkelanjutan;
                    </li>
                    <li>
                        memanfaatkan Data Pribadi Pengguna mengenai kebiasaan
                        Pengguna dalam menggunakan Layanan untuk analisis lebih lanjut
                        dan menjalankan proses pemasaran yang lebih sejalan dengan
                        preferensi Pengguna;
                    </li>
                    <li>
                        memproses Data Pribadi Pengguna dalam konteks pencegahan terjadinya
                        penipuan dan untuk tujuan keamanan.
                    </li>

                </ul>
            </ol>
            <ol start="5" type="1">
                <li class="mt-2">
                    Untuk iklan dan pemasaran Layanan:
                </li>
            </ol>
            <ol start="1" type="1">
                <ul type="disc">
                    <li>
                        Kami dapat menggunakan lokasi fisik perangkat Anda,
                        dikombinasikan dengan informasi tentang iklan apa yang
                        Anda lihat dan informasi lain yang Kami kumpulkan, untuk
                        memungkinkan Kami menyediakan konten yang dipersonalisasi
                        dan untuk mempelajari efektivitas kampanye iklan dan
                        pemasaran.
                    </li>
                    <li>
                        Anda dapat memilih untuk mengizinkan atau menolak
                        penggunaan atau berbagi lokasi perangkat Anda dengan mengubah
                        pengaturan perangkat Anda, tetapi jika Anda memilih untuk
                        menolak penggunaan atau berbagi tersebut, Kami mungkin
                        tidak dapat memberi Anda Layanan dan konten IOH tertentu
                        yang dipersonalisasi.
                    </li>
                </ul>
            </ol>
        </li>
        <li class="mt-3">
            <strong><u>Bagaimana IOH membagikan dan mengungkapkan
                    Data Pribadi Anda?</u></strong>
            <p class="mt-2">
                Dalam hal dimungkinkan dan memiliki dasar pemrosesan yang sah, Kami berbagi
                informasi tentang Anda dengan antara lain:
            </p>
            <ol start="1" type="a">
                <li>
                    Perusahaan-perusahaan yang tergabung di kelompok usaha IOH
                    termasuk antara lain: afiliasi dan anak perusahaan (“<strong>Grup
                        IOH</strong>”) untuk membantu memberikan Layanan atau
                    melakukan pemrosesan dan/atau pengolahan data untuk dan atas nama
                    IOH.
                </li>
                <li>
                    Mitra, pemasok, agen yang terlibat dalam untuk keperluan
                    aktivasi Layanan sebelum Layanan diakses/digunakan oleh
                    Pengguna.
                </li>
                <li>
                    Mitra, pemasok, agen yang terlibat dalam pengiriman dan
                    penyediaan Layanan yang akan atau telah Anda akses, pesan atau
                    gunakan.
                </li>
                <li>
                    Perusahaan yang terlibat untuk melakukan Layanan untuk, atau
                    atas nama IOH, dan/atau Grup IOH.
                </li>
                <li>
                    Referensi kredit, agen pencegah penipuan atau penilaian
                    bisnis, atau agen penilaian kredit lainnya, termasuk
                    perbankan.
                </li>
                <li>
                    Agen penagih utang atau organisasi pemulihan utang lainnya.
                </li>
                <li>
                    Aparat penegak hukum, Kementerian/Lembaga Pemerintah,
                    organisasi regulator, pengadilan, atau otoritas publik lainnya
                    jika Kami harus, atau diizinkan oleh hukum.
                </li>
                <li>
                    Pihak ketiga atau suatu badan di mana pengungkapan tersebut
                    diperlukan dan diatur sesuai dengan ketentuan perundang –
                    undangan yang berlaku.
                </li>
                <li>
                    Layanan darurat (jika Anda melakukan panggilan darurat),
                    termasuk perkiraan lokasi Anda.
                </li>
                <li>
                    Pihak ketiga untuk keperluan promosi bersama. Pihak ketiga
                    tersebut akan bertanggung jawab atas kepatuhan mereka sendiri
                    terhadap undang-undang privasi yang berlaku
                </li>
                <li>
                    Pihak ketiga lainnya saat Anda mendaftar ke layanan mereka dan
                    digunakan oleh mereka untuk tujuan otentikasi dan pencegahan
                    penipuan melalui Kami, termasuk oleh lembaga keuangan berupa
                    bank atau non-bank.
                </li>
                <li>
                    Pihak ketiga yang beriklan dengan Kami untuk melayani Anda
                    (misalnya, antara lain: Facebook, Google, Twitter, Amazon),
                    dengan mempertimbangkan pemberitahuan privasi yang mungkin
                    berlaku khusus untuk layanan-layanan tersebut.
                </li>
            </ol>
        </li>
        <li class="mt-3">
            <strong><u>Penegakan Hukum, Fraud dan Keamanan</u></strong>
            <p class="mt-2">
                IOH dapat mengungkap Data Pribadi jika diperlukan untuk:
            </p>
            <ul type="circle">
                <li>
                    melindungi IOH dari fraud dan penyalahgunaan;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    mempertahankan hak dan aset IOH;
                </li>
            </ul>
            <ul type="circle">
                <li>
                    memenuhi kewajiban terkait keamanan nasional atau permintaan otoritas
                    berwenang.
                </li>
            </ul>
            <p class="mt-2">
                Pengungkapan hanya dilakukan berdasarkan evaluasi kepatuhan dan sepanjang
                dipersyaratkan/diizinkan oleh hukum.
            </p>
        </li>
        <li>
            <strong><u>Aksi Korporasi (Penggabungan, Penjualan, atau
                    Kepailitan)</u></strong>
            <p class="mt-2">
                Dalam hal terjadi aksi korporasi (antara lain: penggabungan/merger,
                akuisisi, pengalihan usaha, restrukturisasi atau perubahan kendali) IOH
                berhak untuk memindahtangankan atau mengalihkan Data Pribadi sebagai
                transaksi atau aksi korporasi tersebut.
            </p>
            <p>
                IOH akan memastikan pengalihan dilakukan sesuai ketentuan hukum dan, bila
                dipersyaratkan, melakukan pemberitahuan kepada Pengguna.
            </p>
        </li>
        <li>
            <strong><u>Pihak ketiga yang bekerja sama dengan IOH</u></strong>
            <p class="mt-2">
                Saat Anda membeli Layanan IOH menggunakan pihak ketiga atau mitra IOH, Kami
                sering perlu bertukar informasi dengan mereka sebagai bagian dari
                pengelolaan hubungan tersebut dan akun Anda, misalnya, agar dapat
                mengidentifikasi pesanan Anda dan dapat membayar mereka.
            </p>
            <p>
                Jika Kami memiliki kontrak dengan penyedia layanan atau kontraktor untuk
                memberi Kami layanan atau memberikan layanan atas nama Kami, dan mereka
                mungkin memiliki akses ke Data Pribadi Anda, Kami tidak mengizinkan mereka
                untuk menggunakan atau mengungkapkan Data Pribadi Anda kecuali sehubungan
                dengan penyediaan layanan mereka. <br />
                Kami mengumpulkan dan menggabungkan informasi untuk memantau penggunaan
                produk dan layanan Anda, dan Pengguna Kami yang lain, serta untuk membantu
                Kami meningkatkan kualitas Layanan Kami.
            </p>
        </li>
        <li>
            <strong>
                <u>Produk pihak ketiga yang Anda beli melalui akun myIM3, bima+, Indosat
                    Digital Ecosystem (IDE) atau aplikasi maupun platform IOH lainnya</u>
            </strong>
            <p class="mt-2">
                Saat Anda membeli produk atau layanan pihak ketiga melalui akun Anda pada
                myIM3, bima+, IDE, atau aplikasi maupun platform IOH lainnya, Anda setuju
                bahwa IOH dapat memberikan Data Pribadi tertentu kepada pihak-pihak yang
                bekerja sama dengan IOH untuk melayani Anda atau menyelesaikan pembelian
                Anda melalui aplikasi maupun platform tersebut.
            </p>
        </li>
        <li>
            <strong><u>Transfer Data Pribadi ke Luar Wilayah Hukum
                    Republik Indonesia</u></strong>
            <p class="mt-2">
                Kami mungkin perlu mentransfer informasi Anda ke perusahaan Grup IOH lain
                atau penyedia layanan di negara-negara di luar wilayah hukum Indonesia.
                Transfer data semacam ini dapat terjadi jika server Kami (yaitu tempat Kami
                menyimpan data) berbasis di luar wilayah hukum Indonesia, atau jika Anda
                menggunakan Layanan Kami saat mengunjungi negara di luar wilayah hukum
                Indonesia.
            </p>
            <p>
                Jika IOH mengirimkan informasi Anda ke luar wilayah hukum Indonesia, Kami
                akan memastikan bahwa informasi Anda terlindungi dengan baik. Kami akan
                selalu memastikan bahwa negara tempat pihak ketiga berbasis memiliki tingkat
                pelindungan Data Pribadi yang setara atau lebih tinggi dari Indonesia, atau
                pihak ketiga yang akan menerima Data Pribadi Anda memiliki standard
                pelindungan Data Pribadi yang memadai dan bersifat mengikat, atau
                sekurang-kurangnya mendapatkan persetujuan dari Anda untuk melakukan
                transfer Data Pribadi Anda.
            </p>
        </li>
        <li>
            <strong><u>Keamanan Data Pribadi</u></strong>
            <p class="mt-2">
                IOH menerapkan langkah-langkah pengamanan teknis dan organisasi yang wajar
                untuk melindungi Data Pribadi Anda.
            </p>
            <p>
                IOH tidak bertanggung jawab atas akses tidak sah atau kehilangan Data
                Pribadi yang terjadi akibat keadaan di luar kendali wajar IOH (termasuk
                tindakan pihak ketiga yang melanggar hukum), sepanjang IOH telah menerapkan
                langkah pengamanan yang sesuai. <br />
                <br />
            </p>
            <p>
                Anda bertanggung jawab untuk menjaga keamanan Data Pribadi dan akun Anda dan
                tidak membaginya dengan orang lain.
            </p>
        </li>
        <li>
            <strong><u>Pengambilan Keputusan Otomatis dan Profiling</u></strong>
            <p class="mt-2">
                Dalam kondisi tertentu, IOH dapat melakukan pemrosesan otomatis termasuk
                profiling untuk pencegahan fraud/kejahatan, rekomendasi layanan, dan/atau
                penilaian risiko tertentu.
            </p>
            <p>
                Keputusan otomatis adalah keputusan mengenai Anda yang dibuat secara
                otomatis berdasarkan hasil keputusan komputer (menggunakan algoritma
                perangkat lunak), tanpa adanya ulasan yang berasal dari manusia dimana
                keputusan tersebut memiliki pengaruh hukum atau pengaruh signifikan lainnya.
                Kami menggunakan analisis otomatis untuk membuat prediksi seperti jenis
                Layanan yang Anda minati, atau pengambilan keputusan otomatis untuk mencegah
                pencurian, penipuan, atau kejahatan lainnya. Solusi kecerdasan buatan yang
                diberikan oleh IOH dapat mengarah pada pemrosesan data secara otomatis di
                berbagai bidang.
            </p>
            <p>
                Apabila keputusan otomatis menimbulkan akibat hukum atau berdampak
                signifikan bagi Anda, IOH akan menerapkan langkah perlindungan yang
                diperlukan sesuai peraturan, termasuk menyediakan mekanisme peninjauan
                (review) bila dipersyaratkan oleh peraturan perundang-undangan yang berlaku.
            </p>
        </li>
        <li>
            <strong><u>Anak-anak</u></strong>
            <p class="mt-2">
                Apabila Anda berusia di bawah 18 tahun, maka Anda wajib mendapatkan
                persetujuan orang tua atau wali Anda yang sah sesuai dengan peraturan
                perundang-undangan yang berlaku sebelum menggunakan Layanan.
            </p>
        </li>
        <li>
            <strong><u>Penyimpanan (Retensi) Data Pribadi</u></strong>
            <p class="mt-2">
                Data Pribadi yang telah dikumpulkan dan akan disimpan selama jangka waktu
                diperlukan untuk memenuhi tujuan yang disebutkan di atas. Kami dapat
                menyimpan Data Pribadi Anda untuk menyediakan Layanan yang Anda minta, atau
                untuk tujuan penting lainnya, seperti mematuhi kewajiban hukum Kami,
                menyelesaikan sengketa, dan melaksanakan kebijakan-kebijakan Kami. Periode
                penyimpanan Data Pribadi didasarkan pada persyaratan hukum yang berlaku.
                Namun, jika tidak ada undang-undang yang relevan, Data Pribadi akan disimpan
                selama waktu yang diperlukan untuk tujuan bisnis.
            </p>
            <p>
                Data Pribadi ini dapat disimpan dalam bentuk salinan cetak, atau format
                elektronik.
            </p>
            <p>
                Kami dapat menyimpan data Anda di pusat data atau gudang yang dikelola baik
                oleh Kami atau oleh penyedia layanan atas nama Kami. Semua fasilitas,
                sistem, dan produk Kami telah dilengkapi dengan kontrol keamanan yang
                diperlukan untuk memastikan perlindungan Data Pribadi.
            </p>
            <p>
                Periode penyimpanan dapat sangat bervariasi berdasarkan jenis informasi dan
                cara penggunaannya dan periode penyimpanan Kami didasarkan pada kriteria
                yang mencakup periode penyimpanan yang dipersyaratkan secara hukum, proses
                pengadilan yang tertunda atau potensial, kekayaan intelektual atau hak
                kepemilikan Kami, persyaratan berdasarkan perjanjian/kontrak, arahan atau
                kebutuhan operasional, dan pengarsipan sejarah. Ketika Data Pribadi dihapus
                dari sistem Kami, data tersebut akan dihapus atau dihancurkan menggunakan
                protokol keamanan yang sesuai sehingga tidak dapat direkonstruksi atau
                dibaca.
            </p>
            <p>
                IOH akan menyimpan Data Pribadi sesuai prinsip pembatasan penyimpanan
                (storage limitation), yaitu hanya selama diperlukan untuk tujuan pemrosesan,
                atau selama diwajibkan oleh peraturan perundang-undangan, setelah itu akan
                dihapus atau dimusnahkan secara aman.
            </p>
        </li>
        <li>
            <strong><u>Hak Anda sebagai Subyek Data</u></strong>
            <p class="mt-2">
                <a name="_Hlk215660037">
                    Di bawah ini Kami menjelaskan detail tentang bagaimana Anda dapat
                    menggunakan hak Anda. Jika Anda memiliki pertanyaan atau tidak dapat
                    menemukan jawabannya, silakan hubungi tim layanan pelanggan Kami.
                </a>
            </p>
            <p>
                Kami berhak menolak permintaan Anda untuk mengakses, memperbaiki dan/atau
                menghapus, sebagian atau seluruh Data Pribadi Anda yang Kami kuasai, jika
                diizinkan atau diharuskan berdasarkan Peraturan Perundang-undangan yang
                berlaku, terutama jika permintaan tersebut dapat berdampak mengenai hal-hal
                seperti namun tidak terbatas pada:
            </p>
            <ol start="1" type="a">
                <li>
                    membahayakan keselamatan, kesehatan fisik atau mental Anda
                    dan/atau orang lain; dan/atau
                </li>
                <li>
                    ada dampak pengungkapan Data Pribadi orang lain; dan/atau
                </li>
                <li>
                    bertentangan dengan kepentingan pertahanan dan keamanan negara
                    dan/atau
                </li>
                <li>
                    alasan permintaan tidak relevan bagi Anda dan/atau aktivitas
                    pemrosesan Data Pribadi yang Kami lakukan.
                </li>
            </ol>
            <p class="mt-2">
                Kami mungkin dapat membebankan biaya administrasi untuk setiap permintaan
                Anda sesuai dengan hukum dan peraturan yang berlaku.
            </p>
            <p>
                <u>Hak untuk mengakses Data Pribadi</u> <u></u>
            </p>
            <p>
                Anda berhak untuk meminta salinan Data Pribadi yang dimiliki IOH tentang
                Anda. Untuk mengajukan permintaan ini sebagai individu atau pihak ketiga
                yang berwenang, Anda dapat kunjungi bagian “<strong>Hubungi Kami</strong>”
                yang memberikan perincian tentang cara melakukannya. Atau, Anda dapat
                menghubungi tim layanan pelanggan Kami.
            </p>
            <p>
                <u>Hak untuk mengoreksi Data Pribadi</u> <u></u>
            </p>
            <p>
                Anda memiliki hak untuk memperbaiki informasi yang dimiliki tentang Anda
                jika informasi tersebut tidak akurat. Jika informasi yang Kami miliki
                tentang Anda tidak akurat atau perlu diperbarui, Anda dapat menghubungi tim
                layanan pelanggan Kami. Anda dianjurkan untuk aktif dalam memastikan
                keakuratan dan pemutakhiran data Anda dari waktu ke waktu.
            </p>
            <p>
                <u>Hak untuk portabilitas data</u> <u></u>
            </p>
            <p>
                Anda berhak untuk membawa dan mengirimkan Data Pribadi yang Anda berikan
                kepada Kami ke pihak lainnya atau ke pengendali Data Pribadi lainnya,
                sepanjang sistem yang digunakan dapat saling berkomunikasi secara aman
                sesuai regulasi, misalnya dengan memungkinkan Anda untuk mengintegrasikan
                data Anda dengan platfrom pihak ketiga yang bekerja sama dengan Kami atau
                memungkinkan Anda untuk mengunduh tagihan bulanan Anda melalui saluran resmi
                Kami dengan struktur dan/atau format yang lazim digunakan.
            </p>
            <p>
                <u>Hak untuk menolak penggunaan Data Pribadi</u> <u></u>
            </p>
            <p>
                Anda berhak, dalam keadaan tertentu, untuk menolak IOH memproses Data
                Pribadi Anda. Untuk informasi lebih lanjut atau untuk menggunakan hak ini,
                silakan hubungi layanan pelanggan IOH. Jika hal ini berkaitan dengan
                keputusan otomatis yang dilakukan pada Anda (artinya tanpa keterlibatan
                manusia), Anda tetap dapat memberi tahu Kami dan Kami akan meninjau
                permintaan Anda terlebih dahulu.
            </p>
            <p>
                <u>Hak untuk menarik kembali persetujuan penggunaan Data Pribadi</u> <u></u>
            </p>
            <p>
                Anda berhak, dalam keadaan tertentu, menarik kembali persetujuan atas
                pemrosesan Data Pribadi yang sebelumnya Anda berikan dengan cara menghubungi
                layanan pelanggan IOH. <br />
                Namun, tidak tersedianya informasi Data Pribadi Anda menyebabkan Kami
                menjadi tidak dapat melakukan verifikasi dan memproses pembelian Anda,
                sehingga Anda mungkin menjadi tidak dapat menggunakan Layanan tertentu.
            </p>
            <p>
                Jika Anda tetap ingin menggunakan Layanan Kami, maka Anda hanya dapat
                menarik sebagian persetujuan penggunaan Data Pribadi yang tidak digunakan
                untuk menyediakan Layanan kepada Anda.
            </p>
            <p>
                Penarikan persetujuan tidak mempengaruhi keabsahan pemrosesan Data Pribadi
                Anda yang telah dilakukan sebelum persetujuan tersebut ditarik.
            </p>
            <p>
                <u>Hak untuk membatasi penggunaan data Anda</u> <u></u>
            </p>
            <p>
                Jika Anda merasa data yang Kami simpan tentang Anda tidak akurat, atau Anda
                yakin Kami seharusnya tidak memproses Data Pribadi Anda, silakan hubungi tim
                layanan pelanggan Kami untuk mendiskusikan hak Anda. Dalam keadaan tertentu,
                Anda berhak meminta Kami membatasi pemrosesan.
            </p>
            <p>
                <u>Hak untuk menghapus data Anda</u> <u></u>
            </p>
            <p>
                IOH berusaha untuk hanya memproses dan menyimpan data Anda selama Kami
                membutuhkannya. Dalam keadaan tertentu Anda memiliki hak untuk meminta Kami
                menghapus Data Pribadi Anda yang Kami pegang. Jika Anda merasa bahwa Kami
                menyimpan data Anda lebih lama dari yang Kami butuhkan, ada baiknya terlebih
                dahulu memeriksa apakah kontrak berlangganan Anda dengan IOH telah berakhir,
                yang dapat Anda lakukan melalui tim layanan pelanggan. Jika kontrak Anda
                dengan IOH telah berakhir, Kami mungkin masih memiliki alasan yang sah untuk
                memproses Data Pribadi Anda. Untuk informasi lebih lanjut tentang periode
                penyimpanan, lihat bagian dalam pemberitahuan privasi ini yang berjudul
                Penyimpanan (Retensi)
            </p>
        </li>
        <li>
            <strong><u>Opt-Out Pemasaran:</u></strong>
            <p class="mt-2">
                Jika Anda tidak lagi ingin menerima informasi pemasaran dari IOH, Anda dapat
                memilih untuk tidak menerimanya kapan saja. Jika sebelumnya Anda memilih
                untuk menerima konten yang dipersonalisasi berdasarkan bagaimana dan dimana
                Anda menggunakan jaringan Kami, Anda juga dapat memilih untuk tidak
                menerimanya kapan saja.
            </p>
            <p>
                Adapun cara untuk melakukan <em>opt-out</em> atas aktivitas pemasaran adalah
                dengan cara menghubungi tim layanan pelanggan Kami dan mekanisme lainnya
                yang Kami sediakan dari waktu ke waktu.
            </p>
            <p>
                Jika Anda memilih untuk <em>opt-out</em>, Anda mungkin masih menerima pesan
                terkait layanan.
            </p>
            <p>
                Harap diketahui bahwa Anda mungkin masih menerima pesan penawaran untuk 7x
                24 jam setelah memilih <em>opt-out.</em>Hal ini dapat disebabkan oleh waktu
                yang diperlukan oleh Kami untuk memperbarui <em>database</em> Kami.
            </p>
            <p>
                Anda juga mungkin telah menerima informasi pemasaran dari IOH meskipun Anda
                bukan Pengguna atau tidak pernah berhubungan dengan Kami. Ini adalah hasil
                dari daftar pihak ketiga yang dapat diperoleh IOH dari waktu ke waktu, yang
                menyatakan bahwa Anda telah memberikan izin untuk dihubungi oleh pihak
                tertentu lain.
            </p>
            <p>
                Jika Anda telah mendaftar dengan Kami untuk memilih <em>opt-out</em> dari
                informasi pemasaran IOH, Anda tidak boleh menerima komunikasi tersebut. Jika
                Anda masih menerimanya, Kami meminta Anda segera memberi tahu Kami dengan
                menghubungi tim layanan pelanggan Kami. Ini hanya akan menghentikan
                informasi pemasaran dari Kami dan tidak menghentikan pihak ketiga membagikan
                data Anda kecuali Anda menghubungi mereka secara langsung.
            </p>
        </li>
        <li>
            <strong><u>Bagaimana cara mengajukan keluhan</u></strong>
            <p class="mt-2">
                Jika Anda ingin menghubungi Kami tentang pelaksanaan hak Anda atau
                mengajukan keluhan tentang cara Kami menggunakan Data Pribadi Anda, Anda
                dapat menghubungi layanan pelanggan IOH melalui kanal resmi.
            </p>
            <p>
                IOH akan menindaklanjuti permintaan Anda dalam jangka waktu yang wajar
                sesuai ketentuan peraturan perundang-undangan yang berlaku.
            </p>
        </li>
        <li>
            <strong><u>Insiden Pelindungan Data Pribadi</u></strong>
            <p class="mt-2">
                Dalam hal terjadi insiden pelindungan Data Pribadi, IOH akan melakukan
                penanganan insiden sesuai prosedur internal dan ketentuan peraturan
                perundang-undangan yang berlaku, termasuk melakukan pemberitahuan kepada
                pihak-pihak yang dipersyaratkan.
            </p>
        </li>
        <li>
            <strong><u>Hukum Yang Berlaku</u></strong>
            <p class="mt-2">
                Pemberitahuan Privasi ini tunduk pada hukum Negara Republik Indonesia.
            </p>
            <p>
                Pemberitahuan Privasi ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris.
                Apabila terdapat perbedaan atau pertentangan di antara versi Bahasa
                Indonesia dan Bahasa Inggris, Bahasa Indonesia akan diberlakukan dan versi
                Bahasa Inggris akan dianggap telah berubah untuk menyesuaikan dengan versi
                Bahasa Indonesia.
            </p>
        </li>
        <li>
            <strong><u>Perubahan Pemberitahuan Privasi</u></strong>
            <p class="mt-2">
                IOH dapat mengubah atau memperbaharui Pemberitahuan Privasi ini setiap waktu
                dengan mempublikasikannya pada situs, aplikasi dan Layanan terkait.
            </p>
            <p>
                Pengguna diharapkan untuk membaca dengan seksama dan melakukan pengecekan
                atas laman Pemberitahuan Privasi ini dari waktu ke waktu untuk mengetahui
                setiap perubahan yang dilakukan IOH atas Pemberitahuan Privasi ini. Dengan
                mengakses dan menggunakan situs, aplikasi, atau layanan IOH lainnya,
                Pengguna setuju untuk menyetujui perubahan atas Pemberitahuan Privasi.
            </p>
        </li>
        <li>
            <strong><u>Pengakuan dan Persetujuan</u></strong>
            <ol start="1" type="a">
                <li>
                    Anda menjamin bahwa segala data yang diberikan dalam bentuk
                    tertulis maupun bentuk lainnya untuk menggunakan Layanan
                    adalah benar milik Anda dan tidak berasal dari pihak ketiga tanpa
                    dasar yang sah, sehingga segala hal yang timbul sehubungan dengan
                    pemberian dan kebenaran data-data tersebut menjadi tanggung jawab
                    penuh dari Anda.
                </li>
                <li>
                    Dengan menyetujui Pemberitahuan Privasi ini, Anda mengakui
                    bahwa Anda telah membaca, memahami dan menyetujui Pemberitahuan
                    Privasi ini. Secara khusus, Anda setuju dan memberikan izin kepada
                    Kami untuk melakukan pengumpulan, pemrosesan, analisis,
                    penyimpanan, pengungkapan, koreksi, dan penghapusan Data
                    Pribadi Anda sesuai dengan Pemberitahuan Privasi ini.
                </li>
                <li>
                    Jika Anda berada di bawah persyaratan usia minimum atau
                    termasuk dalam kategori anak-anak sesuai dengan ketentuan
                    peraturan perundang-undangan yang berlaku, maka persetujuan atas
                    pemrosesan Data Pribadi Anda harus diberikan oleh orang tua
                    (ayah atau ibu) atau wali Anda sesuai dengan peraturan yang
                    berlaku.
                </li>
            </ol>
        </li>
    </ol>
    <p>
        <strong>Pembaharuan terakhir: 08 Januari 2026</strong>
    </p>



    <!-- <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        KEBIJAKAN PRIVASI</h1>
    <p>Kebijakan&nbsp;<strong>Privasi</strong>&nbsp;ini merupakan kebijakan PT Indosat Tbk (&ldquo;<strong>Indosat
            Ooredoo Hutchison</strong>&rdquo; atau &ldquo;<strong>IOH</strong>&rdquo; atau
        &ldquo;<strong>Kami</strong>&rdquo;) dalam penanganan&nbsp;<strong>informasi</strong>&nbsp;dan data pengguna
        situs, aplikasi, platform, produk dan layanan IOH. IOH menghargai dan&nbsp;<strong>melindungi</strong>&nbsp;data
        dan informasi pribadi (&ldquo;<strong>Data Pribadi</strong>&rdquo;) pengguna situs, aplikasi, platform, produk
        dan&nbsp;<strong>layanan lainnya</strong>&nbsp;dari IOH
        (&ldquo;<strong>Pengguna</strong>&rdquo;&nbsp;<strong>atau</strong>&nbsp;&ldquo;<strong>Anda</strong>&rdquo;).
    </p>
    <p>Kebijakan Privasi ini menetapkan dasar dan syarat ketentuan yang berlaku untuk pemerolehan, pengumpulan,
        pengolahan, penganalisisan, penyimpanan, perbaikan, pembaharuan, penampilan, pengumuman, pengiriman,
        penyebarluasan, pengungkapan, dan/atau pembukaan akses, penghapusan dan pemusnahan yang terkait dengan Data
        Pribadi yang diberikan oleh Pengguna kepada IOH atau yang dikumpulkan oleh IOH dari Pengguna baik pada saat
        Pengguna menggunakan setiap produk dan layanan Kami, mengunjungi, mengakses, maupun menggunakan layanan daring
        aplikasi, platform, situs web, peralatan perangkat lunak, layanan dan fungsi lain yang disediakan IOH, atau
        mengunjungi, mengakses ataupun menggunakan produk dan layanan resmi lainnya yang ditawarkan atau diselenggarakan
        oleh IOH (selanjutnya secara bersama-sama disebut sebagai &ldquo;<strong>Layanan</strong>&rdquo;). Data Pengguna
        adalah data pribadi Pengguna dan informasi lain yang jika digabungkan dengan informasi lainya dapat
        mengidentifikasi Pengguna.</p>
    <p>Kebijakan Privasi ini berlaku atas semua Data Pribadi yang Kami kumpulkan, dapatkan atau gunakan pada saat Anda
        menggunakan produk/Layanan Kami kecuali apabila suatu kebijakan privasi terpisah atau tambahan ditawarkan untuk
        produk dan layanan tersebut. Kami menyarankan Anda untuk membaca Kebijakan Privasi ini bersama dengan Syarat dan
        Ketentuan produk/Layanan Kami karena dokumen tersebut memiliki kemungkinan berisi informasi khusus produk atau
        layanan tentang cara Kami memproses Data Pribadi Anda.&nbsp;</p>
    <p>Kebijakan Privasi ini berlaku untuk seluruh Layanan, dan terhadap Pengguna, seluruh Pengguna Layanan dan calon
        Pengguna IOH.</p>
    <p><strong><u>Bagaimana IOH mengumpulkan Data Pribadi Anda?&nbsp;</u></strong></p>
    <p>Data yang Kami kumpulkan tentang Anda dan bagaimana Kami mengumpulkannya dapat bervariasi tergantung pada jenis
        Layanan Kami yang Anda akses atau gunakan, bagaimana Anda menggunakan produk dan Layanan Kami, dan bagaimana
        Anda berinteraksi dengan IOH meskipun Anda bukan Pengguna, atau apa yang telah Kami peroleh dari pihak ketiga
        dengan izin untuk membaginya dengan Kami.</p>
    <p>IOH akan memproses Data Pribadi Anda berdasarkan:</p>
    <ul>
        <li>Pemenuhan kewajiban perjanjian dalam hal Anda merupakan salah satu pihak atau untuk memenuhi permintaan
            Anda pada saat akan melakukan perjanjian.</li>
    </ul>
    <ul>
        <li>Pemenuhan kepentingan yang sah lainnya dengan memperhatikan tujuan, kebutuhan, dan keseimbangan
            kepentingan IOH dan Anda. Misalnya kepentingan untuk menghindari&nbsp;<em>fraud</em>, menjaga keamanan
            jaringan dan layanan Kami, pemasaran secara langsung, dan peningkatan layanan Kami. Setiap kali IOH
            menggunakan dasar hukum ini untuk memproses data Anda, Kami menilai kepentingan bisnis Kami untuk
            memastikan kepentingan tersebut tidak mengesampingkan hak Anda.</li>
    </ul>
    <ul>
        <li>Pemenuhan kewajiban hukum dari IOH sesuai dengan ketentuan peraturan perundang-undangan, misalnya
            kebutuhan untuk proses penyidikan, pelaporan kepada regulator, dan pemenuhan kewajiban lainnya yang
            diatur secara ketat oleh ketentuan perundang-undangan.</li>
    </ul>
    <ul>
        <li>Pelaksanaan tugas dalam rangka kepentingan umum, pelayanan publik, atau pelaksanaan kewenangan IOH
            berdasarkan peraturan perundang-undangan. Misalnya untuk membantu mendeteksi dan mencegah penipuan,
            penggelapan pajak dan kejahatan keuangan, dll.</li>
    </ul>
    <ul>
        <li>Persetujuan yang sah secara eksplisit dari Anda terhadap pemrosesan Data Pribadi yang dilakukan IOH.
            Persetujuan yang sah dari Anda dapat berupa persetujuan yang sifatnya wajib (<em>mandatory</em>) dan
            persetujuan yang sifatnya opsional. Persetujuan yang sifatnya wajib (<em>mandatory) </em>adalah
            pemrosesan yang terkait dengan&nbsp;<em>billing</em>&nbsp;dan<em>&nbsp;routing</em>&nbsp;agar Anda dapat
            melakukan panggilan, SMS, serta layanan data maupun internet |di ponsel Anda, Kami memproses hal-hal
            seperti nomor yang Anda hubungi, berapa banyak data yang Anda gunakan, situs yang Anda kunjungi, dan
            kapan Anda melakukannya sehingga Kami dapat menyediakan konektivitas. Hal tersebut diperlukan agar
            memungkinkan Kami membuat tagihan Anda, berdasarkan penggunaan Anda. Kami juga perlu melakukan
            pemeriksaan kredit limit pascabayar atau sisa deposit atau kredit prabayar saat Anda mengajukan
            permohonan untuk suatu produk atau layanan.</li>
    </ul>
    <ul>
        <li>pemenuhan kepentingan yang sah lainnya dengan memperhatikan tujuan, kebutuhan, dan keseimbangan
            kepentingan IOH dan hak Pengguna.</li>
    </ul>
    <p>IOH mengumpulkan dan menggunakan Data Pribadi Anda dengan sepengetahuan dan persetujuan Anda dan biasanya pada
        saat Anda:&nbsp;</p>
    <ul>
        <li>membeli atau menggunakan berbagai produk dan Layanan</li>
        <li>menggunakan jaringan Kami dan/atau Layanan</li>
        <li>mendaftar untuk Layanan</li>
        <li>mengajukan pertanyaan Pengguna, daftar untuk mendapatkan informasi atau layanan lainnya</li>
        <li>menanggapi komunikasi dari Kami (seperti SMS, surat elektronik (email), kuesioner atau survei)</li>
        <li>berinteraksi dengan situs IOH, seperti mengirimkan formulir aplikasi, mengisi formulir survei,
            menggunakan layanan online. (Apabila browser Anda mengaktifkan cookie internet, hal tersebut dapat
            memfasilitasi IOH untuk melakukan pelacakan preferensi pribadi, halaman yang dikunjungi, dan lainnya)
        </li>
        <li>berpartisipasi di halaman aplikasi IOH dan media sosial IOH, seperti Facebook, Instagram, Twitter,
            LinkedIn, dan lainnya</li>
        <li>berpartisipasi dalam acara promosi, insentif, program loyalitas IOH, atau pengundian hadiah</li>
        <li>Anda telah memberikan persetujuan kepada perusahaan lain untuk membagi informasi tentang Anda</li>
        <li>dimana informasi tentang Anda tersedia untuk umum</li>
        <li>dimana Anda adalah pelanggan dari perusahaan yang Kami akuisisi atau perusahaan yang terlibat dalam
            suatu aksi korporasi Kami</li>
        <li>memberikan informasi melalui pusat panggilan Pengguna, retailer, dealer, dan saluran penjualan atau
            melalui afiliasi atau transaksi bisnis lainnya dengan IOH dimana Anda telah menyetujui untuk memberikan
            Data Pribadi Anda.&nbsp;<strong>&nbsp;</strong></li>
    </ul>
    <p>Kami juga mengumpulkan informasi dari organisasi tertentu, jika sesuai dan sejauh Kami memiliki dasar hukum atau
        kepentingan untuk melakukannya. Ini termasuk lembaga pencegahan penipuan, direktori bisnis, lembaga
        referensi/pemeriksaan pemeriksaan kredit, lembaga penghitungan tagihan, dan penyedia jaringan yang terhubung.
    </p>
    <p>Kami juga dapat mengumpulkan informasi tentang Anda melalui perangkat CCTV yang terpasang pada saat Anda
        mengunjungi lokasi-lokasi Kami, atau melalui kamera keamanan lain sebagai bagian dari tindakan keamanan dan
        pencegahan kejahatan Kami.</p>
    <p><strong><u>Apa saja Data Pribadi Anda yang dikumpulkan oleh IOH?</u></strong></p>
    <p>Jenis-jenis informasi Data Pribadi yang IOH kumpulkan termasuk, namun tidak terbatas pada:</p>
    <ul>
        <li>Informasi kontak (misalnya, antara lain: nama, alamat, alamat surat elektronik (e-mail) dan nomor
            telepon) yang pada dasarkan dibutuhkan untuk menghubungi Penguna sehubungan dengan produk, layanan dan
            tujuan-tujuan lain dari pemrosesan data berdasarkan Kebijakan Privasi ini.</li>
    </ul>
    <ul>
        <li>Informasi identifikasi individual (misalnya, antara lain: &nbsp;Kartu Tanda Penduduk (KTP/e-KTP), nomor
            paspor, Nomor Pokok Wajib Pajak (NPWP), atau data Badan Penyelenggara Jaminan Sosial (BPJS), Surat Izin
            Mengemudi (SIM), dan tanggal lahir).</li>
    </ul>
    <ul>
        <li>Informasi demografis (misalnya, antara lain: rentang usia, status perkawinan, jenis kelamin).</li>
    </ul>
    <ul>
        <li>Foto, seperti foto-foto yang Anda kirimkan untuk kontes atau kompetisi memenangkan hadiah.</li>
    </ul>
    <ul>
        <li>Informasi spesifik produk (misalnya, antara lain: preferensi, closed user groups (CUGs), teman dan
            keluarga yang Anda pilih untuk disertakan dalam paket layanan Anda, batas kredit).</li>
    </ul>
    <ul>
        <li>Data trafik Anda sebagai bagian dari penyediaan konektivitas untuk Anda, misalnya, antara lain: nomor
            yang Anda hubungi, waktu dan durasi panggilan, atau cara Anda menggunakan data.</li>
    </ul>
    <ul>
        <li>Informasi perbankan (misalnya, antara lain: debit langsung dan transaksi perbankan pembayaran tagihan
            yang terkait).</li>
    </ul>
    <ul>
        <li>Informasi akun layanan (misalnya, antara lain: data penggunaan panggilan, saldo akun, riwayat transaksi,
            informasi kredit, penagihan, poin loyalitas).</li>
    </ul>
    <ul>
        <li>Kontak Anda dengan Kami (misalnya, antara lain: catatan atau rekaman panggilan yang Anda lakukan ke
            salah satu pusat kontak Kami,&nbsp;<em>fitur live chat</em>, email atau surat yang dikirim, atau catatan
            lain dari kontak apa pun dengan Kami).</li>
    </ul>
    <ul>
        <li>Informasi kredensial &ndash; Kami akan mengumpulkan kata sandi, petunjuk, dan informasi keamanan serupa
            yang digunakan untuk autentikasi dan akses ke akun dan Layanan.</li>
    </ul>
    <ul>
        <li>Informasi yang Kami peroleh dari sumber lain (misalnya, antara lain: agen kredit, agen pencegahan
            penipuan, perbankan, dan pihak lainnya yang bekerjasama dengan Kami. Ini termasuk data demografis, data
            berbasis minat, dan perilaku penelusuran internet, dll.</li>
    </ul>
    <ul>
        <li>Dalam beberapa kasus (jika dan sepanjang diizinkan oleh hukum yang berlaku), kategori khusus dari Data
            Pribadi atau Data Pribadi terkait dengan hukuman dan pelanggaran pidana. Kategori khusus dari Data
            Pribadi mencakup informasi yang mengungkap asal ras atau etnis, opini politik, keyakinan agama atau
            filosofis, keanggotaan serikat pekerja, data terkait kesehatan atau data terkait kehidupan seks atau
            orientasi seksual seseorang. Misalnya, Kami dapat mengumpulkan data kesehatan Anda saat menilai situasi
            Anda untuk memfasilitasi aktivitas pemulihan utang, memberikan dukungan tambahan, atau saat menyediakan
            komunikasi Kami dalam format yang dapat diakses.</li>
    </ul>
    <ul>
        <li>Jenis dan versi sistem operasi, versi perangkat keras, pengaturan perangkat, jenis perangkat lunak,
            kekuatan baterai dan sinyal, resolusi layer, identitas perangkat (International Mobile Equipment
            Identity), produsen dan model, bahasa, serta jenis dan versi browser internet. Nama dan versi Layanan
            (seperti aplikasi) yang Anda gunakan juga Kami kumpulkan.&nbsp;</li>
    </ul>
    <ul>
        <li>Informasi lokasi geografis, seperti lokasi yang didapatkan dari alamat IP atau GPS Anda, Base Station,
            sinyal Bluetooh atau Wi-Fi, satelit, menara telekomunikasi dan informasi tentang bagaimana Anda terlibat
            dengan dan menggunakan Layanan, sebagai contoh pada saat Anda memilih untuk mengaktifkan layanan
            mengaktifkan-lokasi pada perangkat yang Anda gunakan untuk mengakses layanan tersebut.</li>
    </ul>
    <ul>
        <li>Beberapa Layanan Kami memungkinkan Anda menggunakan informasi biometrik untuk melakukan identifikasi
            atau otentikasi atau untuk memanfaatkan fitur-fitur tertentu. Data biometrik dapat mencakup sidik jari,
            suara, audio, video, atau karakteristik fisik unik serupa.</li>
    </ul>
    <ul>
        <li>Kami mengumpulkan informasi dari dan tentang berbagai macam teknologi dimana Layanan digunakan. Jenis
            informasi yang dikumpulkan tergantung pada teknologi, penggunaan, dan perangkat serta pengaturan
            pribadi. Contoh dari teknologi ini bisa berupa komputer, telepon dan tablet, juga perangkat yang dapat
            digunakan secara interaktif, teknologi yang terhubung di rumah atau kendaraan lain.</li>
    </ul>
    <p><strong><u>Bagaimana IOH menggunakan Data Pribadi Anda?</u></strong></p>
    <p>Data Pribadi Anda dapat dikumpulkan, digunakan, dan/atau diproses oleh Kami untuk, antara lain, tujuan berikut:
    </p>
    <ol>
        <li>Untuk menyediakan informasi dan Layanan beserta manfaat dan perubahan yang terjadi dari Layanan Kami
            ataupun pihak-pihak yang bekerja sama dengan Kami, kepada Anda:&nbsp;</li>
        <ul>
            <li>untuk menyediakan produk, layanan, dan penawaran Kami atau pihak ketiga yang bekerjasama dengan
                Kami, yang mungkin menarik bagi Anda</li>
            <li>menyediakan informasi dan penawaran terkait produk gaya hidup yang mungkin bermanfaat bagi
                Pengguna;untuk memberi tahu Anda tentang manfaat dan perubahan pada fitur Layanan Kami</li>
            <li>untuk memberikan penawaran, kampanye, dan promosi terbaru Kami kepada Anda (di mana Anda
                berlangganan pembaruan tersebut)</li>
            <li>menyediakan informasi dan penawaran produk non-seluler kepada Pengguna, seperti Layanan Tambah Nilai
                (Value-Added Service/VAS), teknologi keuangan, broadband rumah, <em>Internet of Things (IoT)</em>,
                dan
                produk digital/enterprise lainnya;</li>
            <li>untuk memahami bagaimana Anda berinteraksi dengan Layanan dan memberi Anda pengalaman terbaik</li>
            <li>untuk memberi Anda keamanan, versi, fitur, opsi, dan kontrol terbaru yang terkait dengan sistem atau
                perangkat Anda.</li>
        </ul>
        <p>&nbsp;</p>
        <li>Untuk berkomunikasi dengan Anda atau pihak yang datanya Anda berikan melalui Layanan:&nbsp;</li>
        <ul>
            <li>untuk mengirimkan pesan layanan kepada Anda tentang pendaftaran langganan atau akun Kami</li>
            <li>untuk menggunakan informasi Anda untuk berpartisipasi dalam survei atau pertemuan Pengguna</li>
            <li>untuk memungkinkan Kami mengirimkan informasi kepada Anda melalui surat elektronik (email),
                sarana
                telekomunikasi (panggilan telepon atau pesan teks) atau media sosial tentang produk dan layanan
                yang
                ditawarkan oleh pihak ketiga terpilih yang menurut Kami mungkin menarik bagi Anda.</li>
        </ul>
        <p>&nbsp;</p>
        <li>Untuk kegiatan usaha (bisnis) Kami:</li>
        <ul>
            <li>untuk memproses pembayaran, menanggapi permintaan layanan Pengguna</li>
            <li>untuk penelitian dan studi yang mungkin secara sukarela membagikan Data Pribadi untuk
                berpartisipasi&nbsp;</li>
            <li>untuk operasi bisnis melakukan kegiatan akuntansi, audit, penagihan, rekonsiliasi dan
                pengumpulan,
                termasuk pemantauan dan pencegahan kejahatan atau penipuan, melindungi hak-hak hukum Kami, dan
                melakukan kewajiban berdasarkan suatu kesepakatan/kontrak/perjanjian.</li>
        </ul>
        <p>&nbsp;</p>
        <li>Untuk fungsionalitas, pengembangan dan peningkatan&nbsp;produk dan Layanan</li>
        <ul>
            <li>untuk menyediakan konektivitas jaringan, mengukur tingkat penggunaan Layanan, mendiagnosis
                masalah
                server, dan menyediakan fitur keamanan</li>
            <li>memanfaatkan Data Pribadi Pengguna terkait kebiasaan Pengguna dalam menggunakan Layanan untuk memahami
                dan
                mengkategorikan Pengguna. Hasil pemrosesan akan memungkinkan segmentasi dalam profil Pengguna yang dapat
                digunakan oleh IOH</li>
            <li>menggunakan Data Pribadi untuk tujuan penelitian, menguji, memodifikasi, meningkatkan atau
                mengembangkan Layanan, teknologi baru Kami dan untuk mengidentifikasi tren</li>
            <li>memanfaatkan Data Pribadi Pengguna mengenai kebiasaan Pengguna dalam menggunakan Layanan untuk
                analisis lebih lanjut dan menjalankan proses pemasaran yang lebih sejalan dengan preferensi
                Pengguna
            </li>
            <li>memproses Data Pribadi Pengguna dalam konteks pencegahan terjadinya penipuan dan untuk tujuan keamanan.
            </li>
        </ul>
        <p>&nbsp;</p>
        <li>Untuk iklan dan pemasaran Layanan</li>
        <ul>
            <li>Kami dapat menggunakan lokasi fisik perangkat Anda, dikombinasikan dengan informasi tentang
                iklan
                apa yang Anda lihat dan informasi lain yang Kami kumpulkan, untuk memungkinkan Kami menyediakan
                konten yang dipersonalisasi dan untuk mempelajari efektivitas kampanye iklan dan
                pemasaran.&nbsp;
            </li>
            <li>Anda dapat memilih untuk mengizinkan atau menolak penggunaan atau berbagi lokasi perangkat Anda
                dengan mengubah pengaturan perangkat Anda, tetapi jika Anda memilih untuk menolak penggunaan
                atau
                berbagi tersebut, Kami mungkin tidak dapat memberi Anda Layanan dan konten IOH tertentu yang
                dipersonalisasi.</li>
        </ul>
    </ol>
    <p>&nbsp;</p>
    <p><strong><u>Bagaimana IOH membagikan Data Pribadi Anda?</u></strong></p>
    <p>Dalam hal dimungkinkan dan memiliki dasar pemrosesan yang sah, kKami berbagi informasi tentang Anda dengan
        antara
        lain:</p>
    <ul>
        <li>Perusahaan-perusahaan yang tergabung di kelompok usaha IOH termasuk antara lain: afiliasi dan anak
            perusahaan (&ldquo;<strong>Grup IOH</strong>&rdquo;) untuk membantu memberikan Layanan atau
            melakukan
            pengolahan data untuk dan atas nama IOH.</li>
        <li>Mitra, pemasok, agen yang terlibat dalam untuk keperluan aktivasi Layanan sebelum Layanan
            diakses/digunakan oleh Pengguna.</li>
        <li>Mitra, pemasok, agen yang terlibat dalam pengiriman dan penyediaan Layanan yang akan atau telah Anda
            akses, pesan atau gunakan.</li>
        <li>Perusahaan yang terlibat untuk melakukan Layanan untuk, atau atas nama IOH, dan/atau Grup IOH.</li>
        <li>Referensi kredit, agen pencegah penipuan atau penilaian bisnis, atau agen penilaian kredit lainnya,
            termasuk perbankan.</li>
        <li>Agen penagih utang atau organisasi pemulihan utang lainnya.</li>
        <li>Aparat penegak hukum, Kementerian/Lembaga Pemerintah, organisasi regulator, pengadilan, atau
            otoritas
            publik lainnya jika Kami harus, atau diizinkan oleh hukum.</li>
        <li>Pihak ketiga atau suatu badan di mana pengungkapan tersebut diperlukan dan diatur sesuai dengan
            ketentuan perundang &ndash; undangan yang berlaku.</li>
        <li>Layanan darurat (jika Anda melakukan panggilan darurat), termasuk perkiraan lokasi Anda.</li>
        <li>Pihak ketiga untuk keperluan promosi bersama. Pihak ketiga tersebut akan bertanggung jawab atas
            kepatuhan mereka sendiri terhadap undang-undang privasi yang berlaku</li>
        <li>Pihak ketiga lainnya saat Anda mendaftar ke layanan mereka dan digunakan oleh mereka untuk tujuan
            otentikasi dan pencegahan penipuan melalui Kami, termasuk oleh lembaga keuangan berupa bank atau
            non-bank.</li>
        <li>Pihak ketiga yang beriklan dengan Kami untuk melayani Anda (misalnya, antara lain: Facebook, Google,
            Twitter, Amazon), dengan mempertimbangkan kebijakan privasi yang mungkin berlaku khusus untuk
            layanan-layanan tersebut.</li>
    </ul>
    <p><strong><u>Manajemen <em>fraud</em> dan penegakan hukum</u></strong></p>
    <p>Kami akan merilis informasi jika wajar untuk tujuan melindungi Kami dari penipuan, membela hak atau properti
        Kami, atau untuk melindungi kepentingan Pengguna.<br /> Kami juga mungkin perlu mengungkapkan informasi Anda
        untuk mematuhi kewajiban sehubungan dengan kepentingan pertahanan dan keamanan nasional, serta kewajiban
        hukum
        Kami untuk menanggapi tuntutan hukum pihak berwenang. Data Pribadi Anda hanya akan diberikan jika Kami
        dengan
        itikad baik percaya bahwa Kami berkewajiban untuk melakukannya sesuai dengan hukum dan berdasarkan evaluasi
        menyeluruh dari semua persyaratan hukum.</p>
    <p><strong><u>Dalam Hal Terjadi Aksi Korporasi (Penggabungan, Penjualan, atau Kepailitan)</u></strong></p>
    <p>Dalam hal IOH diambil alih oleh atau melakukan penggabungan dengan suatu entitas pihak ketiga, maka IOH
        berhak
        untuk memindahtangankan atau mengalihkan Data sebagai bagian dari penggabungan, pengambilalihan, penjualan,
        atau
        perubahan kendali lainnya. Seandainya terjadi peristiwa kepailitan, bangkrut, reorganisasi, pengawasan
        kurator,
        atau penyerahan demi kepentingan kreditur, terhadap IOH, atau penerapan hukum atau prinsip-prinsip keadilan
        yang
        mempengaruhi hak kreditur secara umum, IOH mungkin tidak dapat mengendalikan bagaimana Data Pribadi Pengguna
        akan diperlakukan, dialihkan, atau digunakan.</p>
    <p><strong><u>Pihak ketiga yang bekerja sama dengan IOH</u></strong></p>
    <p>Saat Anda membeli Layanan IOH menggunakan pihak ketiga atau mitra IOH, Kami sering perlu bertukar informasi
        dengan mereka sebagai bagian dari pengelolaan hubungan tersebut dan akun Anda, misalnya, agar dapat
        mengidentifikasi pesanan Anda dan dapat membayar mereka.</p>
    <p>Jika Kami memiliki kontrak dengan penyedia layanan atau kontraktor untuk memberi Kami layanan atau memberikan
        layanan atas nama Kami, dan mereka mungkin memiliki akses ke Data Pribadi Anda, Kami tidak mengizinkan
        mereka
        untuk menggunakan atau mengungkapkan Data Pribadi Anda kecuali sehubungan dengan penyediaan layanan
        mereka.<br /> Kami mengumpulkan dan menggabungkan informasi untuk memantau penggunaan produk dan layanan
        Anda,
        dan Pengguna Kami yang lain, serta untuk membantu Kami meningkatkan kualitas Layanan Kami.</p>
    <p><strong><u>Produk pihak ketiga yang Anda beli melalui akun myIM3, bima+, Indosat Digital Ecosystem (IDE) atau
                aplikasi maupun platform IOH lainnya</u></strong>&nbsp;</p>
    <p>Saat Anda membeli produk atau layanan pihak ketiga melalui akun Anda pada myIM3, bima+, IDE, atau aplikasi
        maupun
        platform IOH lainnya, Anda setuju bahwa IOH dapat memberikan Data Pribadi tertentu kepada pihak-pihak yang
        bekerja sama dengan IOH untuk melayani Anda atau menyelesaikan pembelian Anda melalui aplikasi maupun
        platform
        tersebut.</p>
    <p><strong><u>Transfer Data Pribadi ke Luar Wilayah Hukum Republik Indonesia</u></strong></p>
    <p>Kami mungkin perlu mentransfer informasi Anda ke perusahaan Grup IOH lain atau penyedia layanan di
        negara-negara
        di luar wilayah hukum Indonesia. Transfer data semacam ini dapat terjadi jika server Kami (yaitu tempat Kami
        menyimpan data) berbasis di luar wilayah hukum Indonesia, atau jika Anda menggunakan Layanan Kami saat
        mengunjungi negara di luar wilayah hukum Indonesia.</p>
    <p>Jika IOH mengirimkan informasi Anda ke luar wilayah hukum Indonesia, Kami akan memastikan bahwa informasi
        Anda
        terlindungi dengan baik. Kami akan selalu memastikan bahwa negara tempat pihak ketiga berbasis memiliki
        tingkat
        pelindungan Data Pribadi yang setara atau lebih tinggi dari Indonesia, atau pihak ketiga yang akan menerima
        Data
        Pribadi Anda memiliki standard pelindungan Data Pribadi yang memadai dan bersifat mengikat, atau
        sekurang-kurangnya mendapatkan persetujuan dari Anda untuk melakukan transfer Data Pribadi Anda.</p>
    <p><strong><u>Pengamanan Data Pribadi Anda</u></strong></p>
    <p>Kami memiliki tim keamanan khusus yang terus-menerus meninjau dan meningkatkan tindakan Kami untuk melindungi
        Data Pribadi Anda dari akses tidak sah, kehilangan, pengungkapan, atau perusakan yang tidak disengaja.</p>
    <p>Kami tidak bertanggung jawab atas akses tidak sah atau hilangnya Data Pribadi yang berada di luar kendali
        Kami.<br /> Kami tidak akan pernah meminta Data Pribadi atau kredensial akun Anda. Anda bertanggung jawab
        untuk
        menjaga keamanan Data Pribadi dan akun Anda dan tidak membaginya dengan orang lain.</p>
    <p><strong><u>Pengambilan Keputusan Otomatis</u></strong></p>
    <p>Dalam beberapa kasus, penggunaan Data Pribadi Anda oleh Kami dapat menghasilkan pengambilan keputusan
        otomatis
        (termasuk profiling) yang secara hukum mempengaruhi Anda atau yang secara signifikan mempengaruhi Anda.</p>
    <p>Keputusan otomatis adalah keputusan mengenai Anda yang dibuat secara otomatis berdasarkan hasil keputusan
        komputer (menggunakan algoritma perangkat lunak), tanpa adanya ulasan yang berasal dari manusia dimana
        keputusan
        tersebut memiliki pengaruh hukum atau pengaruh signifikan lainnya. Kami menggunakan analisis otomatis untuk
        membuat prediksi seperti jenis Layanan yang Anda minati, atau pengambilan keputusan otomatis untuk mencegah
        pencurian, penipuan, atau kejahatan lainnya. Solusi kecerdasan buatan yang diberikan oleh IOH dapat mengarah
        pada pemrosesan data secara otomatis di berbagai bidang. Apabila pengambilan keputusan otomatis Kami memberi
        efek hukum atau secara signifikan mempengaruhi Anda, Kami akan menerapkan langkah-langkah untuk melindungi
        hak-hak Anda, kebebasan dan kepentingan Anda, dengan melakukan penilaian dampak privasi untuk
        mengidentifikasi
        langkah-langkah yang sesuai untuk melindungi hak-hak tersebut, atau mendapatkan persetujuan eksplisit Anda
        sebagaimana yang dibutuhkan oleh hukum yang berlaku.</p>
    <p><strong><u>Dasar Hukum untuk Penggunaan IOH</u></strong></p>
    <p>Dasar hukum Kami untuk mengumpulkan dan menggunakan Data Pribadi akan tergantung pada Data Pribadi yang
        bersangkutan dan konteks spesifik pengumpulan informasi.<br /> Kami memerlukan Data Pribadi untuk memenuhi
        kontrak dengan Anda, dimana Kami memiliki kewajiban hukum untuk melakukannya atau di mana hal tersebut
        merupakan
        kepentingan sah Kami untuk melakukan pemrosesan (seperti pemrosesan untuk keperluan administrasi, pemasaran
        langsung, pengembangan atau pengembangan produk, mencegah penipuan atau tindakan kriminal dan mendukung
        keamanan
        informasi) dan tidak mengesampingkan kepentingan perlindungan data Anda atau hak dasar dan kebebasan.<br />
        Jika
        Kami meminta Anda untuk memberikan Data Pribadi untuk mematuhi persyaratan hukum atau untuk memenuhi kontrak
        dengan Anda, Kami akan menjelaskan hal ini saat pengumpulan informasi. Kami juga akan memberitahu Anda
        apakah
        persyaratan untuk informasi tersebut wajib dan menjelaskan segala konsekuensi kepada Anda jika Anda tidak
        memberikan informasi.</p>
    <p>&nbsp;</p>
    <p>Demikian pula, jika Kami mengumpulkan dan menggunakan Data Pribadi Anda berdasarkan kepentingan sah Kami
        (atau
        dari pihak ketiga mana pun), Kami akan mengambil langkah-langkah yang wajar untuk memberikan pemberitahuan
        yang
        jelas dan menggambarkan kepentingan sah Kami.<br /> IOH adalah pengontrol data dari semua Dara Pribadi yang
        dikumpulkan, kecuali jika pemberitahuan privasi tambahan mengatakan sebaliknya.</p>
    <p>Jika Anda memiliki pertanyaan tentang atau memerlukan informasi lebih lanjut mengenai dasar hukum bagi Kami
        untuk
        mengumpulkan dan menggunakan Data Pribadi Anda untuk setiap kegiatan pemrosesan tertentu, silakan hubungi
        Kami
        menggunakan rincian kontak yang disediakan di bagian "<strong>Hubungi Kami</strong>" di bawah.</p>
    <p><strong><u>Informasi mengenai anak-anak</u></strong></p>
    <p>Apabila Anda berumur di bawah usia 18 tahun, maka Anda berkewajiban untuk mendapatkan persetujuan orang tua
        atau
        wali Anda yang sah sesuai dengan peraturan yang berlaku sebelum menggunakan jaringan, dan/atau Layanan Kami.
    </p>
    <p><strong><u>Penyimpanan (Retensi)</u></strong></p>
    <p>Data Pribadi yang telah dikumpulkan dan akan disimpan selama jangka waktu diperlukan untuk memenuhi tujuan
        yang
        disebutkan di atas. Kami dapat menyimpan Data Pribadi Anda untuk menyediakan Layanan yang Anda minta, atau
        untuk
        tujuan penting lainnya, seperti mematuhi kewajiban hukum Kami, menyelesaikan sengketa, dan melaksanakan
        kebijakan-kebijakan Kami. Periode penyimpanan Data Pribadi didasarkan pada persyaratan hukum yang berlaku.
        Namun, jika tidak ada undang-undang yang relevan, Data Pribadi akan disimpan selama waktu yang diperlukan
        untuk
        tujuan bisnis.</p>
    <p>Data Pribadi ini dapat disimpan dalam bentuk salinan cetak, atau format elektronik.</p>
    <p>Kami dapat menyimpan data Anda di pusat data atau gudang yang dikelola baik oleh Kami atau oleh penyedia
        layanan
        atas nama Kami. Semua fasilitas, sistem, dan produk Kami telah dilengkapi dengan kontrol keamanan yang
        diperlukan untuk memastikan perlindungan Data Pribadi.</p>
    <p>Periode penyimpanan dapat sangat bervariasi berdasarkan jenis informasi dan cara penggunaannya dan periode
        penyimpanan Kami didasarkan pada kriteria yang mencakup periode penyimpanan yang dipersyaratkan secara
        hukum,
        proses pengadilan yang tertunda atau potensial, kekayaan intelektual atau hak kepemilikan Kami, persyaratan
        berdasarkan perjanjian/kontrak, arahan atau kebutuhan operasional, dan pengarsipan sejarah. Ketika Data
        Pribadi
        dihapus dari sistem Kami, data tersebut akan dihapus atau dihancurkan menggunakan protokol keamanan yang
        sesuai
        sehingga tidak dapat direkonstruksi atau dibaca.</p>
    <p><strong><u>Hak Anda</u></strong></p>
    <p>Di bawah ini Kami menjelaskan detail tentang bagaimana Anda dapat menggunakan hak Anda. Jika Anda memiliki
        pertanyaan atau tidak dapat menemukan jawabannya, silakan hubungi tim layanan pelanggan Kami.</p>
    <p>Kami berhak menolak permintaan Anda untuk mengakses, memperbaiki dan/atau menghapus, sebagian atau seluruh
        Data
        Pribadi Anda yang Kami kuasai, jika diizinkan atau diharuskan berdasarkan Peraturan Perundang-undangan yang
        berlaku, terutama jika permintaan tersebut dapat berdampak mengenai hal-hal seperti namun tidak terbatas
        pada:
    </p>
    <ol type="a">
        <li>membahayakan keselamatan, kesehatan fisik atau mental Anda dan/atau orang lain; dan/atau</li>
        <li>ada dampak pengungkapan Data Pribadi orang lain; dan/atau</li>
        <li>bertentangan dengan kepentingan pertahanan dan keamanan negara dan/atau</li>
        <li>alasan permintaan tidak relevan bagi Anda dan/atau aktivitas pemrosesan Data Pribadi yang Kami
            lakukan.
        </li>
    </ol>
    <p>Kami mungkin dapat membebankan biaya administrasi untuk setiap permintaan Anda sesuai dengan hukum dan
        peraturan
        yang berlaku.</p>
    <p><strong><u>Hak untuk mengakses Data Pribadi</u></strong></p>
    <p>Anda berhak untuk meminta salinan Data Pribadi yang dimiliki IOH tentang Anda. Untuk mengajukan permintaan
        ini
        sebagai individu atau pihak ketiga yang berwenang, Anda dapat kunjungi bagian &ldquo;<strong>Hubungi
            Kami</strong>&rdquo; yang memberikan perincian tentang cara melakukannya. Atau, Anda dapat menghubungi
        tim
        layanan pelanggan Kami.</p>
    <p><strong><u>Hak untuk mengoreksi Data Pribadi</u></strong></p>
    <p>Anda memiliki hak untuk memperbaiki informasi yang dimiliki tentang Anda jika informasi tersebut tidak
        akurat.
        Jika informasi yang Kami miliki tentang Anda tidak akurat atau perlu diperbarui, Anda dapat menghubungi tim
        layanan pelanggan Kami. Anda dianjurkan untuk aktif dalam memastikan keakuratan dan pemutakhiran data Anda
        dari
        waktu ke waktu.</p>
    <p><strong><u>Hak untuk portabilitas data</u></strong></p>
    <p>Anda berhak untuk membawa dan mengirimkan Data Pribadi yang Anda berikan kepada Kami ke pihak lainnya atau ke
        pengendali Data Pribadi lainnya, sepanjang sistem yang digunakan dapat saling berkomunikasi secara aman
        sesuai
        regulasi, misalnya dengan memungkinkan Anda untuk mengintegrasikan data Anda dengan platfrom pihak ketiga
        yang
        bekerja sama dengan Kami atau memungkinkan Anda untuk mengunduh tagihan bulanan Anda melalui saluran resmi
        Kami
        dengan struktur dan/atau format yang lazim digunakan.</p>
    <p><strong><u>Hak untuk menolak penggunaan Data Pribadi</u></strong></p>
    <p>Anda berhak, dalam keadaan tertentu, untuk menolak IOH memproses Data Pribadi Anda. Untuk informasi lebih
        lanjut
        atau untuk menggunakan hak ini, silakan hubungi layanan pelanggan IOH. Jika hal ini berkaitan dengan
        keputusan
        otomatis yang dilakukan pada Anda (artinya tanpa keterlibatan manusia), Anda tetap dapat memberi tahu Kami
        dan
        Kami akan meninjau permintaan Anda terlebih dahulu.</p>
    <p><strong><u>Hak untuk menarik kembali persetujuan penggunaan Data Pribadi</u></strong></p>
    <p>Anda berhak, dalam keadaan tertentu, menarik kembali persetujuan atas pemrosesan Data Pribadi yang sebelumnya
        Anda berikan dengan cara menghubungi layanan pelanggan IOH.<br /> Namun, tidak tersedianya informasi Data
        Pribadi Anda menyebabkan Kami menjadi tidak dapat melakukan verifikasi dan memproses pembelian Anda,
        sehingga
        Anda mungkin menjadi tidak dapat menggunakan Layanan tertentu.</p>
    <p>Jika Anda tetap ingin menggunakan Layanan Kami, maka Anda hanya dapat menarik sebagian persetujuan penggunaan
        Data Pribadi yang tidak digunakan untuk menyediakan Layanan kepada Anda.</p>
    <p><strong><u>Untuk Opt-Out dari Informasi Pemasaran:</u></strong></p>
    <ol type="a">
        <li>Jika Anda tidak lagi ingin menerima informasi pemasaran dari IOH, Anda dapat memilih untuk tidak
            menerimanya kapan saja. Jika sebelumnya Anda memilih untuk menerima konten yang dipersonalisasi
            berdasarkan bagaimana dan dimana Anda menggunakan jaringan Kami, Anda juga dapat memilih untuk tidak
            menerimanya kapan saja.</li>
        <li>Adapun cara untuk melakukan&nbsp;<em>opt-out</em>&nbsp;atas aktivitas pemasaran adalah dengan cara
            menghubungi tim layanan pelanggan Kami dan mekanisme lainnya yang Kami sediakan dari waktu ke waktu.
        </li>
        <li>Jika Anda memilih untuk&nbsp;<em>opt-out</em>, Anda mungkin masih menerima pesan terkait layanan.
        </li>
    </ol>
    <p>Harap diketahui bahwa Anda mungkin masih menerima pesan penawaran untuk 7x 24 jam setelah
        memilih&nbsp;<em>opt-out.&nbsp;</em>Hal ini dapat disebabkan oleh waktu yang diperlukan oleh Kami untuk
        memperbarui&nbsp;<em>database</em>&nbsp;Kami.</p>
    <ol type="a">
        <li>Anda juga mungkin telah menerima informasi pemasaran dari IOH meskipun Anda bukan Pengguna atau
            tidak
            pernah berhubungan dengan Kami. Ini adalah hasil dari daftar pihak ketiga yang dapat diperoleh IOH
            dari
            waktu ke waktu, yang menyatakan bahwa Anda telah memberikan izin untuk dihubungi oleh pihak tertentu
            lain.</li>
        <li>Jika Anda telah mendaftar dengan Kami untuk memilih&nbsp;<em>opt-out</em>&nbsp;dari informasi
            pemasaran
            IOH, Anda tidak boleh menerima komunikasi tersebut. Jika Anda masih menerimanya, Kami meminta Anda
            segera memberi tahu Kami dengan menghubungi tim layanan pelanggan Kami. Ini hanya akan menghentikan
            informasi pemasaran dari Kami dan tidak menghentikan pihak ketiga membagikan data Anda kecuali Anda
            menghubungi mereka secara langsung.</li>
    </ol>
    <p><strong><u>Bagaimana cara mengajukan keluhan</u></strong></p>
    <p>Jika Anda ingin menghubungi Kami tentang salah satu hak Anda atau mengajukan keluhan tentang cara Kami
        menggunakan Data Pribadi Anda, silakan menghubungi tim layanan pelanggan Kami, makaKami akan melakukan usaha
        terbaik untuk membantu Anda.</p>
    <p><strong><u>Hak untuk membatasi penggunaan data Anda</u></strong></p>
    <p>Jika Anda merasa data yang Kami simpan tentang Anda tidak akurat, atau Anda yakin Kami seharusnya tidak
        memproses
        Data Pribadi Anda, silakan hubungi tim layanan pelanggan Kami untuk mendiskusikan hak Anda. Dalam keadaan
        tertentu, Anda berhak meminta Kami membatasi pemrosesan.</p>
    <p><strong><u>Hak untuk menghapus data Anda</u></strong></p>
    <p>IOH berusaha untuk hanya memproses dan menyimpan data Anda selama Kami membutuhkannya. Dalam keadaan tertentu
        Anda memiliki hak untuk meminta Kami menghapus Data Pribadi Anda yang Kami pegang. Jika Anda merasa bahwa
        Kami
        menyimpan data Anda lebih lama dari yang Kami butuhkan, ada baiknya terlebih dahulu memeriksa apakah kontrak
        berlangganan Anda dengan IOH telah berakhir, yang dapat Anda lakukan melalui tim layanan pelanggan. Jika
        kontrak
        Anda dengan IOH telah berakhir, Kami mungkin masih memiliki alasan yang sah untuk memproses Data Pribadi
        Anda.
        Untuk informasi lebih lanjut tentang periode penyimpanan, lihat bagian dalam kebijakan privasi ini yang
        berjudul
        Penyimpanan (Retensi)</p>
    <p><strong><u>Hukum yang Berlaku</u></strong></p>
    <p>Kebijakan Privasi ini tunduk pada hukum Negara Republik Indonesia.</p>
    <p>Kebijakan Privasi ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Apabila terdapat perbedaan atau
        pertentangan di antara versi Bahasa Indonesia dan Bahasa Inggris, Bahasa Indonesia akan diberlakukan dan
        versi
        Bahasa Inggris akan dianggap telah berubah untuk menyesuaikan dengan versi Bahasa Indonesia.</p>
    <p><strong><u>Perubahan Kebijakan Privasi</u></strong></p>
    <p>IOH dapat mengubah atau memperbaharui Kebijakan Privasi ini setiap waktu dengan mempublikasikannya pada
        situs,
        aplikasi dan Layanan terkait. Pengguna diharapkan untuk membaca dengan seksama dan melakukan pengecekan atas
        laman Kebijakan Privasi ini dari waktu ke waktu untuk mengetahui setiap perubahan yang dilakukan IOH atas
        Kebijakan Privasi ini. Dengan mengakses dan menggunakan situs, aplikasi, atau layanan IOH lainnya, Pengguna
        setuju untuk menyetujui perubahan atas Kebijakan Privasi.</p>
    <p><strong><u>Pengakuan dan Persetujuan</u></strong></p>
    <ol type="a">
        <li>Anda menjamin bahwa segala data yang diberikan dalam bentuk tertulis maupun bentuk lainnya untuk
            menggunakan Layanan adalah benar milik Anda dan bukan diperoleh dari Data Pribadi milik pihak ketiga
            tanpa izin yang sah, sehingga segala hal yang timbul sehubungan dengan pemberian dan kebenaran
            data-data
            tersebut menjadi tanggung jawab penuh dari Anda.</li>
        <li>Dengan menyetujui Kebijakan Privasi ini, Anda mengakui bahwa Anda telah membaca dan memahami
            Kebijakan
            Privasi ini dan menyetujui semua ketentuannya. Secara khusus, Anda setuju dan memberikan izin kepada
            Kami untuk melakukan pengumpulan, pemrosesan, analisis, penyimpanan, pengungkapan, koreksi, dan
            penghapusan Data Pribadi Anda sesuai dengan Kebijakan Privasi ini.</li>
        <li>Jika Anda berada di bawah persyaratan usia minimum atau termasuk dalam kategori anak-anak sesuai
            dengan
            ketentuan peraturan perundang-undangan yang berlaku, maka persetujuan atas pengolahan Data Pribadi
            Anda
            harus diberikan oleh orang tua (ayah atau ibu) atau wali Anda sesuai dengan peraturan yang berlaku.
        </li>
    </ol>
    <p><strong>Pembaharuan terakhir: &nbsp;&nbsp;xx Februari &nbsp;2024</strong></p>
    <p>&nbsp;</p>


    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Syarat dan Ketentuan Indosat Ooredoo Hutchison Prabayar IM3</h1>
    <p>Syarat dan Ketentuan Layanan Prabayar Indosat Ooredoo Hutchison ("Syarat dan Ketentuan") ini mengikat
        pengguna
        Layanan Prabayar Indosat Ooredoo Hutchison.</p>
    <ol type="i">
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq0"><strong> Pengertian</strong></a></li>
        <ol type="1">
            <li>"Indosat Ooredoo Hutchison" adalah PT Indosat Tbk.</li>
            <li>"Pelanggan" adalah individu atau perorangan yang terdaftar sebagai pihak yang menggunakan Layanan
                Prabayar.
            </li>
            <li>"Kartu SIM Prabayar" adalah kartu Subscriber Identity Module (SIM) prabayar yang dikeluarkan oleh
                Indosat
                Ooredoo Hutchison, yang digunakan oleh Pelanggan untuk mengakses Layanan Prabayar.</li>
            <li>&ldquo;Layanan Prabayar&rdquo; adalah layanan telekomunikasi prabayar yang diselenggarakan oleh Indosat
                Ooredoo Hutchison termasuk namun tidak terbatas pada layanan panggilan suara, pesan singkat, akses
                data/internet dan jasa nilai tambah lainnya.</li>
            <li>"Keadaan Memaksa" adalah suatu keadaan yang berada di luar kendali Indosat Ooredoo, Hutchison termasuk
                tetapi tidak terbatas pada kejadian alam, wabah penyakit, kebakaran, gempa bumi, badai, banjir, atau
                bencana
                lainnya, ancaman akan pecahnya perang, huru hara atau tindak kerusuhan lainnya, perselisihan industrial,
                pemadaman listrik, kerusakan saluran telepon, serangan siber, tindakan pihak lain yang mengakibatkan
                atau
                keadaan di mana Indosat Ooredoo Hutchison tidak dapat memberikan pelayanan yang semestinya kepada
                Pelanggan
                atau adanya larangan yang diberlakukan oleh pemerintah. Dalam hal terjadi Keadaan Memaksa,Indosat
                Ooredoo
                Hutchison dibebaskan dari tanggung jawabnya.</li>
            <li>&ldquo;Masa Aktif&rdquo; adalah masa aktif Kartu SIM Prabayar sebagaimana ditetapkan oleh Indosat
                Ooredoo
                Hutchison.</li>
            <li>&ldquo;Masa Tenggang&rdquo; adalah masa 30 hari kalender setelah berakhirnya Masa Aktif.</li>
            <li>&ldquo;Kadaluarsa&rdquo; adalah Kartu SIM Prabayar yang telah melewati Masa Tenggang sehingga Kartu SIM
                Prabayar tidak dapat digunakan dan sisa pulsa akan hilang.</li>
            <li>Syarat dan Ketentuan Umum adalah syarat-syarat dan ketentuan umum yang tercantum dalam laman ini, yang
                dapat
                dilengkapi dengan Syarat dan Ketentuan Khusus (apabila ada) untuk setiap produk dan layanan Indosat
                Ooredoo
                Hutchison.</li>
            <li>Syarat dan Ketentuan Khusus adalah syarat-syarat dan ketentuan khusus yang tercantum dalam laman ini
                atau
                laman lain yang berlaku khusus untuk setiap produk, layanan maupun program-program tertentu yang
                diselenggarakan sendiri oleh Indosat Ooredoo Hutchison atau dengan bekerjasama dengan pihak lain.</li>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq1"><strong> Ketentuan Umum</strong></a>
        </li>
        <ol type="1">
            <li>Syarat dan Ketentuan ini berlaku dan mengikat para Pelanggan yang menggunakan Kartu SIM Prabayar.</li>
            <li>Indosat Ooredoo Hutchison akan berusaha agar Layanan Prabayar selalu berfungsi dengan baik namun
                demikian
                Layanan Prabayar dapat sewaktu-waktu mengalami gangguan atau tidak berfungsi dengan baik.</li>
            <li>Pelanggan tidak boleh menggunakan, atau memperbolehkan pihak lain untuk menggunakan Layanan Prabayar
                untuk
                keperluan yang tidak sah atau bersifat melanggar hukum.</li>
            <li>Pelanggan setuju untuk sewaktu-waktu menerima penawaran atau informasi terkait dengan produk-produk atau
                program marketing yang dikeluarkan oleh Indosat Ooredoo Hutchison dan / atau bekerja sama dengan pihak
                ketiga.</li>
            <li>Setiap keberatan terhadap pemotongan pulsa prabayar atas penggunaan jasa atau layanan telekomunikasi
                milik
                Indosat Ooredoo Hutchison termasuk namun tidak terbatas pada jasa nilai tambah / layanan konten hanya
                dapat
                dilayani oleh Indosat Ooredoo Hutchison maksimal 3 (tiga) bulan penggunaan terakhir sejak Pelanggan
                pertama
                kali mengajukan keberatan kepada Indosat Ooredoo Hutchison.</li>
            <li>Pelanggan dengan ini mengijinkan Indosat Ooredoo Hutchison untuk menyimpan, menggunakan maupun mengolah
                data
                pelanggan dan data penggunaan Layanan Prabayar (baik dilakukan oleh Indosat Ooredoo Hutchison dan/atau
                mitranya) untuk tujuan pengembangan produk maupun memasarkan produk lain.</li>
        </ol>
        <li>
            <a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq2"><strong>Kartu Sim Prabayar</strong></a>
        </li>
        <p>&nbsp;</p>
        <ol type="1">
            <li>Untuk berlangganan Layanan Prabayar, Pelanggan harus melakukan aktivasi Kartu SIM Prabayar dan kemudian
                diwajibkan untuk mengisi data diri secara benar dan lengkap sesuai dengan kartu identitas diri (KTP,
                SIM,
                Passport). Kartu SIM Prabayar hanya dapat diaktifkan di area sesuai dengan area aktivasi yang tertera
                pada
                bagian depan kemasan Kartu SIM Prabayar. Layanan Prabayar tidak dapat Anda gunakan jika
                aktivasi/registrasi
                Kartu SIM Prabayar dilakukan di luar area aktivasi tersebut.</li>
            <li>Untuk tetap bisa menggunakan Layanan Prabayar, Pelanggan wajib memastikan Kartu SIM Prabayar selalu
                berada
                dalam Masa Aktif.</li>
            <li>Kartu SIM Prabayar yang sedang dalam Masa Tenggang tidak dapat dipergunakan untuk melakukan panggilan
                telepon.</li>
            <li>Jika Pelanggan tidak melakukan isi ulang sampai Masa Tenggang berakhir, maka Kartu SIM Prabayar akan
                menjadi
                kadaluarsa. Pulsa milik Pelanggan akan hilang apabila Kartu SIM Prabayar Kadaluarsa dan Pelanggan tidak
                akan
                menuntut ganti rugi dalam bentuk apapun kepada Indosat Ooredoo Hutchison.</li>
            <li>Kartu SIM Prabayar akan tetap menjadi milik Indosat Ooredoo Hutchison, akan tetapi Pelanggan bertanggung
                jawab atas semua penggunaan Kartu SIM Prabayar termasuk namun tidak terbatas apabila Kartu SIM Prabayar
                tersebut dipergunakan oleh pihak lain.</li>
            <li>Pelanggan dapat mengganti Kartu SIM Prabayar yang hilang atau rusak setelah memenuhi persyaratan yang
                ditetapkan Indosat Ooredoo Hutchison dan Indosat Ooredoo Hutchison berhak mengenakan biaya administrasi
                yang
                ditetapkan.</li>
            <li>Kehilangan pulsa pada Kartu SIM Prabayar milik Pelanggan yang rusak atau hilang sepenuhnya menjadi
                resiko
                Pelanggan.</li>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq3"><strong> Pembatasan dan
                    Pemblokiran</strong></a></li>
        <ol type="1">
            <li>Indosat Ooredoo Hutchison berhak untuk melakukan pemblokiran jika Kartu SIM Prabayar ini diduga kuat
                digunakan untuk melakukan perbuatan melanggar hukum.</li>
            <li>Indosat Ooredoo Hutchison berhak melakukan pemblokiran apabila: (i) ada permintaan resmi dari instansi
                yang
                berwenang; atau (ii) ada indikasi penyalahgunaan Kartu SIM Prabayar dengan cara apapun termasuk
                mengirimkan
                SMS dalam jumlah dan isi diluar batas kewajaran.</li>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq4"><strong> Lain-lain</strong></a></li>
        <ol>
            <li>Setiap informasi yang dicantumkan dalam website atau media lain oleh Indosat Ooredoo Hutchison merupakan
                bagian dari Syarat dan Ketentuan ini.</li>
            <li>Kerugian yang timbul sebagai akibat dari penggunaan atau penyalahgunaan Kartu SIM Prabayar oleh pihak
                lain
                yang tidak bertanggung jawab sepenuhnya menjadi resiko pelanggan.</li>
            <li>Indosat Ooredoo Hutchison hanya bertanggung jawab atas kerugian yang merupakan dampak langsung dari
                kesalahan Indosat Ooredoo Hutchison dalam menyelenggarakan Layanan Prabayar, tidak termasuk kerugian
                tidak
                langsung seperti kehilangan keuntungan, kerugian nama baik, perhitungan bunga bank.</li>
            <li>Indosat Ooredoo Hutchison berhak untuk mengubah/mengakhiri/menambahkan bagian manapun dari Layanan
                Prabayar
                atau struktur harga setiap saat berdasarkan kebijakan yang ditetapkan oleh Indosat Ooredoo Hutchison.
            </li>
            <li>Pelanggan dengan ini mengijinkan dan memberi wewenang kepada Indosat Ooredoo Hutchison untuk menggunakan
                Syarat dan Ketentuan ini berikut setiap perubahan, tambahan ataupun pembaharuannya termasuk catatan,
                informasi maupun data yang berhubungan dengan Pelanggan dalam bentuk apapun yang diperoleh dari
                Pelanggan
                baik untuk keperluan dan kepentingan Indosat Ooredoo Hutchison sendiri maupun untuk kerjasama dengan
                mitra
                Indosat Ooredoo Hutchison.</li>
            <li>Pelanggan setuju untuk sewaktu-waktu menerima penawaran/informasi terkait dengan produk-produk marketing
                yang dikeluarkan oleh Indosat Ooredoo Hutchison dan/atau bekerjasama dengan pihak ketiga. Pelanggan
                dapat
                menghentikan atau mengaktifkan kembali layanan penawaran/informasi terkait dengan produk-produk
                marketing
                tersebut dengan mengakses *185#, pilih &ldquo;Layanan DnD&rdquo;</li>
            <li>Tarif dapat berubah sewaktu-waktu sesuai dengan kebijakan tarif Indosat Ooredoo Hutchison yang akan
                diinformasikan melalui website&nbsp;<a href="http://www.indosatooredoo.com/">www.indosatooredoo.com</a>.
            </li>
            <li>Indosat Ooredoo Hutchison dapat memberlakukan variasi tarif yang berbeda-beda sesuai dengan kebijakan
                tarif
                yang ditetapkan oleh Indosat Ooredoo Hutchison.</li>
            <li>Untuk kelancaran transaksi pembelian paket quota anda, pastikan saldo anda minimal tersisa 3000 setelah
                anda
                membeli paket quota yang anda pilih.</li>
            <li>Untuk kenyamanan penggunaan layanan paket data anda, sistem akan mulai memproses deaktivasi 5 menit
                sebelum
                paket anda berakhir.</li>
            <li>Setiap perubahan terhadap Syarat dan Ketentuan ini akan diinformasikan melalui website&nbsp;<a
                    href="http://www.indosatooredoo.com/">www.indosatooredoo.com</a>.</li>
            <li>Perubahan apapun dari Layanan Prabayar atau struktur harga akan berlaku efektif ketika Pelanggan<br />
                (i)
                melakukan perpanjangan jangka waktu paket berlangganan; atau<br /> (ii) membeli paket baru, baik paket
                yang
                sama atau berbeda, untuk menggantikan paket sebelumnya, mana yang lebih dulu terjadi.</li>
            <li>Syarat dan Ketentuan ini dibuat, diatur dan dilaksanakan menurut dan berdasarkan ketentuan-ketentuan
                hukum
                Republik Indonesia.</li>
            <li>Apabila terjadi perbedaan atau perselisihan akan diselesaikan melalui musyawarah. Segala perselisihan
                atau
                perbedaan yang tidak dapat diselesaikan secara musyawarah oleh Indosat Ooredoo Hutchison dan Pelanggan
                sehubungan dengan penafsiran dan/ atau pelaksanaan Syarat dan Ketentuan ini, maka kedua belah pihak
                sepakat
                untuk menyelesaikannya melalui Pengadilan Negeri Jakarta Pusat.</li>
            <li>Setiap informasi dan Syarat dan Ketentuan Khusus yang dicantumkan dalam situs oleh Indosat Ooredoo
                Hutchison
                merupakan bagian dari Syarat dan Ketentuan Umum.</li>
            <li>Syarat dan Ketentuan ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Apabila terjadi perbedaan
                penafsiran terhadap kata, frase, atau kalimat dalam Bahasa Indonesia dan Bahasa Inggris di Syarat dan
                Ketentuan ini, maka yang berlaku dan digunakan dalam menafsirkan kata, frase, atau kalimat dimaksud
                adalah
                versi Bahasa Indonesia.</li>
        </ol>
    </ol>


    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Syarat dan Ketentuan Indosat Ooredoo Hutchison Pascabayar IM3</h1>
    <p>Berikut ini adalah syarat dan ketentuan umum berlangganan layanan telekomunikasi pasca bayar Indosat Ooredoo
        Hutchison yang harus dipatuhi oleh pelanggan</p>
    <ol type="i">
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq10"><strong> Definisi</strong></a></li>
        <ol type="1">
            <li>&ldquo;Indosat Ooredoo Hutchison&rdquo; adalah PT Indosat Tbk, selaku penyelenggara Layanan
                Telekomunikasi.
            </li>
            <li>"Pelanggan" adalah perseorangan, badan hukum atau instansi yang berlangganan Layanan Telekomunikasi
                sebagaimana tersebut dalam Formulir Berlangganan, yang terikat dengan Ketentuan dan Syarat Berlangganan
                ini.
            </li>
            <li>"Layanan Telekomunikasi" adalah layanan telekomunikasi seluler pascabayar yang disediakan oleh Indosat
                Ooredoo Hutchison kepada Pelanggan berupa nomor telepon yang dapat digunakan oleh Pelanggan untuk
                melakukan
                dan/atau menerima panggilan telepon dan/atau memanfaatkan paket/fitur/Layanan Telekomunikasi
                tambahan/value
                added service/push mail/data dan lain-lain sebagaimana ditentukan oleh Indosat Ooredoo Hutchison dari
                waktu
                ke waktu.</li>
            <li>"Layanan Push Mail" adalah layanan email yang dapat diakses oleh Pelanggan dengan menggunakan jaringan
                telekomunikasi Indosat Ooredoo Hutchison.</li>
            <li>"Formulir Berlangganan" adalah daftar isian yang harus diisi dan ditandatangani oleh calon Pelanggan
                pada
                saat mengajukan permohonan untuk menjadi Pelanggan.</li>
            <li>"SIM Card" adalah kartu chip mikro prosesor yang dilengkapi nomor telepon yang dapat digunakan pada
                peralatan telekomunikasi Pelanggan untuk menikmati Layanan Telekomunikasi.</li>
            <li>"Aktivasi" adalah tindakan pengaktifan SIM Card untuk dapat menggunakan Layanan Telekomunikasi.</li>
            <li>"SAMU" (Single Account Multi User) adalah layanan yang disediakan Indosat Ooredoo Hutchison berupa
                penyatuan
                tagihan untuk akun yang mempunyai beberapa nomor.</li>
            <li>"Pemblokiran" adalah pemutusan atau penon-aktifan Layanan Telekomunikasi baik bersifat sementara
                (sebagian
                atau seluruh Layanan Telekomunikasi) maupun permanen.</li>
            <li>"Force Majeure" adalah kejadian kejadian di luar kekuasaan Indosat Ooredoo Hutchison yang mengakibatkan
                terhenti atau tertundanya pelaksanaan Ketentuan dan Syarat Berlangganan ini, seperti: petir, gempa bumi,
                topan, kebakaran, perang, ledakan, banjir, tsunami, sabotase, serangan siber, huru hara atau kebijakan
                pemerintah/regulator atau tindakan pihak ketiga.</li>
            <li>&ldquo;Identitas&rdquo; adalah nomor kartu tanda penduduk dan kartu keluarga Pelanggan.</li>
            <li>Syarat dan Ketentuan Umum adalah syarat-syarat dan ketentuan umum ini, yang dapat dilengkapi dengan
                Syarat
                dan Ketentuan Khusus (apabila ada) untuk setiap produk dan layanan IOH.</li>
            <li>Syarat dan Ketentuan Khusus adalah syarat-syarat dan ketentuan khusus yang berlaku khusus untuk setiap
                produk, layanan maupun program-program tertentu yang diselenggarakan sendiri oleh IOH atau dengan
                bekerjasama dengan pihak lain.</li>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq11"><strong> SIM Card</strong></a></li>
        <ol type="1">
            <li>SIM Card wajib digunakan oleh Pelanggan untuk keperluan sendiri sesuai dengan Ketentuan dan Syarat
                Berlangganan ini.</li>
            <li>Apabila Pelanggan bermaksud untuk melakukan pengalihan/penggunaan SIM Card kepada pihak ketiga, maka
                Pelanggan wajib mendapat persetujuan secara tertulis terlebih dahulu dari Indosat Ooredoo Hutchison.
                Apabila
                pengalihan dilakukan tanpa persetujuan Indosat Ooredoo Hutchison, maka Pelanggan tetap bertanggung jawab
                atas segala akibat pengalihan/penggunaan SIM Card tersebut.</li>
            <li>Pelanggan dilarang menyalahgunakan SIM Card diluar peruntukannya yang ditentukan di dalam Ketentuan dan
                Syarat Berlangganan ini.</li>
            <li>Jika terjadi kehilangan SIM Card, Pelanggan wajib untuk melaporkannya ke bagian layanan Pelanggan
                (customer
                service) yaitu gerai, Contact Center atau Griya Indosat Ooredoo Hutchison dengan menandatangani surat
                pernyataan kehilangan dan melampirkan fotokopi identitas. Atas laporan tersebut, Indosat Ooredoo
                Hutchison
                akan me-nonaktifkan SIM Card tersebut. Biaya berlangganan atau biaya-biaya lain sesuai dengan paket
                berlangganan serta pemakaian Layanan Telekomunikasi yang timbul sebelum SIM Card di-nonaktifkan oleh
                Indosat
                Ooredoo Hutchison tetap menjadi tanggung jawab Pelanggan.</li>
            <li>Indosat Ooredoo Hutchison berhak menggunakan kembali nomor telepon seluler Pelanggan yang ada di SIM
                Card
                untuk Pelanggan lain setelah Pemblokiran permanen langganan Layanan Telekomunikasi baik oleh Indosat
                Ooredoo
                Hutchison maupun oleh Pelanggan.</li>
        </ol>
        <p>&nbsp;</p>
        <li>
            <a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq12"><strong>Data Pelanggan</strong></a>
        </li>
        <ol type="1">
            <li>Pelanggan menjamin bahwa seluruh data dan keterangan yang diberikan kepada Indosat Ooredoo Hutchison
                dalam
                Formulir Berlangganan adalah benar.</li>
            <li>Jika seluruh persyaratan dimaksud dalam Formulir Berlangganan belum sepenuhnya dilengkapi oleh Pelanggan
                atau Formulir Berlangganan tidak lolos verifikasi Indosat Ooredoo Hutchison, Indosat Ooredoo Hutchison
                akan
                menangguhkan Aktivasi (apabila SIM Card belum di-Aktivasi) atau melakukan Pemblokiran (apabila SIM Card
                sudah di-Aktivasi).</li>
            <li>Pelanggan wajib segera memberitahukan secara tertulis kepada Indosat Ooredoo Hutchison setiap perubahan
                alamat atau perubahan rekening bank/kartu kredit, termasuk masa berakhirnya kartu kredit Pelanggan.</li>
        </ol>
        <p>&nbsp;</p>

        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq13"><strong> Layanan
                    Telekomunikasi</strong></a></li>
        <ol type="1">
            <li>Indosat Ooredoo Hutchison akan menyediakan Layanan Telekomunikasi sesuai dengan kemampuan fasilitas
                telekomunikasi yang dioperasikannya dan berdasarkan ketentuan dan kebijakan internal yang berlaku di
                Indosat
                Ooredoo Hutchison.</li>
            <li>Indosat Ooredoo Hutchison sewaktu-waktu dapat meninjau kembali dan melakukan perubahan atas Layanan
                Telekomunkasi termasuk namun tidak terbatas pada tarif-tarif yang diberlakukan.</li>
            <li>Indosat Ooredoo Hutchison, dengan memberikan pemberitahuan sebelumnya kepada Pelanggan, dapat melakukan
                migrasi dan atau perubahan paket data yang sedang digunakan oleh Pelanggan, baik yang disebabkan karena
                (i)
                evaluasi dan penghentian paket data yang dikeluarkan oleh Indosat Ooredoo Hutchison, yang mana atas
                evaluasi
                dan penghentian paket data tersebut dapat dilakukan oleh Indosat Ooredoo Hutchison sewaktu-waktu dan
                atau
                (ii) masa kontrak atas paket kontrak yang diambil oleh Pelanggan akan berakhir.</li>
            <li>Dalam hal Pelanggan memilih berlangganan Layanan Telekomunikasi yang menggunakan Layanan tambahan
                dan/atau
                perangkat telekomunikasi yang disediakan pihak ketiga, maka:</li>
            <ol>
                <li>Perbaikan kerusakan perangkat telekomunikasi tersebut mengacu kepada ketentuan garansi perangkat
                    telekomunikasi dari pihak ketiga tersebut, apabila ada.</li>
                <li>Kehilangan perangkat telekomunikasi merupakan resiko Pelanggan.</li>
                <li>Kerusakan perangkat telekomunikasi / selama masa perbaikan perangkat telekomunikasi tidak dapat
                    dijadikan alasan untuk menunda pembayaran Layanan Telekomunikasi.</li>
                <li>Pelanggan mengetahui sepenuhnya dan setuju bahwa penyediaan layanan tambahan dan/atau perangkat
                    telekomunikasi melalui pihak ketiga hanya dapat dilakukan sepanjang kerjasama antara Indosat Ooredoo
                    Hutchison dengan pihak ketiga yang menyediakan Layanan Telekomunikasi tambahan dan/atau perangkat
                    telekomunikasi tersebut masih berlangsung dan oleh karenanya Pelanggan tidak akan mengajukan
                    tuntuntan
                    apapun kepada Indosat Ooredoo Hutchison apabila penyediaan Layanan Telekomunikasi tambahan dan/atau
                    perangkat telekomunikasi berakhir karena berakhirnya kerjasama dengan pihak ketiga.</li>
            </ol>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq14"><strong> Penagihan</strong></a></li>
        <ol type="1">
            <li>Indosat Ooredoo Hutchison akan melakukan penagihan atas pemakaian Layanan Telekomunikasi kepada
                Pelanggan
                setiap bulan dan wajib dibayarkan oleh Pelanggan selambat-lambatnya pada tanggal jatuh tempo yang
                disebutkan
                pada tagihan.</li>
            <li>Indosat Ooredoo Hutchison berhak melakukan penagihan atas pemakaian Layanan Telekomunikasi yang belum
                ditagihkan sebelumnya kepada Pelanggan, pada periode tagihan yang akan datang.</li>
            <li>Apabila Pelanggan tidak menerima tagihan yang seharusnya telah diterima, maka Pelanggan harus segera
                menanyakannya kepada Customer Service Indosat Ooredoo Hutchison. Pelanggan tetap berkewajiban untuk
                memenuhi
                pembayaran selambat-lambatnya pada tanggal jatuh tempo walaupun tidak/belum menerima tagihan yang
                dimaksud.
            </li>
            <li>Apabila Pelanggan tidak melakukan pembayaran tagihan sampai dengan tanggal jatuh tempo, maka Indosat
                Ooredoo
                Hutchison berhak menggunakan atau menjual nomor tersebut kepada pelanggan lain sesuai dengan peraturan
                perundang-undangan yang berlaku. Pelanggan yang ingin mengaktifkan kembali nomor tersebut (selama belum
                digunakan oleh pelanggan lain), wajib mengikuti Syarat dan Ketentuan yang berlaku pada saat pengaktifan
                kembali.</li>
            <li>Pelanggan wajib menonaktifkan layanan pembayaran Layanan Telekomunikasi melalui Bank atau penyedia
                layanan
                uang elektronik lainnya apabila Pelanggan mengakhiri Layanan Telekomunikasi. Segala penggunaan layanan
                perbankan atau penyedia layanan uang elektronik yang terjadi setelah proses pengakhiran Layanan
                Telekomunikasi menjadi tanggung jawab Pelanggan dan Indosat Ooredoo Hutchison dibebaskan dari segala
                klaim,
                dan/atau tuntutan dari pihak manapun.</li>
            <li>Setiap keberatan terhadap tagihan tidak mengesampingkan kewajiban Pelanggan untuk melakukan pembayaran
                pada
                saat jatuh tempo dan keberatan-keberatan atas tagihan hanya dilayani oleh Indosat Ooredoo Hutchison
                sampai
                dengan 2 (dua) bulan setelah tanggal proses tagihan.</li>
            <li>Pelanggan dengan ini mengakui sahnya bukti-bukti penagihan yang didasarkan pada data-data yang dicatat
                secara elektronik oleh Indosat Ooredoo Hutchison.</li>
            <li>Indosat Ooredoo Hutchison berwenang menagih pembayaran sebelum tanggal proses tagihan sesuai jumlah yang
                tercatat di Indosat Ooredoo Hutchison apabila jumlah pemakaian Layanan Telekomunikasi pada bulan
                berjalan
                melebihi jumlah rata-rata pemakaian bulanan. Atas tagihan dimaksud Pelanggan wajib melakukan pembayaran
                sesuai jumlah yang ditagih dan pada waktu yang ditentukan oleh Indosat Ooredoo Hutchison.</li>
            <li>Indosat Ooredoo Hutchison berhak melakukan penagihan atas biaya cetak dan pengiriman hardcopy tagihan
                kepada
                Pelanggan. Apabila Pelanggan tidak ingin dikenakan biaya cetak dan pengiriman hard copy tagihan, maka
                Pelanggan dapat menghubungi call center 021-30008686 atau mengakses aplikasi MyIM3 untuk melakukan
                pendaftaran e-billing untuk pengiriman informasi tagihan pemakaian Layanan Telekomunikasi. Besaran biaya
                cetak dan pengiriman hardcopy tagihan dapat di cek di&nbsp;<a
                    href="https://indosatooredoo.com/portal/en/bspostpaidbillviacourier">https://indosatooredoo.com/portal/en/bspostpaidbillviacourier</a>
            </li>
        </ol>
        <p>&nbsp;</p>
        <li>
            <a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq15"><strong>
                    Pembatasan Plafon Tagihan, Biaya dan Pembayaran</strong></a>
        </li>
        <ol type="1">
            <li>Indosat Ooredoo Hutchison berhak untuk menentukan Pembatasan plafon tagihan termasuk namun tidak
                terbatas
                pada waktu jumlah pembatasan plafon terhitung efektif sejak aktivasi dengan ketentuan pada awal
                registrasi
                calon pelanggan, Indosat Ooredoo Hutchison akan melakukan pemberitahuan secara lengkap kepada pelanggan
                terkait jangka waktu dan jumlah pembatasan plafon tagihan.</li>
            <li>Terhadap pembatasan plafon tagihan, dalam hal Pelanggan ingin menggunakan Layanan telekomunikasi dan
                fasilitas tambahan (jika ada) diluar jumlah pembatasan plafon tagihan yang sudah ditetapkan oleh Indosat
                Ooredoo Hutchison maka Pelanggan sepakat untuk melakukan pembayaran tagihan dengan menggunakan kartu
                kredit.
            </li>
            <li>Pelanggan wajib membayarkan biaya-biaya berlangganan dan pemakaian Layanan Telekomunikasi dan fasilitas
                tambahan (jika ada) kepada Indosat Ooredoo Hutchison sesuai dengan Paket berlangganan yang dipilih
                Pelanggan
                dan tarif yang ditetapkan Indosat Ooredoo Hutchison dari waktu ke waktu sesuai ketentuan yang berlaku.
                Setiap pajak atau biaya yang timbul atas pembayaran tersebut menjadi beban dan tanggung jawab Pelanggan.
            </li>
            <li>Biaya pemakaian Layanan Telekomunikasi Indosat Ooredoo Hutchison di luar negeri akan ditagihkan kepada
                Pelanggan setelah Indosat Ooredoo Hutchison menerima data pemakaian Pelanggan yang dikirimkan oleh
                penyelenggara atau operator telekomunikasi di luar negeri (Mitra International Roaming).</li>
            <li>Jika Pelanggan dikenai pemblokiran karena sebab apapun, maka Pelanggan tetap berkewajiban untuk
                melakukan
                pembayaran tagihan Pelanggan yang terhutang kepada Indosat Ooredoo Hutchison secara sekaligus.</li>
            <li>Untuk Pemblokiran sementara, Pelanggan dapat mengaktifkan kembali Layanan Telekomunikasi setelah
                melakukan
                pembayaran terhadap seluruh tagihan yang terhutang dan menghubungi bagian layanan pelanggan (customer
                service) untuk pengaktifan kembali Layanan Telekomunikasi.</li>
            <li>Pembayaran dapat dilakukan oleh Pelanggan dengan cara sebagai berikut:</li>
            <ol>
                <li>Tunai atau transfer sesuai tempat pembayaran atau rekening yang telah disebut pada lembar tagihan.
                </li>
                <li>Auto debit rekening atau kartu kredit.</li>
                <li>Cara pembayaran lain yang ditentukan oleh Indosat Ooredoo Hutchison dikemudian hari.</li>
            </ol>
        </ol>
        <p>&nbsp;</p>
        <li>
            <a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq16"><strong>
                    Pembatasan Tanggung Jawab</strong></a>
        </li>
        <ol type="1">
            <li>Indosat Ooredoo Hutchison tidak bertanggung jawab atas kerugian-kerugian tidak langsung yang timbul dan
                diderita oleh Pelanggan dan/atau pihak ketiga. Indosat Ooredoo Hutchison hanya berkewajiban untuk
                menanggung
                kerugian yang diderita Pelanggan sepanjang dapat dibuktikan karena kesalahan Indosat Ooredoo Hutchison,
                dengan jumlah maksimum 3 (tiga) bulan biaya berlangganan (abonemen).</li>
            <li>Indosat Ooredoo Hutchison dibebaskan dari kewajibannya berdasarkan Ketentuan dan Syarat Berlangganan ini
                apabila terjadi Force Majeure.</li>
            <li>Indosat Ooredoo Hutchison tidak bertanggungjawab atas isi berita dan/atau informasi dan/atau data yang
                dimiliki Pelanggan dan/atau kehilangan data yang dikirim/diterima oleh Pelanggan kepada/dari pihak lain
                melalui jaringan telekomunikasi milik Indosat Ooredoo Hutchison. Oleh karenanya, dengan ini Pelanggan
                membebaskan Indosat Ooredoo Hutchison dari segala gugatan/tuntutan dari pihak manapun juga.</li>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq17"><strong>
                    Pemblokiran dan Pengakhiran Berlangganan</strong></a></li>
        <ol type="1">
            <li>Indosat Ooredoo Hutchison berhak melakukan Pemblokiran Layanan Telekomunikasi tanpa pemberitahuan
                sebelumnya
                kepada Pelanggan, apabila terjadi satu atau lebih hal-hal berikut:</li>
            <ol>
                <li>Pelanggan tidak melakukan pembayaran tagihan bulanan yang telah jatuh tempo.</li>
                <li>Pelanggan tidak memenuhi kewajiban pembayaran sebagaimana dimaksud butir V (5) di atas.</li>
                <li>Pemakaian Pelanggan sudah melebihi sejumlah nilai tertentu yang ditetapkan oleh Indosat Ooredoo
                    Hutchison selama proses verifikasi belum selesai dilakukan atau Pelanggan tidak lolos verifikasi.
                </li>
                <li>Pemakaian Pelanggan sudah melebihi jumlah credit limit (apabila Layanan Telekomunikasi memiliki
                    ketentuan credit limit).</li>
                <li>Dengan bukti-bukti awal yang cukup, Pelanggan diduga menggunakan Layanan Telekomunikasi untuk
                    melakukan
                    perbuatan yang melanggar hukum.</li>
                <li>Data atau keterangan yang diberikan Pelanggan sebagaimana dimaksud butir III (1) tidak benar, palsu
                    atau
                    menyesatkan.</li>
                <li>Pelanggan melakukan pelanggaran terhadap Ketentuan dan Syarat Berlangganan ini.</li>
                <li>Pelanggan dinyatakan oleh Undang-Undang dalam keadaan bangkrut atau pailit atau ditempatkan di bawah
                    pengampuan.</li>
                <li>Pelanggan meninggal dunia.</li>
                <li>Pelanggan melakukan perbuatan melawan hukum yang berlaku yang mengakibatkan kerugian moril ataupun
                    materiil terhadap Indosat Ooredoo Hutchison.</li>
                <li>Terjadi peristiwa Force Majeure yang berlangsung secara terus menerus selama 6 (enam) bulan.</li>
            </ol>
            <li>Khusus untuk SAMU, dalam hal Pelanggan melakukan perbuatan sebagaimana dinyatakan dalam ayat 1 diatas
                maka
                Indosat Ooredoo Hutchison berhak untuk melakukan Pemblokiran terhadap salah satu atau seluruh Layanan
                Telekomunikasi Pelanggan SAMU tersebut.</li>
            <li>Setelah Pemblokiran permanen Indosat Ooredoo Hutchison berhak mengalihkan nomor telepon Pelanggan ke
                pelanggan lain sesuai dengan ketentuan yang berlaku di Indosat Ooredoo Hutchison.</li>
            <li>Pelanggan dapat berhenti berlangganan Layanan Telekomunikasi setiap saat dengan pemberitahuan tertulis
                terlebih dahulu kepada Indosat Ooredoo Hutchison. Pengakhiran berlangganan yang didasarkan atas
                permintaan
                Pelanggan tidak menghapuskan kewajiban Pelanggan yang terhutang secara sekaligus.</li>
            <li>Indosat Ooredoo Hutchison dan Pelanggan sepakat untuk mengesampingkan pemberlakuan Pasal 1266 Kitab
                Undang-Undang Hukum Perdata terhadap pengakhiran berlangganan ini.</li>
        </ol>
        <p>&nbsp;</p>
        <li><a href="https://indosatooredoo.com/portal/id/pssupporttnc#faq18"><strong> Lain-lain</strong></a></li>
        <ol type="1">
            <li>Syarat dan Ketentuan ini tunduk dan diatur oleh hukum Negara Republik Indonesia. Apabila terjadi
                perbedaan
                atau perselisihan yang tidak dapat diselesaikan secara musyawarah oleh Indosat Ooredoo Hutchison dan
                Pelanggan dalam penafsiran atau pelaksanaan Syarat dan Ketentuan ini, maka kedua belah pihak sepakat
                untuk
                menyelesaikannya melalui Pengadilan Negeri Jakarta Pusat.</li>
            <li>Pelanggan dengan ini mengijinkan dan memberi wewenang kepada Indosat Ooredoo Hutchison untuk menggunakan
                Syarat dan Ketentuan ini berikut setiap perubahan, tambahan ataupun pembaharuannya termasuk catatan,
                informasi maupun data yang berhubungan dengan Pelanggan dalam bentuk apapun yang diperoleh dari
                Pelanggan
                untuk keperluan dan kepentingan Indosat Ooredoo Hutchison dalam bentuk apapun.</li>
            <li>Pelanggan setuju untuk sewaktu-waktu menerima penawaran/informasi terkait dengan produk-produk marketing
                yang dikeluarkan oleh Indosat Ooredoo Hutchison dan/atau bekerjasama dengan pihak ketiga. Pelanggan
                dapat
                menghentikan atau mengaktifkan kembali layanan penawaran/informasi terkait dengan produk-produk
                marketing
                tersebut dengan mengakses *185#, pilih &ldquo;Layanan DnD&rdquo;</li>
            <li>Syarat dan Ketentuan ini menggantikan persetujuan atau kesepakatan yang dibuat sebelumnya tentang syarat
                dan
                ketentuan Layanan Telekomunikasi Indosat Ooredoo Hutchison (apabila ada).</li>
            <li>Indosat Oooredoo Hutchison sepenuhnya berhak untuk mengubah, menghapus dan/atau menambah Syarat dan
                Ketentuan ini dari waktu ke waktu tanpa memberikan pemberitahuan sebelumnya kepada Pelanggan.</li>
            <li>Perubahan apapun dari Layanan Telekomunikasi atau struktur harga akan berlaku efektif ketika (i)
                Pelanggan
                melakukan perpanjangan jangka waktu paket berlangganan; atau (ii) membeli paket baru, baik paket yang
                sama
                atau berbeda, untuk menggantikan paket sebelumnya, mana yang lebih dulu terjadi.</li>
            <li>Setiap informasi dan Syarat dan Ketentuan Khusus yang dicantumkan dalam Situs oleh Indosat Ooredoo
                Hutchison
                merupakan bagian dari Syarat dan Ketentuan Umum.</li>
            <li>Syarat dan Ketentuan ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Apabila terjadi perbedaan
                penafsiran terhadap kata, frase, atau kalimat dalam Bahasa Indonesia dan Bahasa Inggris di Syarat dan
                Ketentuan ini, maka yang berlaku dan digunakan dalam menafsirkan kata, frase, atau kalimat dimaksud
                adalah
                versi Bahasa Indonesia.</li>
        </ol>
    </ol>


    <p><strong>Syarat dan Ketentuan Umum Layanan IOH TRI</strong></p>
    <p>Terima kasih atas kepercayaan anda menggunakan produk dan layanan IOH (dahulu Tri) dari PT Indosat Tbk
        (IOH)</p>
    <p>Laman ini berisi syarat dan ketentuan umum yang berlaku untuk semua penggunaan produk dan layanan IOH. Dengan
        menggunakan produk dan layanan IOH atau mengakses laman ini, berarti melahirkan perjanjian antara anda dan
        IOH,
        dan anda dianggap telah mempelajari, memahami dan menyatakan setuju untuk terikat pada Syarat dan Ketentuan
        Umum
        ini. Syarat dan Ketentuan Umum ini dapat dilengkapi dengan Syarat dan Ketentuan Khusus. Apabila anda tidak
        ingin
        tunduk dan terikat pada Syarat dan Ketentuan Umum ini, anda dilarang untuk menggunakan produk dan layanan
        IOH,
        serta wajib menghentikan akses ke situs ini. Anda juga diwajibkan untuk mematuhi hukum yang berlaku ketika
        membeli maupun menggunakan produk dan layanan IOH.</p>
    <p>Syarat dan Ketentuan Umum ini akan selalu dianggap otomatis tercantum dan melekat sebagai bagian yang tidak
        terpisahkan dari setiap perjanjan yang dibuat oleh IOH dengan pihak lain terkait dengan penyediaan maupun
        penggunaan produk dan layanan IOH, kecuali dinyatakan lain di dalam perjanjian tersebut.&nbsp;</p>
    <p>Setiap perubahan terhadap Syarat dan Ketentuan Umum ini akan diinformasikan melalui www.tri.co.id oleh karena
        itu
        anda dihimbau untuk mengakses laman ini secara berkala untuk mengetahui perubahannya (apabila ada).&nbsp;
    </p>
    <p>Syarat dan Ketentuan Umum ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Apabila terjadi perbedaan
        penafsiran terhadap kata, frase, atau kalimat dalam Bahasa Indonesia dan Bahasa Inggris di Syarat dan
        Ketentuan
        Umum ini, maka yang berlaku dan digunakan dalam menafsirkan kata, frase, atau kalimat dimaksud adalah versi
        Bahasa Indonesia.</p>

    <ol type="A">
        <li><strong> Definisi</strong></li>
        <ol type="1">
            <li>IOH adalah PT Indosat Tbk.</li>
            <li>Kadaluarsa adalah Kartu SIM Layanan Prabayar yang telah melewati Masa Tenggang sehingga tidak dapat
                digunakan oleh Pelanggan.</li>
            <li>Kartu SIM adalah kartu chip subscriber identity module yang dilengkapi dengan nomor telepon yang dapat
                digunakan untuk mengakses ataupun menikmati Layanan.</li>
            <li>Keadaan Memaksa adalah adalah setiap peristiwa yang terjadi di luar kemampuan, kendali, kekuasaan dan
                perkiraan IOH, yang mengakibatkan terhenti atau tertundanya pelaksanaan Sebagian ataupun seluruh Syarat
                dan
                Ketentuan Umum ini beserta Syarat dan Ketentuan Khusus (apabila ada) oleh IOH, antara lain: bencana
                alam,
                banjir, tsunami, pandemi, sabotase, huru hara, peperangan, peledakan, kebakaran, pemadaman listrik,
                tindakan
                pemerintah atau tindakan pihak ketiga, gangguan teknis atau alasan lainnya yang diluar kuasa IOH.&nbsp;
            </li>
            <li>Kebijakan Privasi adalah syarat dan ketentuan yang ditetapkan oleh IOH dan tercantum pada laman
                https://tri.co.id/KebijakanPrivasi mengenai penggunaan data pengguna maupun pelanggan IOH.</li>
            <li>Layanan adalah layanan telekomunikasi berupa produk dan/atau jasa yang disediakan oleh IOH kepada
                Pelanggan,
                baik berupa jasa (dalam bentuk voice, SMS maupun data), konten, fitur, media-media sosial dengan akun
                resmi
                IOH, dan produk-produk IOH yang di akses melalui Situs dan jaringan telekomunikasi yang dimiliki atau
                dioperasikan oleh IOH.</li>
            <li>Layanan Pascabayar adalah Layanan yang disediakan oleh IOH kepada Pelanggan dengan sistem pascabayar.
            </li>
            <li>Layanan Prabayar adalah Layanan yang disediakan oleh IOH kepada Pelanggan dengan sistem prabayar.</li>
            <li>Masa Aktif adalah masa aktif Kartu SIM sebagaimana ditentukan oleh IOH, yang untuk setiap dan seluruh
                kondisi, periodenya tidak akan melebihi 365 hari.</li>
            <li>Masa Tenggang adalah periode 30 hari setelah berakhirnya Masa Aktif.</li>
            <li>Pelanggan adalah setiap individu, perorangan, badan hukum, instansi dan badan usaha yang menggunakan
                Layanan.&nbsp;</li>
            <li>Situs adalah situs dan aplikasi resmi IOH yaitu www.ioh.co.id, www.tri.co.id, bima+, BimaTri, Bima
                Market,
                Aladin beserta situs-situs dan aplikasi-aplikasi turunannya.</li>
            <li>Syarat dan Ketentuan Umum adalah syarat-syarat dan ketentuan umum yang tercantum dalam laman ini, yang
                dapat
                dilengkapi dengan Syarat dan Ketentuan Khusus (apabila ada) untuk setiap produk dan layanan IOH.</li>
            <li>Syarat dan Ketentuan Khusus adalah syarat-syarat dan ketentuan khusus yang tercantum dalam laman ini
                atau
                laman lain yang berlaku khusus untuk setiap produk, layanan maupun program-program tertentu yang
                diselenggarakan sendiri oleh IOH atau dengan bekerjasama dengan pihak lain.&nbsp;</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong> Kartu SIM</strong></li>
        <ol type="1">
            <li>Kartu SIM merupakan milik IOH.</li>
            <li>Kartu SIM hanya dapat diaktifkan di Indonesia selama masa berlaku masih aktif sesuai dengan keterangan
                yang
                tertera di paket perdana Kartu SIM.</li>
            <li>Dengan membeli atau menggunakan paket perdana Kartu SIM, Pelanggan menyatakan tunduk dan terikat pada
                Syarat
                dan Ketentuan Umum beserta Syarat dan Ketentuan Khusus (apabila ada) termasuk perubahan-perubahannya
                yang
                ditetapkan oleh IOH.</li>
            <li>Pada saat akan melakukan aktivasi Kartu SIM, Pelanggan wajib mengisi data diri dengan benar, lengkap dan
                akurat. IOH berhak untuk menonaktifkan nomor-nomor IOH yang diketahui memberikan data yang tidak benar,
                salah atau palsu sesuai hukum yang berlaku.</li>
            <li>Kartu SIM memiliki Masa Aktif yang terbatas.</li>
            <li>Pelanggan bertanggung jawab atas Kartu SIM masing-masing. Semua biaya yang berkaitan dengan penggunaan
                Kartu
                SIM akan menjadi tanggung jawab Pelanggan termasuk tunggakan denda dan/atau biaya tambahan lainnya,
                serta
                pajak yang akan dibebankan ke nomor Pelanggan. Pelanggan juga bertanggung jawab untuk biaya yang
                ditimbulkan
                oleh penggunaan Kartu SIM oleh pihak lain dengan ataupun tanpa sepengetahuan Pelanggan.&nbsp;</li>
            <li>Pelanggan dapat menggunakan Kartu SIM secara terus menerus sepanjang Pelanggan mematuhi Syarat dan
                Ketentuan
                Umum ini serta Syarat dan Ketentuan Khusus (apabila ada).&nbsp;</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Registrasi, Aktivasi, Ketersediaan dan Penggunaan Layanan</strong></li>
        <ol>
            <li>Pelanggan dapat menikmati Layanan apabila telah melakukan proses registrasi Pelanggan sesuai hukum yang
                berlaku, dan proses aktivasi Layanan sesuai kebijakan IOH.</li>
            <li>Layanan disediakan melalui jaringan IOH maupun jaringan lain yang dimiliki operator lain yang
                bekerjasama
                dengan IOH di dalam maupun di luar wilayah Indonesia.&nbsp;</li>
            <li>IOH berusaha agar Layanan selalu berfungsi dan tersedia dengan baik bagi Pelanggan, namun demikian tidak
                ada
                jaminan bahwa Layanan akan terus menerus tersedia karena Layanan dapat sewaktu-waktu mengalami gangguan
                atau
                tidak berfungsi dengan baik. Dalam kondisi demikian Pelanggan tidak akan menuntut rugi apapun kepada
                IOH.
            </li>
            <li>Pelanggan hanya dapat mempergunakan Layanan untuk kepentingan pribadi Pelanggan dan tidak diperbolehkan
                untuk:</li>
            <ol>
                <li>menyebarkan, mengirim atau memposting junk mail, SMS serta pesan multimedia seperti MMS, video,
                    surat
                    berantai, pesan masal yang tidak diminta, spam atau duplikasi atau pesan yang tidak diinginkan
                    (komersial maupun non komersial) yang berisi pesan politik, pesan penipuan, menawarkan promosi
                    palsu,
                    iklan promosi, pinjaman keuangan, rekrutmen atau berbagai jenis penyalahgunaan pesan lainnya;</li>
                <li>mengirim pesan teks berupa SMS tanpa pandang bulu atau serentak ke sejumlah telepon selular di mana
                    pesan teks tersebut tidak untuk penggunaan pribadi dan dimaksudkan untuk tetapi tidak terbatas pada
                    segala bentuk pesan-pesan politik, iklan, penipuan, pemasaran atau tujuan promosi;</li>
                <li>melakukan pola panggilan telepon yang tidak biasa yang tidak konsisten dengan penggunaan normal,
                    indvidual, misalnya panggilan-panggilan regular berdurasi pendek ke beberapa nomor dalam waktu
                    singkat
                    atau penyalahgunaan panggilan lainnya;</li>
                <li>menyebarkan, mengirim, atau memposting materi atau informasi yang tidak patut, tidak sopan,
                    memfitnah,
                    melanggar, mengandung pornografi, pelecehan, mengancam, mengganggu, melanggar peraturan yang
                    berlaku,
                    menggunakan bahasa yang tidak pantas dan/atau materi atau informasi &nbsp;yang melanggar hukum;</li>
                <li>mengiklankan atau menawarkan untuk menjual atau membeli barang dan jasa untuk tujuan non-personal;
                </li>
                <li>mengumpulkan dan/atau menyebarkan informasi tentang orang lain atau alamat email mereka tanpa
                    persetujuan yang bersangkutan;</li>
                <li>mengirimkan atau meng-upload informasi atau materi yang mengandung virus, worm, Trojan horse,
                    membatalkan bots atau program lain yang berbahaya, merusak atau dekstruktif;</li>
                <li>menjual atau menyediakan Layanan kepada pihak lain atau pihak ketiga tanpa persetujuan tertulis dari
                    IOH;</li>
                <li>menggunakan Layanan dengan perangkat lain selain telepon seluler Pelanggan atau cara-cara lain yang
                    berdampak negative atau mengganggu Layanan atau jaringan IOH;</li>
                <li>menggunakan Layanan yang &nbsp;memberi pengaruh negative pada jaringan IOH atau pengalaman Pelanggan
                    menjadi &nbsp;terganggu dalam mengakses Layanan, mengganggu keamanan atau kapasitas jaringan, tidak
                    reasonable, eksessive dan tidak propossional yang mengkontribusi terjadinya kongesti, berdampak
                    &nbsp;buruk pada tingkat layanan jaringan &nbsp;atau arus data yang sah, menurunkan kinerja
                    jaringan,
                    penyebabkan gangguan pada jaringan atau pelanggan lainnya;</li>
                <li>penggunaan Layanan untuk tujuan illegal atau melanggar hukum, termasuk penggunaan yang melanggar
                    hukum
                    yang berlaku; atau</li>
                <li>penggunaan Layanan khususnya layanan data dengan berbagai cara yang mengalahkan atau menghalangi,
                    mengganggu jaringan atau sistem IOH, termasuk namun tidak terbatas pada perangat lunak berbahaya
                    atau
                    &ldquo;malware&rdquo; yang dirancang, sengaja atau tidak sengaja, untuk menyusup ke sistem jaringan
                    atau
                    computer seperti spyware, worm, Trojan Horse, rootkit, dan/atau crimeware : serangan
                    &ldquo;penolakan
                    layanan&rdquo; terhadap host jaringan atau pengguna individu, dan &ldquo;spam&rdquo; atau email
                    komersial atau email massal yang tidak diminta (kegiatan-kegiatan yang memiliki efek memfasilitasi
                    email
                    komersial yang tidak diminta atau bulk email yang tidak diminta).</li>
            </ol>
            <li>Pelanggan dilarang untuk menggunakan, atau memperbolehkan pihak lain untuk menggunakan Layanan untuk (i)
                tujuan atau keperluan yang tidak sah, (ii) hal-hal yang bertentangan dengan Syarat dan Ketentuan
                Pelanggan,
                atau (iii) bersifat melanggar hukum yang berlaku.</li>
            <li>IOH dapat sewaktu-waktu baik atas kebijakannya sendiri atau atas dasar permintaan pemerintah atau hukum
                yang
                berlaku, mengubah, memberlakukan, atau mengakhiri suatu bagian dari atau seluruh Layanan, biaya atau
                tarif
                layanan, manfaat Layanan, dan/atau setiap kebijakan sehubungan dengan Layanan.</li>
            <li>Untuk menjaga kualitas ketersediaan Layanan bagi seluruh Pelanggan, IOH memberlakukan kebijakan batas
                pemakaian wajar Layanan oleh Pelanggan (Fair Usage Policy atau FUP). &nbsp;FUP berlaku bagi seluruh
                Pelanggan yang menikmati Layanan dengan kecepatan maupun kuota tertentu sebagaimana ditetapkan oleh IOH.
                Penerapan FUP dapat berakibat pada adanya penurunan kecepatan Layanan atau pembatasan pengiriman jumlah
                SMS
                maupun data oleh Pelanggan yang menggunakan Layanan.</li>
            <li>Layanan roaming internasional dapat dinikmati di negara-negara tertentu oleh Pelanggan yang memenuhi
                persyaratan yang ditetapkan oleh IOH.</li>
            <li>Dalam menjalankan Layanan, IOH dapat sewaktu-waktu memperbaharui Layanan berdasarkan salah satu
                pertimbangan
                sebagai berikut:</li>
            <ol>
                <li>ditetapkan oleh instansi yang berwenang</li>
                <li>Layanan sudah tidak sesuai dengan perkembangan zaman dan teknologi terkini</li>
                <li>Layanan sudah tidak digunakan lagi dan Layanan akan dialihkan dengan Layanan lain yang sejenis</li>
                <li>pertimbangan-pertimbangan lain yang dianggap wajar oleh IOH.</li>
            </ol>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Pembatasan dan Pemutusan Layanan</strong></li>
        <ol type="1">
            <li>IOH berhak untuk melakukan pembatasan maupun pemblokiran Kartu SIM dan Layanan serta pemutusan Layanan
                tanpa
                terlebih dahulu memberikan suatu pemberitahuan kepada Pelanggan apabila:</li>
            <ol>
                <li>Terdapat dugaan adanya perbuatan melanggar hukum yang menggunakan Kartu SIM atau Layanan oleh
                    Pelanggan
                    ataupun pihak lain.</li>
                <li>Ada permintaan resmi dari penegak hukum atau instansi yang berwenang.</li>
                <li>Ada indikasi penyalahgunaan Kartu SIM atau Layanan dengan cara apapun termasuk pengiriman SMS dalam
                    jumlah dan isi diluar batas kewajaran, penggunaan layanan di luar batas kewajaran normal baik
                    menggunakan atau tanpa menggunakan alat bantu maupun penggunaan Layanan yang bertentangan hukum yang
                    berlaku.</li>
                <li>Pelanggan menggunakan data palsu untuk registrasi, aktivasi ataupun menggunakan Kartu SIM atau
                    Layanan.
                </li>
                <li>IOH menerima keluhan dari pihak lain terkait dengan penggunaan Layanan oleh Pelanggan, misalnya: SMS
                    spamming, penipuan dan sebagainya.</li>
                <li>Pelanggan melakukan pelanggaran terhadap Syarat dan Ketentuan Umum atau Syarat dan Ketentuan Khusus
                    (apabila ada).</li>
                <li>Pelanggan meakukan pelanggaran terhadap hukum yang berlaku dengan menggunakan Kartu SIM atau
                    Layanan.
                </li>
                <li>Bagi Pelanggan Layanan Prabayar, gagal melakukan pengisian pulsa dalam jangka waktu yang ditentukan
                    untuk produk atau program Layanan Prabayar.</li>
                <li>Bagi Pelanggan Layanan Pascabayar, gagal atau terlambat melakukan pembayaran biaya-biaya yang
                    terkait
                    dengan penggunaan Layanan pada tanggal jatuh tempo yang ditentukan oleh IOH.</li>
            </ol>
            <li>Atas tindakan pembatasan maupun pemblokiran Kartu SIM dan Layanan serta pemutusan Layanan sebagaimana
                dimaksud di atas, Pelanggan tidak dapat menuntut ganti rugi apapun kepada/dari IOH.</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Tarif dan biaya Layanan</strong></li>
        <ol type="1">
            <li>Tarif dan biaya Layanan untuk setiap produk dan layanan dapat berbeda satu sama lain sesuai kebijakan
                tarif
                yang ditetapkan oleh IOH.</li>
            <li>IOH dapat memberlakukan tarif dan biaya Layanan yang berbeda pada lokasi dan waktu tertentu sesuai
                kebijakan
                tarif yang ditetapkan oleh IOH.</li>
            <li>Tarif dan biaya Layanan dapat berubah sewaktu-waktu sesuai dengan kebijakan tarif IOH yang
                diinformasikan
                melalui Situs. Perubahan yang dimaksud dapat dilakukan oleh IOH dengan cara
                mengubah/mengakhiri/menambahkan
                bagian manapun dari Layanan atau struktur tarif/biaya Layanan setiap saat berdasarkan kebijakan IOH
                dan/atau
                apabila ditentukan dan telah disetujui oleh pemerintah.</li>
            <li>Perubahan apapun dari Layanan atau struktur tarif/biaya Layanan akan berlaku efektif ketika Pelanggan
                (i)
                melakukan perpanjangan jangka waktu paket berlangganan; atau (ii) membeli paket baru, baik paket yang
                sama
                atau berbeda, untuk menggantikan paket sebelumnya, mana yang lebih dulu terjadi.</li>
            <li>Bagi Pelanggan Layanan Pascabayar:</li>
            <ol>
                <li>IOH akan melakukan penagihan atas pemakaian Layanan kepada Pelanggan setiap bulan dan wajib
                    dibayarkan
                    oleh Pelanggan selambat-lambatnya pada tanggal jatuh tempo yang disebutkan pada tagihan.</li>
                <li>Tagihan akan termasuk tetapi tidak terbatas pada:</li>
                <ol>
                    <li>Biaya koneksi/aktivasi.</li>
                    <li>Biaya berlangganan bulanan (apabila ada).</li>
                    <li>Biaya pemakaian minimum per bulan sebagaimana tertera dalam formulir pendaftaran Pelanggan
                        Layanan
                        Pascabayar.</li>
                    <li>Biaya penggunaan Layanan.</li>
                    <li>Biaya lainnya, seperti biaya penggantian Kartu SIM, biaya penyediaan perangkat, biaya migrasi,
                        biaya
                        aktivasi kembali dan biaya lain sesuai kesepakatan antara IOH dan Pelanggan.</li>
                </ol>
                <li>Pelanggan mengakui sahnya bukti-bukti penagihan yang didasarkan pada data-data yang dicatat secara
                    elektronik oleh IOH.</li>
                <li>Pembayaran tagihan Layanan Pascabayar dapat dilakukan oleh Pelanggan ke rekning yang disebutkan
                    dalam
                    tagihan, dengan cara tunai di lokasi-lokasi yang ditentukan IOH, transfer, debit rekening atau kartu
                    kredit, dan cara pembayaran lain yang ditentukan oleh IOH di kemudian hari.&nbsp;</li>
            </ol>
            <li>Khusus bagi Pelanggan perdana IOH apa saja dengan tarif dasar SMS Rp 875/SMS</li>
            <ol>
                <li>Jika sisa pulsa utama Rp 176 &ndash; Rp 875, Pelanggan tetap dapat mengirimkan SMS dengan tarif
                    khusus
                    Rp 175/SMS.</li>
                <li>Apabila Pelanggan mengirimkan 5 SMS (5x Rp 175/SMS) maka langsung mendapatkan Extra 1000 SMS ke
                    sesama
                    IOH dan 30 SMS ke operator lain).</li>
                <li>Extra SMS dapat digunakan di hari yang sama. Sisa extra SMS yang tidak terpakai akan hangus di hari
                    berikutnya.</li>
            </ol>
            <li>Khusus bagi Pelanggan yang memiliki kondisi sebagai berikut:</li>
            <ol>
                <li>Pemakaian kuota data &gt; 200MB</li>
                <li>Dalam 90 hari berturut-turut tidak ada pemakaian sama sekali terhitung sejak nomernya aktif untuk:
                </li>
                <ol>
                    <li>melakukan sambungan telpon keluar&nbsp;</li>
                    <li>SMS keluar</li>
                    <li>akses internet</li>
                    <li>isi ulang pulsa/kuota data,</li>
                </ol>
            </ol>
        </ol>
        <p>IOH dengan sebelumnya memberikan pemberitahuan kepada Pelanggan mengenai Masa Tenggang (pemberitahuan mana
            dapat
            dilakukan oleh IOH melalui Situs, Layanan atau media lain yang ditentukan oleh IOH), akan memasukan Kartu
            SIM
            kedalam Masa Tenggang yang apabila terlewati akan otomatis mengakibatkan Kartu SIM menjadi hangus dan tidak
            dapat dipergunakan lagi oleh Pelanggan untuk menikmati Layanan.</p>
        <p>&nbsp;</p>
        <li><strong>Pembatasan Tanggung Jawab</strong></li>
        <ol type="1">
            <li>Selain sebagaimana disebutkan dalam bagian lain Syarat dan Ketentuan Umum ini, IOH tidak bertanggung
                jawab
                atas kerugian-kerugian tidak langsung yang timbul dan diderita oleh Pelanggan dan/atau pihak ketiga. IOH
                hanya berkewajiban untuk menanggung kerugian yang diderita langsung oleh Pelanggan sepanjang dapat
                dibuktikan bahwa kerugian tersebut timbul secara langsung karena semata-mata kesalahan IOH, dengan
                jumlah
                maksimum 1 (satu) bulan biaya berlangganan Layanan untuk bulan terakhir yang telah dibayarkan oleh
                Pelanggan
                kepada IOH.</li>
            <li>IOH dibebaskan dari kewajibannya melaksanakan Syarat dan Ketentuan Umum serta Syarat dan Ketentuan
                Khusus
                (apabila ada) jika terjadi Keadaan Memaksa.</li>
            <li>IOH tidak bertanggung jawab atas klaim, kewajiban, dan/atau kompensasi yang terkait dengan penggunaan
                Kartu
                SIM atau Layanan, terhadap kerusakan yang terjadi sebagai akibat dari penyalahgunaan Kartu SIM dan/atau
                Layanan oleh pihak lain yang tidak bertanggung jawab (termasuk atas isi komunikasi yang dikirimkan
                dengan
                menggunakan Layanan atau jaringan IOH), terjadinya Keadaan Memaksa, penggunaan jaringan telekomunikasi
                atau
                infrastruktur atau perangkat lain yang berkaitan dengan Layanan, untuk cedera fisik, penyakit, risiko
                kesehatan atau kerusakan lain yang terjadi kepada Pelanggan atau kepada orang lain.&nbsp;</li>
            <li>IOH tidak bertanggungjawab atas isi berita dan/atau informasi dan/atau data yang dimiliki Pelanggan
                dan/atau
                kehilangan data yang dikirim/diterima oleh Pelanggan kepada/dari pihak lain melalui Layanan. Oleh
                karenanya,
                dengan ini Pelanggan membebaskan IOH dari segala gugatan/tuntutan dari pihak manapun juga terkait dengan
                hal
                ini.</li>
            <li>Situs mungkin menyediakan link ke situs pihak lain. Link tersebut tidak dapat dianggap bahwa IOH
                menyetujui
                dan bertanggung jawab atas konten situs pihak lain tersebut. IOH tidak bertanggung jawab atas konten
                atau
                materi lainnya yang ada pada situs pihak lain tersebut.</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Pusat Kontak Layanan (Customer Care)</strong></li>
        <p>Pelanggan dapat menghubungi Pusat Kontak Layanan Pelanggan IOH untuk setiap pertanyaan, keluhan maupun
            masukan
            terkait dengan Layanan.&nbsp;<br /> Pusat Kontak Layanan Pelanggan IOH dapat diakses melalui:</p>
        <ul>
            <li>Akses 3Chat melalui aplikasi bima+</li>
            <li>Twitter: @3CareIndonesia</li>
            <li>WhatsApp: 08999800123</li>
            <li>Telegram: @TriIndonesiaCare_bot</li>
            <li>Email: 3care@three.co.id</li>
            <li>Telepon: 132 / 089644000123&nbsp;</li>
            <li>Kunjungan ke 3Store terdekat.</li>
        </ul>
        <p>&nbsp;</p>
        <li><strong>Hak Kekayaan Intelektual (HAKI)</strong></li>
        <p>Kelompok usaha IOH memiliki dan memegang hak kekayaan intelektual dari berbagai macam logo, merek, nama, hak
            cipta, gambar dan aplikasi sehubungan dengan Layanan, yang seluruhnya dilindungi oleh hukum yang berlaku.
            Penggunaan hak kekayaan intelektual milik kelompok usaha IOH tanpa persetujuan tertulis sebelumnya dari IOH
            ataupun tanpa dasar yang sah merupakan suatu pelanggaran hak kekayaan intelektual yang dapat dituntut
            berdasarkan hukum yang berlaku.<br /> Hak kekayaan intelektual atas konten pihak ketiga yang terkandung di
            dalam
            Layanan akan tetap merupakan milik dan tanggung jawab pihak ketiga tersebut.</p>
        <p>&nbsp;</p>
        <li><strong>Data Pelanggan</strong></li>
        <ol type="1">
            <li>Dengan menggunakan membeli atau menggunakan Layanan, Pelanggan mengizinkan IOH untuk memperolehan,
                mengumpulkan, mengolahan, menganalisa, menyimpan menampilkan, mengumumkan, mengirimkan, menyebarluaskan
                dan/atau membuka akses, menghapus atau memusnahkan inforasi dan data yang diberikan oleh Pelanggan
                melalui
                Layanan atau yang dikumpulkan oleh IOH dari Pelanggan, untuk tujuan-tujuan sebagai berikut:</li>
            <ol>
                <li>penyediaan Layanan kepada Pelanggan;</li>
                <li>melakukan proses transaksi ;</li>
                <li>menjaga dan meningkatkan kualitas dan pengalaman Pelanggan terhadap Layanan;</li>
                <li>mendukung kegiatan usaha IOH; atau</li>
                <li>tujuan-tujuan lain yang diizinkan maupun diwajibkan oleh hukum yang berlaku.</li>
            </ol>
            <li>Pelanggan setuju untuk sewaktu-waktu menerima penawaran atau informasi terkait dengan produk-produk atau
                program-program yang diselenggarakan oleh IOH dan/atau melalui pihak lain yang bekerjasama dengan IOH.
                Pelanggan yang tidak bersedia untuk menerima penawaran atau informasi terkait dengan produk pihak lain
                yang
                bekerjasama dengan IOH dapat menghubungi Pusat Kontak Layanan Pelanggan untuk proses lebih lanjut.</li>
            <li>Penanganan informasi dan data Pelanggan IOH juga tunduk dan terikat pada Kebijakan Privasi.&nbsp;</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Lain-lain</strong></li>
        <ol type="1">
            <li>Syarat dan Ketentuan Umum beserta Syarat Ketentuan Khusus, tunduk pada hukum Negara Republik Indonesia.
            </li>
            <li>Setiap informasi dan Syarat dan Ketentuan Khusus yang dicantumkan dalam Situs oleh IOH merupakan bagian
                dari
                Syarat dan Ketentuan Umum.</li>
            <li>Syarat dan Ketentuan Umum ini menggantikan persetujuan atau kesepakatan yang dibuat sebelumnya tentang
                ketentuan dan syarat berlangganan Layanan (apabila ada).</li>
            <li>Pelanggan mengijinkan dan memberi wewenang kepada IOH untuk menggunakan Syarat dan Ketentuan Umum,
                Syarat
                dan Ketentuan Khusus berikut setiap perubahan, tambahan ataupun pembaharuannya termasuk catatan,
                informasi
                maupun data yang berhubungan dengan Pelanggan dalam bentuk apapun yang diperoleh dari Pelanggan untuk
                keperluan dan kepentingan IOH sendiri maupun untuk kerjasama dengan mitra IOH.</li>
            <li>Apabila salah satu ketentuan dan/atau syarat-syarat dalam Syarat dan Ketentuan Umum menjadi tidak sah
                atau
                tidak dapat diberlakukan secara sah, ketentuan-ketentuan lainnya tidak akan terpengaruh.</li>
            <li>Apabila terjadi perselisihan dalam penafsiran dan/atau pelaksanaan Syarat dan Ketentuan Umum serta
                Syarat
                dan Ketentuan Khusus ini, Pelanggan dan IOH sepakat untuk terlebih dahulu menyelesaikannya secara
                musyawarah
                untuk mufakat. Apabila musyawarah mufakat tidak berhasil untuk menyelesaikan masalah dalam waktu yang
                wajar,
                Pelanggan dan IOH sepakat untuk memilih domisili hukum yang tetap di Pengadilan Negeri Jakarta Selatan.
            </li>
        </ol>
    </ol>

    <p>&nbsp;</p>
    <h1
        [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat', 'tri-bold' : platform === 'tri' }">
        Syarat dan Ketentuan
        Indosat Ooredoo Hutchison Prabayar Tri</h1>
    <p>Terima kasih atas kepercayaan anda menggunakan produk dan layanan IOH (dahulu Tri) dari PT Indosat Tbk
        (IOH).&nbsp;</p>
    <p>Laman ini berisi syarat dan ketentuan umum yang berlaku untuk semua penggunaan produk dan layanan IOH. Dengan
        menggunakan produk dan layanan IOH atau mengakses laman ini, berarti melahirkan perjanjian antara anda dan
        IOH,
        dan anda dianggap telah mempelajari, memahami dan menyatakan setuju untuk terikat pada Syarat dan Ketentuan
        Umum
        ini. Syarat dan Ketentuan Umum ini dapat dilengkapi dengan Syarat dan Ketentuan Khusus. Apabila anda tidak
        ingin
        tunduk dan terikat pada Syarat dan Ketentuan Umum ini, anda dilarang untuk menggunakan produk dan layanan
        IOH,
        serta wajib menghentikan akses ke situs ini. Anda juga diwajibkan untuk mematuhi hukum yang berlaku ketika
        membeli maupun menggunakan produk dan layanan IOH.</p>
    <p>Syarat dan Ketentuan Umum ini akan selalu dianggap otomatis tercantum dan melekat sebagai bagian yang tidak
        terpisahkan dari setiap perjanjan yang dibuat oleh IOH dengan pihak lain terkait dengan penyediaan maupun
        penggunaan produk dan layanan IOH, kecuali dinyatakan lain di dalam perjanjian tersebut.&nbsp;</p>
    <p>Setiap perubahan terhadap Syarat dan Ketentuan Umum ini akan diinformasikan melalui www.tri.co.id oleh karena
        itu
        anda dihimbau untuk mengakses laman ini secara berkala untuk mengetahui perubahannya (apabila ada).&nbsp;
    </p>
    <p>Syarat dan Ketentuan Umum ini dibuat dalam Bahasa Indonesia dan Bahasa Inggris. Apabila terjadi perbedaan
        penafsiran terhadap kata, frase, atau kalimat dalam Bahasa Indonesia dan Bahasa Inggris di Syarat dan
        Ketentuan
        Umum ini, maka yang berlaku dan digunakan dalam menafsirkan kata, frase, atau kalimat dimaksud adalah versi
        Bahasa Indonesia.</p>

    <ol type="A">
        <li><strong>Definisi</strong></li>
        <ol type="1">
            <li>IOH adalah PT Indosat Tbk.</li>
            <li>Kadaluarsa adalah Kartu SIM Layanan Prabayar yang telah melewati Masa Tenggang sehingga tidak dapat
                digunakan oleh Pelanggan.</li>
            <li>Kartu SIM adalah kartu chip subscriber identity module yang dilengkapi dengan nomor telepon yang dapat
                digunakan untuk mengakses ataupun menikmati Layanan.</li>
            <li>Keadaan Memaksa adalah adalah setiap peristiwa yang terjadi di luar kemampuan, kendali, kekuasaan dan
                perkiraan IOH, yang mengakibatkan terhenti atau tertundanya pelaksanaan Sebagian ataupun seluruh Syarat
                dan
                Ketentuan Umum ini beserta Syarat dan Ketentuan Khusus (apabila ada) oleh IOH, antara lain: bencana
                alam,
                banjir, tsunami, pandemi, sabotase, huru hara, peperangan, peledakan, kebakaran, pemadaman listrik,
                tindakan
                pemerintah atau tindakan pihak ketiga, gangguan teknis atau alasan lainnya yang diluar kuasa IOH.&nbsp;
            </li>
            <li>Kebijakan Privasi adalah syarat dan ketentuan yang ditetapkan oleh IOH dan tercantum pada laman
                https://tri.co.id/KebijakanPrivasi mengenai penggunaan data pengguna maupun pelanggan IOH.</li>
            <li>Layanan adalah layanan telekomunikasi berupa produk dan/atau jasa yang disediakan oleh IOH kepada
                Pelanggan,
                baik berupa jasa (dalam bentuk voice, SMS maupun data), konten, fitur, media-media sosial dengan akun
                resmi
                IOH, dan produk-produk IOH yang di akses melalui Situs dan jaringan telekomunikasi yang dimiliki atau
                dioperasikan oleh IOH.</li>
            <li>Layanan Pascabayar adalah Layanan yang disediakan oleh IOH kepada Pelanggan dengan sistem pascabayar.
            </li>
            <li>Layanan Prabayar adalah Layanan yang disediakan oleh IOH kepada Pelanggan dengan sistem prabayar.</li>
            <li>Masa Aktif adalah masa aktif Kartu SIM sebagaimana ditentukan oleh IOH, yang untuk setiap dan seluruh
                kondisi, periodenya tidak akan melebihi 365 hari.</li>
            <li>Masa Tenggang adalah periode 30 hari setelah berakhirnya Masa Aktif.</li>
            <li>Pelanggan adalah setiap individu, perorangan, badan hukum, instansi dan badan usaha yang menggunakan
                Layanan.&nbsp;</li>
            <li>Situs adalah situs dan aplikasi resmi IOH yaitu www.ioh.co.id, www.tri.co.id, bima+, BimaTri, Bima
                Market,
                Aladin beserta situs-situs dan aplikasi-aplikasi turunannya.</li>
            <li>Syarat dan Ketentuan Umum adalah syarat-syarat dan ketentuan umum yang tercantum dalam laman ini, yang
                dapat
                dilengkapi dengan Syarat dan Ketentuan Khusus (apabila ada) untuk setiap produk dan layanan IOH.</li>
            <li>Syarat dan Ketentuan Khusus adalah syarat-syarat dan ketentuan khusus yang tercantum dalam laman ini
                atau
                laman lain yang berlaku khusus untuk setiap produk, layanan maupun program-program tertentu yang
                diselenggarakan sendiri oleh IOH atau dengan bekerjasama dengan pihak lain.&nbsp;</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Kartu SIM</strong></li>
        <ol type="1">
            <li>Kartu SIM merupakan milik IOH.</li>
            <li>Kartu SIM hanya dapat diaktifkan di Indonesia selama masa berlaku masih aktif sesuai dengan keterangan
                yang
                tertera di paket perdana Kartu SIM.</li>
            <li>Dengan membeli atau menggunakan paket perdana Kartu SIM, Pelanggan menyatakan tunduk dan terikat pada
                Syarat
                dan Ketentuan Umum beserta Syarat dan Ketentuan Khusus (apabila ada) termasuk perubahan-perubahannya
                yang
                ditetapkan oleh IOH.</li>
            <li>Pada saat akan melakukan aktivasi Kartu SIM, Pelanggan wajib mengisi data diri dengan benar, lengkap dan
                akurat. IOH berhak untuk menonaktifkan nomor-nomor IOH yang diketahui memberikan data yang tidak benar,
                salah atau palsu sesuai hukum yang berlaku.</li>
            <li>Kartu SIM memiliki Masa Aktif yang terbatas.</li>
            <li>Pelanggan bertanggung jawab atas Kartu SIM masing-masing. Semua biaya yang berkaitan dengan penggunaan
                Kartu
                SIM akan menjadi tanggung jawab Pelanggan termasuk tunggakan denda dan/atau biaya tambahan lainnya,
                serta
                pajak yang akan dibebankan ke nomor Pelanggan. Pelanggan juga bertanggung jawab untuk biaya yang
                ditimbulkan
                oleh penggunaan Kartu SIM oleh pihak lain dengan ataupun tanpa sepengetahuan Pelanggan.&nbsp;</li>
            <li>Pelanggan dapat menggunakan Kartu SIM secara terus menerus sepanjang Pelanggan mematuhi Syarat dan
                Ketentuan
                Umum ini serta Syarat dan Ketentuan Khusus (apabila ada).&nbsp;</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Registrasi, Aktivasi, Ketersediaan dan Penggunaan Layanan</strong></li>
        <ol type="1">
            <li>Pelanggan dapat menikmati Layanan apabila telah melakukan proses registrasi Pelanggan sesuai hukum yang
                berlaku, dan proses aktivasi Layanan sesuai kebijakan IOH.</li>
            <li>Layanan disediakan melalui jaringan IOH maupun jaringan lain yang dimiliki operator lain yang
                bekerjasama
                dengan IOH di dalam maupun di luar wilayah Indonesia.&nbsp;</li>
            <li>IOH berusaha agar Layanan selalu berfungsi dan tersedia dengan baik bagi Pelanggan, namun demikian tidak
                ada
                jaminan bahwa Layanan akan terus menerus tersedia karena Layanan dapat sewaktu-waktu mengalami gangguan
                atau
                tidak berfungsi dengan baik. Dalam kondisi demikian Pelanggan tidak akan menuntut rugi apapun kepada
                IOH.
            </li>
            <li>Pelanggan hanya dapat mempergunakan Layanan untuk kepentingan pribadi Pelanggan dan tidak diperbolehkan
                untuk:</li>
            <ol>
                <li>menyebarkan, mengirim atau memposting junk mail, SMS serta pesan multimedia seperti MMS, video,
                    surat
                    berantai, pesan masal yang tidak diminta, spam atau duplikasi atau pesan yang tidak diinginkan
                    (komersial maupun non komersial) yang berisi pesan politik, pesan penipuan, menawarkan promosi
                    palsu,
                    iklan promosi, pinjaman keuangan, rekrutmen atau berbagai jenis penyalahgunaan pesan lainnya;</li>
                <li>mengirim pesan teks berupa SMS tanpa pandang bulu atau serentak ke sejumlah telepon selular di mana
                    pesan teks tersebut tidak untuk penggunaan pribadi dan dimaksudkan untuk tetapi tidak terbatas pada
                    segala bentuk pesan-pesan politik, iklan, penipuan, pemasaran atau tujuan promosi;</li>
                <li>melakukan pola panggilan telepon yang tidak biasa yang tidak konsisten dengan penggunaan normal,
                    indvidual, misalnya panggilan-panggilan regular berdurasi pendek ke beberapa nomor dalam waktu
                    singkat
                    atau penyalahgunaan panggilan lainnya;</li>
                <li>menyebarkan, mengirim, atau memposting materi atau informasi yang tidak patut, tidak sopan,
                    memfitnah,
                    melanggar, mengandung pornografi, pelecehan, mengancam, mengganggu, melanggar peraturan yang
                    berlaku,
                    menggunakan bahasa yang tidak pantas dan/atau materi atau informasi &nbsp;yang melanggar hukum;</li>
                <li>mengiklankan atau menawarkan untuk menjual atau membeli barang dan jasa untuk tujuan non-personal;
                </li>
                <li>mengumpulkan dan/atau menyebarkan informasi tentang orang lain atau alamat email mereka tanpa
                    persetujuan yang bersangkutan;</li>
                <li>mengirimkan atau meng-upload informasi atau materi yang mengandung virus, worm, Trojan horse,
                    membatalkan bots atau program lain yang berbahaya, merusak atau dekstruktif;</li>
                <li>menjual atau menyediakan Layanan kepada pihak lain atau pihak ketiga tanpa persetujuan tertulis dari
                    IOH;</li>
                <li>menggunakan Layanan dengan perangkat lain selain telepon seluler Pelanggan atau cara-cara lain yang
                    berdampak negative atau mengganggu Layanan atau jaringan IOH;</li>
                <li>menggunakan Layanan yang &nbsp;memberi pengaruh negative pada jaringan IOH atau pengalaman Pelanggan
                    menjadi &nbsp;terganggu dalam mengakses Layanan, mengganggu keamanan atau kapasitas jaringan, tidak
                    reasonable, eksessive dan tidak propossional yang mengkontribusi terjadinya kongesti, berdampak
                    &nbsp;buruk pada tingkat layanan jaringan &nbsp;atau arus data yang sah, menurunkan kinerja
                    jaringan,
                    penyebabkan gangguan pada jaringan atau pelanggan lainnya;</li>
                <li>penggunaan Layanan untuk tujuan illegal atau melanggar hukum, termasuk penggunaan yang melanggar
                    hukum
                    yang berlaku; atau</li>
                <li>penggunaan Layanan khususnya layanan data dengan berbagai cara yang mengalahkan atau menghalangi,
                    mengganggu jaringan atau sistem IOH, termasuk namun tidak terbatas pada perangat lunak berbahaya
                    atau
                    &ldquo;malware&rdquo; yang dirancang, sengaja atau tidak sengaja, untuk menyusup ke sistem jaringan
                    atau
                    computer seperti spyware, worm, Trojan Horse, rootkit, dan/atau crimeware : serangan
                    &ldquo;penolakan
                    layanan&rdquo; terhadap host jaringan atau pengguna individu, dan &ldquo;spam&rdquo; atau email
                    komersial atau email massal yang tidak diminta (kegiatan-kegiatan yang memiliki efek memfasilitasi
                    email
                    komersial yang tidak diminta atau bulk email yang tidak diminta).</li>
            </ol>
            <li>Pelanggan dilarang untuk menggunakan, atau memperbolehkan pihak lain untuk menggunakan Layanan untuk (i)
                tujuan atau keperluan yang tidak sah, (ii) hal-hal yang bertentangan dengan Syarat dan Ketentuan
                Pelanggan,
                atau (iii) bersifat melanggar hukum yang berlaku.</li>
            <li>IOH dapat sewaktu-waktu baik atas kebijakannya sendiri atau atas dasar permintaan pemerintah atau hukum
                yang
                berlaku, mengubah, memberlakukan, atau mengakhiri suatu bagian dari atau seluruh Layanan, biaya atau
                tarif
                layanan, manfaat Layanan, dan/atau setiap kebijakan sehubungan dengan Layanan.</li>
            <li>Untuk menjaga kualitas ketersediaan Layanan bagi seluruh Pelanggan, IOH memberlakukan kebijakan batas
                pemakaian wajar Layanan oleh Pelanggan (Fair Usage Policy atau FUP). &nbsp;FUP berlaku bagi seluruh
                Pelanggan yang menikmati Layanan dengan kecepatan maupun kuota tertentu sebagaimana ditetapkan oleh IOH.
                Penerapan FUP dapat berakibat pada adanya penurunan kecepatan Layanan atau pembatasan pengiriman jumlah
                SMS
                maupun data oleh Pelanggan yang menggunakan Layanan.</li>
            <li>Layanan roaming internasional dapat dinikmati di negara-negara tertentu oleh Pelanggan yang memenuhi
                persyaratan yang ditetapkan oleh IOH.</li>
            <li>Dalam menjalankan Layanan, IOH dapat sewaktu-waktu memperbaharui Layanan berdasarkan salah satu
                pertimbangan
                sebagai berikut:</li>
            <ol>
                <li>ditetapkan oleh instansi yang berwenang</li>
                <li>Layanan sudah tidak sesuai dengan perkembangan zaman dan teknologi terkini</li>
                <li>Layanan sudah tidak digunakan lagi dan Layanan akan dialihkan dengan Layanan lain yang sejenis</li>
                <li>pertimbangan-pertimbangan lain yang dianggap wajar oleh IOH.</li>
            </ol>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Pembatasan dan Pemutusan Layanan</strong></li>
        <ol type="1">
            <li>IOH berhak untuk melakukan pembatasan maupun pemblokiran Kartu SIM dan Layanan serta pemutusan Layanan
                tanpa
                terlebih dahulu memberikan suatu pemberitahuan kepada Pelanggan apabila:</li>
            <ol>
                <li>Terdapat dugaan adanya perbuatan melanggar hukum yang menggunakan Kartu SIM atau Layanan oleh
                    Pelanggan
                    ataupun pihak lain.</li>
                <li>Ada permintaan resmi dari penegak hukum atau instansi yang berwenang.</li>
                <li>Ada indikasi penyalahgunaan Kartu SIM atau Layanan dengan cara apapun termasuk pengiriman SMS dalam
                    jumlah dan isi diluar batas kewajaran, penggunaan layanan di luar batas kewajaran normal baik
                    menggunakan atau tanpa menggunakan alat bantu maupun penggunaan Layanan yang bertentangan hukum yang
                    berlaku.</li>
                <li>Pelanggan menggunakan data palsu untuk registrasi, aktivasi ataupun menggunakan Kartu SIM atau
                    Layanan.
                </li>
                <li>IOH menerima keluhan dari pihak lain terkait dengan penggunaan Layanan oleh Pelanggan, misalnya: SMS
                    spamming, penipuan dan sebagainya.</li>
                <li>Pelanggan melakukan pelanggaran terhadap Syarat dan Ketentuan Umum atau Syarat dan Ketentuan Khusus
                    (apabila ada).</li>
                <li>Pelanggan meakukan pelanggaran terhadap hukum yang berlaku dengan menggunakan Kartu SIM atau
                    Layanan.
                </li>
                <li>Bagi Pelanggan Layanan Prabayar, gagal melakukan pengisian pulsa dalam jangka waktu yang ditentukan
                    untuk produk atau program Layanan Prabayar.</li>
                <li>Bagi Pelanggan Layanan Pascabayar, gagal atau terlambat melakukan pembayaran biaya-biaya yang
                    terkait
                    dengan penggunaan Layanan pada tanggal jatuh tempo yang ditentukan oleh IOH.</li>
            </ol>
            <li>Atas tindakan pembatasan maupun pemblokiran Kartu SIM dan Layanan serta pemutusan Layanan sebagaimana
                dimaksud di atas, Pelanggan tidak dapat menuntut ganti rugi apapun kepada/dari IOH.</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Tarif dan biaya Layanan</strong></li>
        <ol type="1">
            <li>Tarif dan biaya Layanan untuk setiap produk dan layanan dapat berbeda satu sama lain sesuai kebijakan
                tarif
                yang ditetapkan oleh IOH.</li>
            <li>IOH dapat memberlakukan tarif dan biaya Layanan yang berbeda pada lokasi dan waktu tertentu sesuai
                kebijakan
                tarif yang ditetapkan oleh IOH.</li>
            <li>Tarif dan biaya Layanan dapat berubah sewaktu-waktu sesuai dengan kebijakan tarif IOH yang
                diinformasikan
                melalui Situs. Perubahan yang dimaksud dapat dilakukan oleh IOH dengan cara
                mengubah/mengakhiri/menambahkan
                bagian manapun dari Layanan atau struktur tarif/biaya Layanan setiap saat berdasarkan kebijakan IOH
                dan/atau
                apabila ditentukan dan telah disetujui oleh pemerintah.</li>
            <li>Perubahan apapun dari Layanan atau struktur tarif/biaya Layanan akan berlaku efektif ketika Pelanggan
                (i)
                melakukan perpanjangan jangka waktu paket berlangganan; atau (ii) membeli paket baru, baik paket yang
                sama
                atau berbeda, untuk menggantikan paket sebelumnya, mana yang lebih dulu terjadi.</li>
            <li>Bagi Pelanggan Layanan Pascabayar:</li>
            <ol>
                <li>IOH akan melakukan penagihan atas pemakaian Layanan kepada Pelanggan setiap bulan dan wajib
                    dibayarkan
                    oleh Pelanggan selambat-lambatnya pada tanggal jatuh tempo yang disebutkan pada tagihan.</li>
                <li>Tagihan akan termasuk tetapi tidak terbatas pada:</li>
                <ol>
                    <li>Biaya koneksi/aktivasi.</li>
                    <li>Biaya berlangganan bulanan (apabila ada).</li>
                    <li>Biaya pemakaian minimum per bulan sebagaimana tertera dalam formulir pendaftaran Pelanggan
                        Layanan
                        Pascabayar.</li>
                    <li>Biaya penggunaan Layanan.</li>
                    <li>Biaya lainnya, seperti biaya penggantian Kartu SIM, biaya penyediaan perangkat, biaya migrasi,
                        biaya
                        aktivasi kembali dan biaya lain sesuai kesepakatan antara IOH dan Pelanggan.</li>
                </ol>
                <li>Pelanggan mengakui sahnya bukti-bukti penagihan yang didasarkan pada data-data yang dicatat secara
                    elektronik oleh IOH.</li>
                <li>Pembayaran tagihan Layanan Pascabayar dapat dilakukan oleh Pelanggan ke rekning yang disebutkan
                    dalam
                    tagihan, dengan cara tunai di lokasi-lokasi yang ditentukan IOH, transfer, debit rekening atau kartu
                    kredit, dan cara pembayaran lain yang ditentukan oleh IOH di kemudian hari.&nbsp;</li>
            </ol>
            <li>Khusus bagi Pelanggan perdana IOH apa saja dengan tarif dasar SMS Rp 875/SMS</li>
            <ol>
                <li>Jika sisa pulsa utama Rp 176 &ndash; Rp 875, Pelanggan tetap dapat mengirimkan SMS dengan tarif
                    khusus
                    Rp 175/SMS.</li>
                <li>Apabila Pelanggan mengirimkan 5 SMS (5x Rp 175/SMS) maka langsung mendapatkan Extra 1000 SMS ke
                    sesama
                    IOH dan 30 SMS ke operator lain).</li>
                <li>Extra SMS dapat digunakan di hari yang sama. Sisa extra SMS yang tidak terpakai akan hangus di hari
                    berikutnya.</li>
            </ol>
            <li>Khusus bagi Pelanggan yang memiliki kondisi sebagai berikut:</li>
            <ol>
                <li>Pemakaian kuota data &gt; 200MB</li>
                <li>Dalam 90 hari berturut-turut tidak ada pemakaian sama sekali terhitung sejak nomernya aktif untuk:
                </li>
                <ol type="i">
                    <li>melakukan sambungan telpon keluar&nbsp;</li>
                    <li>SMS keluar</li>
                    <li>akses internet</li>
                    <li>isi ulang pulsa/kuota data,</li>
                </ol>
            </ol>
            <p>IOH dengan sebelumnya memberikan pemberitahuan kepada Pelanggan mengenai Masa Tenggang (pemberitahuan
                mana
                dapat
                dilakukan oleh IOH melalui Situs, Layanan atau media lain yang ditentukan oleh IOH), akan memasukan
                Kartu
                SIM
                kedalam Masa Tenggang yang apabila terlewati akan otomatis mengakibatkan Kartu SIM menjadi hangus dan
                tidak
                dapat dipergunakan lagi oleh Pelanggan untuk menikmati Layanan.</p>
            <p>&nbsp;</p>
        </ol>
        <li><strong>Pembatasan Tanggung Jawab</strong></li>
        <ol type="1">
            <li>Selain sebagaimana disebutkan dalam bagian lain Syarat dan Ketentuan Umum ini, IOH tidak bertanggung
                jawab
                atas kerugian-kerugian tidak langsung yang timbul dan diderita oleh Pelanggan dan/atau pihak ketiga. IOH
                hanya berkewajiban untuk menanggung kerugian yang diderita langsung oleh Pelanggan sepanjang dapat
                dibuktikan bahwa kerugian tersebut timbul secara langsung karena semata-mata kesalahan IOH, dengan
                jumlah
                maksimum 1 (satu) bulan biaya berlangganan Layanan untuk bulan terakhir yang telah dibayarkan oleh
                Pelanggan
                kepada IOH.</li>
            <li>IOH dibebaskan dari kewajibannya melaksanakan Syarat dan Ketentuan Umum serta Syarat dan Ketentuan
                Khusus
                (apabila ada) jika terjadi Keadaan Memaksa.</li>
            <li>IOH tidak bertanggung jawab atas klaim, kewajiban, dan/atau kompensasi yang terkait dengan penggunaan
                Kartu
                SIM atau Layanan, terhadap kerusakan yang terjadi sebagai akibat dari penyalahgunaan Kartu SIM dan/atau
                Layanan oleh pihak lain yang tidak bertanggung jawab (termasuk atas isi komunikasi yang dikirimkan
                dengan
                menggunakan Layanan atau jaringan IOH), terjadinya Keadaan Memaksa, penggunaan jaringan telekomunikasi
                atau
                infrastruktur atau perangkat lain yang berkaitan dengan Layanan, untuk cedera fisik, penyakit, risiko
                kesehatan atau kerusakan lain yang terjadi kepada Pelanggan atau kepada orang lain.&nbsp;</li>
            <li>IOH tidak bertanggungjawab atas isi berita dan/atau informasi dan/atau data yang dimiliki Pelanggan
                dan/atau
                kehilangan data yang dikirim/diterima oleh Pelanggan kepada/dari pihak lain melalui Layanan. Oleh
                karenanya,
                dengan ini Pelanggan membebaskan IOH dari segala gugatan/tuntutan dari pihak manapun juga terkait dengan
                hal
                ini.</li>
            <li>Situs mungkin menyediakan link ke situs pihak lain. Link tersebut tidak dapat dianggap bahwa IOH
                menyetujui
                dan bertanggung jawab atas konten situs pihak lain tersebut. IOH tidak bertanggung jawab atas konten
                atau
                materi lainnya yang ada pada situs pihak lain tersebut.</li>
        </ol>
        <li><strong>Pusat Kontak Layanan (Customer Care)</strong></li>
        <p>Pelanggan dapat menghubungi Pusat Kontak Layanan Pelanggan IOH untuk setiap pertanyaan, keluhan maupun
            masukan
            terkait dengan Layanan.&nbsp;<br /> Pusat Kontak Layanan Pelanggan IOH dapat diakses melalui:</p>
        <ul>
            <li>Akses 3Chat melalui aplikasi bima+</li>
            <li>Twitter: @3CareIndonesia</li>
            <li>WhatsApp: 08999800123</li>
            <li>Telegram: @TriIndonesiaCare_bot</li>
            <li>Email: 3care@three.co.id</li>
            <li>Telepon: 132 / 089644000123&nbsp;</li>
            <li>Kunjungan ke 3Store terdekat.</li>
        </ul>
        <p>&nbsp;</p>
        <li><strong>Hak Kekayaan Intelektual (HAKI)</strong></li>
        <p>Kelompok usaha IOH memiliki dan memegang hak kekayaan intelektual dari berbagai macam logo, merek, nama, hak
            cipta, gambar dan aplikasi sehubungan dengan Layanan, yang seluruhnya dilindungi oleh hukum yang berlaku.
            Penggunaan hak kekayaan intelektual milik kelompok usaha IOH tanpa persetujuan tertulis sebelumnya dari IOH
            ataupun tanpa dasar yang sah merupakan suatu pelanggaran hak kekayaan intelektual yang dapat dituntut
            berdasarkan hukum yang berlaku.<br /> Hak kekayaan intelektual atas konten pihak ketiga yang terkandung di
            dalam
            Layanan akan tetap merupakan milik dan tanggung jawab pihak ketiga tersebut.</p>
        <p>&nbsp;</p>
        <li><strong>Data Pelanggan</strong></li>
        <ol type="1">
            <li>Dengan menggunakan membeli atau menggunakan Layanan, Pelanggan mengizinkan IOH untuk memperolehan,
                mengumpulkan, mengolahan, menganalisa, menyimpan menampilkan, mengumumkan, mengirimkan, menyebarluaskan
                dan/atau membuka akses, menghapus atau memusnahkan inforasi dan data yang diberikan oleh Pelanggan
                melalui
                Layanan atau yang dikumpulkan oleh IOH dari Pelanggan, untuk tujuan-tujuan sebagai berikut:</li>
            <ol type="a">
                <li>penyediaan Layanan kepada Pelanggan;</li>
                <li>melakukan proses transaksi ;</li>
                <li>menjaga dan meningkatkan kualitas dan pengalaman Pelanggan terhadap Layanan;</li>
                <li>mendukung kegiatan usaha IOH; atau</li>
                <li>tujuan-tujuan lain yang diizinkan maupun diwajibkan oleh hukum yang berlaku.</li>
            </ol>
            <li>Pelanggan setuju untuk sewaktu-waktu menerima penawaran atau informasi terkait dengan produk-produk atau
                program-program yang diselenggarakan oleh IOH dan/atau melalui pihak lain yang bekerjasama dengan IOH.
                Pelanggan yang tidak bersedia untuk menerima penawaran atau informasi terkait dengan produk pihak lain
                yang
                bekerjasama dengan IOH dapat menghubungi Pusat Kontak Layanan Pelanggan untuk proses lebih lanjut.</li>
            <li>Penanganan informasi dan data Pelanggan IOH juga tunduk dan terikat pada Kebijakan Privasi.&nbsp;</li>
        </ol>
        <p>&nbsp;</p>
        <li><strong>Lain-lain</strong></li>
        <ol type="1">
            <li>Syarat dan Ketentuan Umum beserta Syarat Ketentuan Khusus, tunduk pada hukum Negara Republik Indonesia.
            </li>
            <li>Setiap informasi dan Syarat dan Ketentuan Khusus yang dicantumkan dalam Situs oleh IOH merupakan bagian
                dari
                Syarat dan Ketentuan Umum.</li>
            <li>Syarat dan Ketentuan Umum ini menggantikan persetujuan atau kesepakatan yang dibuat sebelumnya tentang
                ketentuan dan syarat berlangganan Layanan (apabila ada).</li>
            <li>Pelanggan mengijinkan dan memberi wewenang kepada IOH untuk menggunakan Syarat dan Ketentuan Umum,
                Syarat
                dan Ketentuan Khusus berikut setiap perubahan, tambahan ataupun pembaharuannya termasuk catatan,
                informasi
                maupun data yang berhubungan dengan Pelanggan dalam bentuk apapun yang diperoleh dari Pelanggan untuk
                keperluan dan kepentingan IOH sendiri maupun untuk kerjasama dengan mitra IOH.</li>
            <li>Apabila salah satu ketentuan dan/atau syarat-syarat dalam Syarat dan Ketentuan Umum menjadi tidak sah
                atau
                tidak dapat diberlakukan secara sah, ketentuan-ketentuan lainnya tidak akan terpengaruh.</li>
            <li>Apabila terjadi perselisihan dalam penafsiran dan/atau pelaksanaan Syarat dan Ketentuan Umum serta
                Syarat
                dan Ketentuan Khusus ini, Pelanggan dan IOH sepakat untuk terlebih dahulu menyelesaikannya secara
                musyawarah
                untuk mufakat. Apabila musyawarah mufakat tidak berhasil untuk menyelesaikan masalah dalam waktu yang
                wajar,
                Pelanggan dan IOH sepakat untuk memilih domisili hukum yang tetap di Pengadilan Negeri Jakarta Selatan.
            </li>
        </ol>
    </ol>
    <h1 [ngClass]="{ 'im3-bold' : platform === 'im3', 'indosat-bold' : platform === 'indosat' || platform === 'tri' }">
        Pemasaran
        Terpersonalisasi atas Produk dan Layanan oleh IOH</h1>
    <ul>
        <li>Untuk dapat menggunakan data pribadi pelanggan IOH terkait lokasi fisik perangkat pelanggan IOH yang
            dikombinasikan dengan informasi tentang iklan apa yang pelanggan IOH lihat dan kebiasaan penggunaan
            layanan
            dan/ atau produk IOH. Data ini akan dibagikan kepada pihak ketiga untuk penyediaan konten yang telah
            dipersonalisasi dan untuk mempelajari efektivitas kampanye iklan pihak ketiga yang sesuai dengan profil
            pelanggan yang dituju.</li>
        <li>Untuk dapat menggunakan data pribadi pelanggan IOH terkait kebiasaan dalam penggunaan dan pembelian
            produk
            dan/ atau layanan IOH, kecenderungan untuk mengganti nomor, serta lokasi. Data ini akan dibagikan kepada
            pihak ketiga untuk melakukan proses Analisa lebih lanjut. Analisa mencakup, penilaian risiko kredit dan
            penyediaan layanan telekomunikasi tambahan. Hal ini termasuk untuk melibatkan kolaborasi dengan pihak
            ketiga
            di sektor layanan keuangan dan lainnya.</li>
        <li>Untuk dapat menggunakan data pribadi pelanggan IOH terkait kebiasaan dalam penggunaan produk dan/ atau
            layanan IOH untuk memahami dan melakukan ucakategorisasi pelanggan. Hasil pemrosesan ini akan membuat
            segmentasi pada profil pelanggan yang dibagikan kepada pihak ketiga.</li>
        <li>Untuk memanfaatkan data pribadi pelanggan IOH terkait kebiasaan mereka dalam menggunakan produk dan/atau
            layanan IOH untuk analisis lebih lanjut untuk tujuan pihak ketiga. Selain itu, untuk menjalankan proses
            pemasaran yang lebih sejalan dengan preferensi pelanggan IOH. Ini termasuk berkolaborasi dengan pihak
            ketiga
            untuk memberikan penawaran produk dan layanan yang dimiliki oleh pihak ketiga yang lebih sejalan dengan
            preferensi Anda, sebagaimana yang diakui oleh IOH.</li>
    </ul> -->
</div>